export const my_language_data = {
  Login: "လော့ဂ်အင်",
  Loading: "ဖွင့်နေသည်",
  LoginWithUsernameandPassword: "သင့်အသုံးပြုသူအမည်နှင့် စကားဝှက်ဖြင့် ဝင်ပါ",
  UserID: "အသုံးပြုသူအိုင်ဒီ",
  Password: "စကားဝှက်",
  EnterUserName: "အသုံးပြုသူအမည်ထည့်ပါ",
  EnterPassword: "စကားဝှက်ထည့်ပါ",
  EnterPasswordValid: "စကားဝှက်သည် ၈ မှ ၁၆ လုံးကြား ဖြစ်ရပါမည်။",
  EnterPasswordPolicy:
    "စကားဝှက်သည် ၈-၁၆ လုံးကြားရှိရပြီး အကြိမ်ကြိမ် စာလုံး၊ နံပါတ်၊ အထူးသင်္ကေတပါရှိပြီး အာကာသများပါမလာရပါ။",
  ForgotPassword: "စကားဝှက် မေ့နေပါသလား",
  UsernameisRequired: "အသုံးပြုသူအမည် လိုအပ်ပါသည်",
  PasswordisRequired: "စကားဝှက် လိုအပ်ပါသည်",
  MobileNoisRequired: "မိုဘိုင်းနံပါတ် လိုအပ်ပါသည်",
  MobileNoisValid: "မိုဘိုင်းနံပါတ် မှန်ကန်စွာ ထည့်ပါ",
  UserNm: "အသုံးပြုသူအမည်",
  UsernamenandPasswordisRequired: "အသုံးပြုသူအမည်နှင့် စကားဝှက် လိုအပ်ပါသည်",
  ThisFieldisrequired: "ဤကွက်လပ် လိုအပ်ပါသည်",
  Next: "နောက်တစ်ခု",
  backtologin: "လော့ဂ်အင်သို့ ပြန်သွားရန်",
  Save: "သိမ်းဆည်းပါ",
  Yes: "ဟုတ်ကဲ့",
  No: "မဟုတ်ပါ",
  Nodatafound: "ဒေတာမတွေ့ရှိပါ",
  Confirmation: "အတည်ပြုချက်",
  Filter: "စစ်ထုတ်ပါ",
  Apply: "လျှောက်ထားပါ",
  Clear: "ရှင်းလင်းပါ",
  FailedToAddFollowingFilesForUpload: "အောက်ပါဖိုင်များ တင်ရန် မအောင်မြင်ပါ",
  FileUpload: "ဖိုင် တင်ပါ",
  FileViewer: "ဖိုင် ကြည့်ရှုသူ",
  File: "ဖိုင်",
  Type: "အမျိုးအစား",
  Size: "အရွယ်အစား",
  DoyouwanttosavethisRequest: "ဤတောင်းဆိုမှုကို သိမ်းဆည်းလိုပါသလား",
  DoyouwanttosavethisRecord: "ဤမှတ်တမ်းကို သိမ်းဆည်းလိုပါသလား",
  DoyouwanttoacceptthisRequest: "ဤတောင်းဆိုမှုကို လက်ခံလိုပါသလား",
  DoYouwanttorejectthisRequest: "ဤတောင်းဆိုမှုကို ပယ်ချလိုပါသလား",
  Doyouwanttorevertthisrequest: "ဤတောင်းဆိုမှုကို ပြန်လည် ပြုပြင်လိုပါသလား",
  Youcannotacceptyourownentry: "သင့်ကိုယ်ပိုင် ထည့်သွင်းမှုကို လက်ခံ၍ မရပါ။",
  Youcannotrejectyourownentry: "သင့်ကိုယ်ပိုင် ထည့်သွင်းမှုကို ပယ်ချ၍ မရပါ။",
  Youcannotconfirmyourownentry: "သင့်ကိုယ်ပိုင် ထည့်သွင်းမှုကို အတည်ပြု၍ မရပါ။",
  RecordUpdatedsuccessfully: "မှတ်တမ်း အောင်မြင်စွာ ပြုပြင်ပြီးပါပြီ။",
  ImageUpdatedsuccessfully: "ရုပ်ပုံ အောင်မြင်စွာ ပြုပြင်ပြီးပါပြီ။",
  Somethingwenttowrong: "တစ်စုံတစ်ခု မှားနေသည်...",
  Recordssuccessfullydeleted: "မှတ်တမ်းများ အောင်မြင်စွာ ဖျက်ပြီးပါပြီ။",
  Requesthasbeenalreadyaccepted: "ဤတောင်းဆိုမှုကို မကြာမှီ လက်ခံပြီးဖြစ်ပါသည်။",
  Requesthasbeenalreadyrejected: "ဤတောင်းဆိုမှုကို မကြာမှီ ပယ်ချပြီးဖြစ်ပါသည်။",
  Areyousuretoupdateservices: "ဝန်ဆောင်မှုများကို ပြုပြင်မည်မှာ သေချာပါသလား",
  Passwordsuccessfullyreset: "စကားဝှက် အောင်မြင်စွာ ပြန်လည်ပြင်ဆင်ပြီးပါပြီ",
  success: "အောင်မြင်သည်",
  Deleting: "ဖျက်နေသည်...",
  profile: {
    UserProfile: "အသုံးပြုသူ ပရိုဖိုင်",
    EnableTOTPAuth: "T-OTP အတည်ပြုမှု ဖွင့်ပါ",
    DisableTOTPAuth: "T-OTP အတည်ပြုမှု ပိတ်ထားသည်",
    ChangePassword: "စကားဝှက်ပြောင်းရန်",
    LoginDate: "လော့ဂ်အင်ရက်စွဲ",
    UserID: "အသုံးပြုသူ ID",
    Name: "နာမည်",
    LoginID: "လော့ဂ်အင် ID",
    LoginFlag: "လော့ဂ်အင်အခြေအနေ",
    LogoutDate: "လော့ဂ်အောက်ရက်စွဲ",
    ActivityRemarks: "လှုပ်ရှားမှုမှတ်ချက်များ",
    IPAddress: "အိုင်ပီ လိပ်စာ",
    ReleasedUser: "ဖြန့်ချိထားသော အသုံးပြုသူ",
    ReleasedDate: "ဖြန့်ချိသည့်ရက်စွဲ",
    SrNo: "စဉ်အမှတ်",
    UserLevel: "အသုံးပြုသူအဆင့်",
    MobileNumber: "မိုဘိုင်းနံပါတ်",
    EnterMobileNumber: "မိုဘိုင်းနံပါတ်ရိုက်ထည့်ပါ",
    EmailID: "အီးမေးလ် ID",
    UserGroup: "အသုံးပြုသူအဖွဲ့",
    UserSubType: "အသုံးပြုသူအမျိုးအစား",
    BranchName: "ဘဏ်ခွဲနာမည်",
    AllowedRelease: "ခွင့်ပြုထားသော ဖြန့်ချိမှု",
    required: "ဤကွက်လပ်ကို ဖြည့်ရန်လိုအပ်ပါသည်။",
    Searchin: "ရှာဖွေပါ",
    SearchinScreens: "{0} မျက်နှာပြင်များတွင် ရှာဖွေပါ",
    screens: "မျက်နှာပြင်များ",
    records: "မှတ်တမ်းများ",

    // For Change Password in Profile
    CurrentPassword: "လက်ရှိ စကားဝှက်",
    NewPassword: "စကားဝှက်အသစ်",
    ConfirmPassword: "စကားဝှက်အတည်ပြုပါ",
    Close: "ပိတ်ပါ",
    PasswordValidation: "စကားဝှက်အသစ်သည် စကားဝှက်ဟောင်းနှင့် တူမဖြစ်ရပါ",
    ChangePasswordValidation:
      "စကားဝှက်သည် အက္ခရာနှင့်ဂဏန်းများစွာပါဝင်ပြီး အထူးသင်္ကေတ၊ သေးငယ်သောအက္ခရာ၊ ကြီးသောအက္ခရာနှင့် နေရာမပါသော စကားဝှက်ဖြစ်ရပါမည်။",
    ConfirmPasswordValidation: "စကားဝှက်အသစ်နှင့် အတည်ပြုစကားဝှက် တူညီမနေပါ",
    SetNewPassword: "စကားဝှက်အသစ် သတ်မှတ်ပါ",
    EnterConfirmPassword: "အတည်ပြုစကားဝှက် ထည့်ပါ",

    // For Password in Verify
    PasswordVerify: "စကားဝှက် အတည်ပြုချက်",
    Verify: "အတည်ပြုပါ",
    ConfirmPasswordRequired: "အတည်ပြုစကားဝှက် လိုအပ်ပါသည်။",

    // For T-OTP in Profile
    EnabledAuth: "အတည်ပြုစက် ဖွင့်ထားသည်",
    TOTP_Note: "မှတ်ချက်: အတည်ပြုစက် ဖွင့်ထားသည်",
    TOTP_Note1:
      "QR ကုဒ်ကို ရှာဖွေပါ: အတည်ပြုစက် မည်သည့် app ကိုမဆို အသုံးပြုပြီး QR ကုဒ်ကို ရှာဖွေပါ။",
    TOTP_Note2:
      "နှစ်ဆင့်အတည်ပြုမှု ဖွင့်ပါ: လုံခြုံမှုအတွက် အချိန်အခြေပြု တစ်ကြိမ်သုံးစကားဝှက် (TOTP) နည်းလမ်းကို အသုံးပြုပါ။",
    TOTP_Note3:
      "အတည်ပြု app ရွေးချယ်စရာများ: မည်သည့် အတည်ပြု app ကိုမဆို အသုံးပြုနိုင်သော်လည်း Google Authenticator ကို အကြံပြုသည်။",
    TOTP_Note4:
      "QR ကုဒ် ရှာဖွေခြင်း ညွှန်ကြားချက်: အသုံးပြုသူအား သူတို့ရွေးချယ်ထားသော app တွင် QR ကုဒ်ကို ရှာဖွေရန် ညွှန်ကြားပါ။",
    TOTP_Note5:
      "OTP အတည်ပြုပါ: ရှာဖွေပြီးနောက်၊ အသုံးပြုသူသည် app မှ ထုတ်ပေးသော တစ်ကြိမ်သုံးစကားဝှက် (OTP) ကို အတည်ပြုရမည်။",
    EnterOTP: "OTP ရိုက်ထည့်ပါ",
    VerifyOTP: "OTP အတည်ပြုပါ",
  },

  // For OTP Verify
  otp: {
    OTPAuthentication: "OTP အတည်ပြုခြင်း",
    PleaseEnterOTP: "OTP ရိုက်ထည့်ပါ",
    Back: "နောက်သို့",
    Verify: "အတည်ပြုပါ",
    ResendOTP: "OTP ပြန်ပို့ပါ",
    EnterOTPDigit: "၆ လုံးပါသော OTP နံပါတ်ကို ရိုက်ထည့်ပါ",
    ResendOTPIn: "OTP ပြန်ပို့မှုအတွက်",
    Scecond: "စက္ကန့်",
  },

  // For Appbar
  appBar: {
    Branch: "ဘဏ်ခွဲ",
    LastLogin: "နောက်ဆုံး လော့ဂ်အင်",
    UserID: "အသုံးပြုသူ ID",
    Role: "တာဝန်",
    Profile: "ပရိုဖိုင်",
    Logout: "လော့ဂ်အောက်",
  },

  dashBoard: {
    LatestTransactions: "နောက်ဆုံး လုပ်ဆောင်ချက်များ",
    TrafficByDevice: "စက်ပစ္စည်းအလိုက် လုပ်ဆောင်ချက်များ",
    Success: "အောင်မြင်",
    Fail: "မအောင်မြင်",
    Today: "ယနေ့",
    LastWeek: "ပြီးခဲ့သည့် အပတ်",
    LastMonth: "ပြီးခဲ့သည့် လ",
  },

  Web: "ဝက်ဘ်",
  IOS: "အိုင်အိုအက်စ်",
  Android: "အန်းဒရွိုက်",
  Huawei: "ဟွာဝေး",

  // config:
  Custom: "စိတ်ကြိုက်",
  AllScreens: "အားလုံးသော မျက်နှာပြင်များ",
  ScreenName: "မျက်နှာပြင် နာမည်",
  UserCode: "အသုံးပြုသူ ကုဒ်",
  SystemCode: "စနစ် ကုဒ်",
  Release: "ဖြန့်ချိခြင်း",
  ServiceActiveDeactiveConfiguration: "ဝန်ဆောင်မှု ဖွင့်/ပိတ် ချိန်ညှိမှု",
  SrNo: "စဉ်အမှတ်",
  ServiceName: "ဝန်ဆောင်မှု နာမည်",
  Status: "အခြေအနေ",
  AccessChannel: "ဝင်ရောက်မှု လမ်းကြောင်း",
  CardUser: "ကဒ် အသုံးပြုသူ",
  NonCardUser: "ကဒ်မရှိသော အသုံးပြုသူ",
  ServiceStopAlertMessage: "ဝန်ဆောင်မှု ရပ်နားသတိပေးစာ",
  EnterServiceStopAlertMessage: "ဝန်ဆောင်မှု ရပ်နားသတိပေးစာ ရိုက်ထည့်ပါ",
  TotalNoofRecords: "စုစုပေါင်း မှတ်တမ်းများ",
  MessageEnglish: "စာသား (အင်္ဂလိပ်)",
  EnterMessageEnglish: "အင်္ဂလိပ်စာသား ရိုက်ထည့်ပါ",
  MessageLocal: "စာသား (ဒေသတွင်း)",
  EnterMessageLocal: "ဒေသတွင်းစာသား ရိုက်ထည့်ပါ",
  ServiceDeactivationConfigurationDetails:
    "ဝန်ဆောင်မှု ပိတ်ထားခြင်း ချိန်ညှိမှုအသေးစိတ်",
  FromDate: "စတင်ရက်*",
  ToDate: "ပြီးဆုံးရက်*",
  Active: "ဖွင့်ထား",
  Action: "လုပ်ဆောင်မှု",
  FromDateToDate: "စတင်ရက်သည် ရက်ပြီးဆုံးထက် နည်းနေရမည်။",
  ToDateFromDate: "ပြီးဆုံးရက်သည် စတင်ရက်ထက် များနေရမည်။",
  FromDateToDatePrevious: "စတင်ရက်သည် ယခင်ပြီးဆုံးရက်ထက် နောက်ကျနေရမည်။",
  Cancel: "ပယ်ဖျက်",
  Edit: "ပြင်ဆင်ရန်",
  New: "အသစ်",
  confirm: "အတည်ပြုပါ",
  Close: "ပိတ်ပါ",
  Add: "ထည့်ပါ",
  AddRow: "အတန်းအသစ်ထည့်ပါ",
  EditDetail: "အသေးစိတ် ပြင်ဆင်ပါ",
  ViewDetails: "အသေးစိတ်ကြည့်ရှုပါ",
  view: "ကြည့်ပါ",
  Delete: "ဖျက်ပါ",
  Update: "ပြန်လည်မွမ်းမံပါ",
  ViewFile: "ဖိုင်ကြည့်ရန်",
  ClearAll: "အားလုံးရှင်းရန်",
  Ok: "အိုကေ",
  PopulateBusinessDay: "စီးပွားရေးနေ့ ဖြည့်စွက်ပါ",
  DateWiseServiceDisable: "ရက်အလိုက် ဝန်ဆောင်မှု ပိတ်ပါ",
  Messages: "စာတိုများ",
  Selected: "ရွေးချယ်ထားသည်",
  // Rowsperpage: "Rows per page:",

  // Marquee Text Configuration
  MarqueeTextConfiguration: "မားကီ စာသား ဖွဲ့စည်းမှု",
  Channel: "ချန်နယ်",
  MarqueeTextEnglish: "မားကီ စာသား (အင်္ဂလိပ်)",
  MarqueeTextLocal: "မားကီ စာသား (ဒေသတွင်း)",
  EffectiveFrom: "စတင် လုပ်ဆောင်သည့် ရက်",
  EffectiveTo: "ရပ်တန့်သည့် ရက်",
  EnterEffectiveFrom: "စတင်ရက် ရိုက်ထည့်ပါ",
  EnterMarqueeTextEnglish: "မားကီ စာသား (အင်္ဂလိပ်) ရိုက်ထည့်ပါ",
  EnterMarqueeTextLocal: "မားကီ စာသား (ဒေသတွင်း) ရိုက်ထည့်ပါ",
  Mustbeavaliddate: "မှန်ကန်သည့် ရက်စွဲ ဖြစ်ရမည်",
  EffectiveToshouldbegreaterthanorequaltoEffectiveFrom:
    "ရပ်တန့်သည့်ရက်သည် စတင်ရက်ထက် ကြီးရမည် (သို့) တူညီရမည်။",
  Wouldyouliketodeletetheselectedrecord:
    "ရွေးချယ်ထားသော မှတ်တမ်းကို ဖျက်လိုပါသလား။",
  CommonMessageTemplete: "အသုံးများသော မက်ဆေ့ဂျ် ပုံစံ",
  SelectCommonMessageTemplete: "ရွေးချယ်ပါ။ အဖြစ်များသည်။ မက်ဆေ့ချ် နမူနာပုံစံ",

  //Email Account Setup

  EmailAccountSetup: "အီးမေးလ် အကောင့် ဖွဲ့စည်းမှု",
  SentByName: "ပို့သူ နာမည်",
  SMTPServerIP: "SMTP ဆာဗာ IP",
  Port: "ပို့",
  SSLEnabled: "SSL ဖွင့်ထား",
  SecurePasswordAuthentication: "စနစ်သင့် အစီအစဉ်စီ စကားဝှက် အတည်ပြုမှု",
  SecurePasswordAuthenticationEnabled: "စနစ်သင့် စကားဝှက် အတည်ပြုမှု ဖွင့်ထား",
  PassAuth: "စကားဝှက် အတည်ပြုမှု",
  UserName: "အသုံးပြုသူ နာမည်",
  SMTPServer: "SMTP ဆာဗာ",
  PortNo: "ပို့နံပါတ်",
  NoteEMailSMTP:
    "မှတ်ချက် - SMTP သုံးနိုင်ရန် သင့် အီးမေးလ်အကောင့် ဖွင့်ထားမှု သေချာပါစေ။",
  EnterSentByName: "ပို့သူ နာမည် ရိုက်ထည့်ပါ",
  EnterSMTPServer: "SMTP ဆာဗာ ရိုက်ထည့်ပါ",
  EnterPortNo: "ပို့နံပါတ် ရိုက်ထည့်ပါ",
  // EnterUserName: "Enter User Name",

  // District Master
  DistrictMaster: "ခရိုင် မဟာဌာန",
  DistrictCode: "ခရိုင် ကုဒ်",
  DistrictName: "ခရိုင် နာမည်",
  DivisionCode: "တိုင်းဒေသကြီး ကုဒ်",
  DivisionName: "တိုင်းဒေသကြီး နာမည်",
  GeoCode: "ဂျီအို ကုဒ်",
  DistCD: "ခရိုင် ကုဒ်",
  EnterDistrictCode: "ခရိုင် ကုဒ် ရိုက်ထည့်ပါ",
  EnterDistrictName: "ခရိုင် နာမည် ရိုက်ထည့်ပါ",
  EnterDivisionCode: "တိုင်းဒေသကြီး ကုဒ် ရိုက်ထည့်ပါ",
  EnterDivisionName: "တိုင်းဒေသကြီး နာမည် ရိုက်ထည့်ပါ",
  EnterGeoCode: "ဂျီအို ကုဒ် ရိုက်ထည့်ပါ",
  EnterDistCD: "ခရိုင် ကုဒ် ရိုက်ထည့်ပါ",

  // Service Wise Configuration
  ServiceWiseConfiguration: "ဝန်ဆောင်မှုအလိုက် ဖွဲ့စည်းမှု",
  Description: "ဖော်ပြချက်",
  EnterDescription: "ဖော်ပြချက် ရိုက်ထည့်ပါ",
  DailyLimit: "နေ့စဉ် ကန့်သတ်ချက်",
  MinimumAmount: "အနည်းဆုံး ပမာဏ",
  MaximumAmount: "အများဆုံး ပမာဏ",
  TransactionType: "ငွေလွှဲအမျိုးအစား",
  ConfirmStatus: "အတည်ပြု အခြေအနေ",
  ModifiedBy: "ပြုပြင်ခဲ့သူ",
  ModifiedDate: "ပြုပြင်ခဲ့သည့်ရက်",
  EnterDailyLimit: "နေ့စဉ် ကန့်သတ်ချက် ရိုက်ထည့်ပါ",
  WeeklyLimit: "အပတ်စဉ် ကန့်သတ်ချက်",
  EnterWeeklyLimit: "အပတ်စဉ် ကန့်သတ်ချက် ရိုက်ထည့်ပါ",
  MonthlyLimit: "လစဉ် ကန့်သတ်ချက်",
  EnterMonthlyLimit: "လစဉ် ကန့်သတ်ချက် ရိုက်ထည့်ပါ",
  EnterMinimumAmount: "အနည်းဆုံး ပမာဏ ရိုက်ထည့်ပါ",
  EnterMaximumAmount: "အများဆုံး ပမာဏ ရိုက်ထည့်ပါ",
  CardMinimumAmount: "ကဒ် အနည်းဆုံး ပမာဏ",
  EnterCardMinimumAmount: "ကဒ် အနည်းဆုံး ပမာဏ ရိုက်ထည့်ပါ",
  Execution: "လုပ်ဆောင်ခြင်း",
  StartTime: "စတင်အချိန်",
  EnterStartTime: "စတင်အချိန် ရိုက်ထည့်ပါ",
  EndTime: "ပြီးဆုံးအချိန်",
  EnterEndTime: "ပြီးဆုံးအချိန် ရိုက်ထည့်ပါ",
  VATPercentage: "VAT ရာခိုင်နှုန်း",
  EnterVATPercentage: "VAT ရာခိုင်နှုန်း ရိုက်ထည့်ပါ",
  MerchantID: "ကုန်သွယ်လုပ်ငန်း ID",
  EnterMerchantID: "ကုန်သွယ်လုပ်ငန်း ID ရိုက်ထည့်ပါ",
  TerminalID: "တယ်မင်နယ် အိုင်ဒီ",
  EnterTerminalID: "တယ်မင်နယ် အိုင်ဒီ ရိုက်ထည့်ပါ",
  WorkingDayStartFrom: "လုပ်ငန်းနေ့ စတင်ရန်",
  CoolDownPeriodInMinute: "စိတ်အေးချိန်ကာလ (မိနစ်အတွင်း)",
  EnterCoolDownPeriodInMinute: "စိတ်အေးချိန်ကာလ (မိနစ်အတွင်း) ရိုက်ထည့်ပါ",
  MaxDailyCount: "နေ့စဉ် အများဆုံး အရေအတွက်",
  EnterMaxDailyCount: "နေ့စဉ် အများဆုံး အရေအတွက် ရိုက်ထည့်ပါ",
  MaxMonthlyCount: "လစဉ် အများဆုံး အရေအတွက်",
  EnterMaxMonthlyCount: "လစဉ် အများဆုံး အရေအတွက် ရိုက်ထည့်ပါ",
  AmountLabel: "ပမာဏ အမှတ်အသား",
  Accept: "လက်ခံပါ",
  Revert: "ပြန်လည်ပေးပါ",
  Reject: "ငြင်းပါ",

  Charge: "ဝန်ဆောင်ခ",
  ServiceChargeTemplate: "ဝန်ဆောင်ခ နမူနာ",
  SelectServiceChargeTemplate: "ဝန်ဆောင်ခ နမူနာ ရွေးချယ်ပါ",
  ServiceChargeAccount: "ဝန်ဆောင်ခ အကောင့်",
  EnterServiceChargeAccount: "ဝန်ဆောင်ခ အကောင့် ရိုက်ထည့်ပါ",
  VATAccount: "VAT အကောင့်",
  EnterVATAccount: "VAT အကောင့် ရိုက်ထည့်ပါ",
  TransactionParticulars: "ငွေလွှဲအသေးစိတ်",
  FinacleSuspenseCreditAccount: "Finacle သည်းထိတ်ရင်ဖိုစရာ အကြွေးအကောင့်",
  EnterFinacleSuspenseCreditAccount:
    "Finacle သည်းထိတ်ရင်ဖိုစရာ အကြွေးအကောင့် ရိုက်ထည့်ပါ",
  FinacleSuspenseDebitAccount: "Finacle သည်းထိတ်ရင်ဖိုစရာ အကြွေးပေးအကောင့်",
  EnterFinacleSuspenseDebitAccount:
    "Finacle သည်းထိတ်ရင်ဖိုစရာ အကြွေးပေးအကောင့် ရိုက်ထည့်ပါ",
  AbabilSuspenseCreditAccount: "Ababil သည်းထိတ်ရင်ဖိုစရာ အကြွေးအကောင့်",
  EnterAbabilSuspenseCreditAccount:
    "Ababil သည်းထိတ်ရင်ဖိုစရာ အကြွေးအကောင့် ရိုက်ထည့်ပါ",
  AbabilSuspenseDebitAccount: "Ababil သည်းထိတ်ရင်ဖိုစရာ အကြွေးပေးအကောင့်",
  EnterAbabilSuspenseDebitAccount:
    "Ababil သည်းထိတ်ရင်ဖိုစရာ အကြွေးပေးအကောင့် ရိုက်ထည့်ပါ",
  CardSuspenseCreditAccount: "ကဒ် သည်းထိတ်ရင်ဖိုစရာ အကြွေးအကောင့်",
  EnterCardSuspenseCreditAccount:
    "ကဒ် သည်းထိတ်ရင်ဖိုစရာ အကြွေးအကောင့် ရိုက်ထည့်ပါ",
  CardSuspenseDebitAccount: "ကဒ် သည်းထိတ်ရင်ဖိုစရာ အကြွေးပေးအကောင့်",
  EnterCardSuspenseDebitAccount:
    "ကဒ် သည်းထိတ်ရင်ဖိုစရာ အကြွေးပေးအကောင့် ရိုက်ထည့်ပါ",

  FinacleTransactionParticulars: "Finacle ငွေလွှဲ အသေးစိတ်",
  FinacleTransactionParticulars2: "Finacle ငွေလွှဲ အသေးစိတ်2",
  AbabilTransactionParticulars: "Ababil ငွေလွှဲ အသေးစိတ်",
  AbabilTransactionParticulars2: "Ababil ငွေလွှဲ အသေးစိတ်2",
  TranzwareTransactionParticulars: "Tranzware ငွေလွှဲ အသေးစိတ်",
  TranzwareTransactionParticulars2: "Tranzware ငွေလွှဲ အသေးစိတ်2",
  DynamicKeyword: "Dynamic ကီးဝိုဒ်",
  TransactionParticularsfor: "ငွေလွှဲ အသေးစိတ် အတွက်",
  Finacle: "Finacle",
  Ababil: "Ababil",
  Tranzware: "Tranzware",
  AmountLabelMapping: "ပမာဏ အမှတ်အသား ချိန်ညှိမှု",
  AmountLabelReq: "ပမာဏ အမှတ်အသား*",
  AmountLabelisAlreadyenteredatLine: "ပမာဏ အမှတ်အသားသည် အတန်းတွင် ရှိပြီးသား",
  Line: " ",

  ServiceWiseConfigurationConfirmation:
    "ဝန်ဆောင်မှုအလိုက် ဖွဲ့စည်းမှု အတည်ပြုချက်",
  ServiceWiseConfirmation: "ဝန်ဆောင်မှုအလိုက် အတည်ပြုချက်",

  FinacleAsFromSource: "Finacle သို့မှတဆင့်",
  AbabilAsFromSource: "Ababil သို့မှတဆင့်",
  TranzwareAsFromSource: "Tranzware သို့မှတဆင့်",

  // Leaves Master
  LeavesMaster: "ရက်ခွင့် မဟာဌာန",
  Template: "နမူနာ",
  DeactiveDate: "ရပ်တန့်သည့် ရက်",
  EnteredBy: "ထည့်သွင်းခဲ့သူ",
  EnteredDate: "ထည့်သွင်းခဲ့သည့်ရက်",
  MachineName: "စက်အမည်",
  LastModifiedBy: "နောက်ဆုံး ပြုပြင်ခဲ့သူ",
  LastMachinename: "နောက်ဆုံး စက်အမည်",
  EnteraTemplate: "နမူနာ ရိုက်ထည့်ပါ",
  NumberofLeaves: "ရက်ခွင့် အရေအတွက်*",
  EnterNumberofLeaves: "ရက်ခွင့် အရေအတွက် ရိုက်ထည့်ပါ",
  NumberofLeavesisAlreadyenteredatLine:
    "ရက်ခွင့် အရေအတွက်သည် အတန်း {0} တွင် ရှိပြီးသား",

  //Service Charge Template

  EffectiveDate: "ထိထိရောက်ရောက် သက်ရောက်မှုရက်",
  LastEnteredBy: "နောက်ဆုံး ထည့်သွင်းခဲ့သူ",
  LastEnteredDate: "နောက်ဆုံး ထည့်သွင်းခဲ့သည့်ရက်",
  LastModifiedDate: "နောက်ဆုံး ပြုပြင်ခဲ့သည့်ရက်",
  ServiceChargeTemplateConfirmation: "ဝန်ဆောင်မှု ချိုးမှုပုံစံ အတည်ပြုချက်",
  ServiceChargeTemplateConfiguration: "ဝန်ဆောင်မှု ချိုးမှုပုံစံ ဖွဲ့စည်းမှု",
  FromAmount: "မှ ပမာဏ*",
  ToAmount: "သို့ ပမာဏ*",
  ChargeAmountReq: "ချိုးမှုပမာဏ*",
  ChargePercent: "ချိုးမှုပရစင်",
  Compute: "တွက်ချက်ပါ*",
  Computes: "တွက်ချက်ပါ",
  FromAmountshouldbelessthenToAmount: "မှ ပမာဏသည် သို့ ပမာဏထက် သေးသင့်သည်",
  FromAmountShouldBeGreaterThanPreviousToAmountOnSameDate:
    "မှ ပမာဏသည် မတိုင်မီ သို့ ပမာဏထက် ကြီးသင့်သည်",
  ToAmountshouldbegreaterthanFromAmount: "သို့ ပမာဏသည် မှ ပမာဏထက် ကြီးသင့်သည်",

  // Holiday/Business Day Configuration
  HolidayBusinessDayConfiguration: "အားလပ်ရက်/အလုပ်ရက် ဖွဲ့စည်းမှု",
  StartDate: "အစနေ့",
  EndDate: "ဆုံးနေ့",
  HolidayConfiguration: "အားလပ်ရက် ဖွဲ့စည်းမှု",
  EndDateshouldbegreaterthanStartDate: "'ဆုံးနေ့' သည် 'အစနေ့' ထက် ကြီးသင့်သည်။",
  InvaliddaterangeEndDateshouldbegreaterthanStartDate:
    "ရက်နှင့်စပ် သေချာမှု မမှန်ပါ။ 'ဆုံးနေ့' သည် 'အစနေ့' ထက် ကြီးသင့်သည်။",
  Holidays: "အားလပ်ရက်",

  BusinessDayConfig: "အလုပ်ရက် ဖွဲ့စည်းမှု",
  Note: "မှတ်ချက် :",
  Note1:
    "အလုပ်ရက်များကို ယခင်က ဖွဲ့စည်းပြီးပါပြီ။ အလုပ်ရက် ဖွဲ့စည်းမှု စကင်တွင် စစ်ဆေးနိုင်ပါသည်။",
  Note2:
    "'Business Day ဖွဲ့စည်းမှု' ကို ဖန်တီးရန် 'Populate Business Day' ခလုတ်ကိုနှိပ်ပါ။",
  BranchNameReq: "ဌာနအမည်*",
  HolidayConfig: "အားလပ်ရက် ဖွဲ့စည်းမှု",
  BusinessDayConfiguration: "အလုပ်ရက် ဖွဲ့စည်းမှု",
  Date: "ရက်",
  DayName: "ရက်နေ့အမည်",
  BusinessDayHoliday: "အလုပ်ရက်/အားလပ်ရက်",
  ThisValuealreadyexists: "ဤတန်ဖိုးသည် ယခင်တွင် ရှိပြီးသား။",
  Entervaliddate: "သင့်လျော်သော ရက်ကို ရိုက်ထည့်ပါ",
  Dateshould: "",
  Dateshouldbebetween: "ရက်သည် {0} ၏ အတွင်းရှိသင့်သည်",
  HolidayDate: "အားလပ်ရက် အချိန်*",
  HolidayDescription: "အားလပ်ရက် အကြောင်းအရာ*",
  HolidayType: "အားလပ်ရက် အမျိုးအစား*",
  BranchNameisAlreadyenteredatLine: "ဌာနအမည်သည် အတန်း {0} တွင် ရှိပြီးသား",

  // Scheme Master
  SchemeMaster: "အစီအစဉ် မဟာဌာန",
  SchemeCode: "အစီအစဉ် ကုဒ်",
  ParentType: "မိဘ အမျိုးအစား",
  EnterParentType: "မိဘ အမျိုးအစားကို ရိုက်ထည့်ပါ",
  SchemeMasterConfirmation: "အစီအစဉ် မဟာဌာန အတည်ပြုချက်",
  LeavesTemplate: "ရက်ခွင့် နမူနာ",
  Charges: "ချိုးမှူး",
  Service: "ဝန်ဆောင်မှု",
  EnterSchemeCode: "အစီအစဉ် ကုဒ်ကို ရိုက်ထည့်ပါ",
  Populate: "ပြည့်စုံပါ",

  // Operator Master
  OperatorMasterconfirmation: "လုပ်ငန်းရှင် မဟာဌာန အတည်ပြုချက်",
  OperatorMaster: "လုပ်ငန်းရှင် မဟာဌာန",
  OperatorType: "လုပ်ငန်းရှင် အမျိုးအစား",
  OperatorID: "လုပ်ငန်းရှင် ID",
  EnterOperatorID: "လုပ်ငန်းရှင် ID ကို ရိုက်ထည့်ပါ",
  OperatorName: "လုပ်ငန်းရှင် အမည်",
  EnterOperatorName: "လုပ်ငန်းရှင် အမည်ကို ရိုက်ထည့်ပါ",
  UPLOADVIEWImage: "ပုံကို တင်ပါ/ကြည့်ပါ",

  TrnParticulars: "ငွေလွှဲ အသေးစိတ်",
  EnterTrnParticulars: "ငွေလွှဲ အသေးစိတ်ကို ရိုက်ထည့်ပါ",
  TrnParticulars2: "ငွေလွှဲ အသေးစိတ်2",
  EnterTrnParticulars2: "ငွေလွှဲ အသေးစိတ်2 ကို ရိုက်ထည့်ပါ",
  ChargeTemplate: "ချိုးမှုပုံစံ",
  SpecialAmount: "ထူးခြားသော ပမာဏ",
  AmountLabelAlreadyenteredatLine:
    "ပမာဏ အမှတ်အသားသည် အတန်း {0} တွင် ရှိပြီးသား",
  AccountNumber: "အကောင့်နံပါတ်",
  EnterAccountNumber: "အကောင့်နံပါတ်ကို ရိုက်ထည့်ပါ",
  MaximumAmountshouldbeGreaterthanorequaltoMinimumAmount:
    "အများဆုံး ပမာဏသည် အနည်းဆုံး ပမာဏထက် ကြီး သို့မဟုတ် အတူညီသင့်သည်။",
  MinimumAmountshouldbeLessthanorequalToMaximumAmount:
    "အနည်းဆုံး ပမာဏသည် အများဆုံး ပမာဏထက် သေး သို့မဟုတ် အတူညီသင့်သည်။",
  Doubleclicktochangetheimage: "ပုံကို လျှပ်နှိပ်ပြီး ပြောင်းပါ",
  OptionisAlreadyenteredatLine: "ရွေးချယ်မှုသည် အတန်း {0} တွင် ရှိပြီးသား",
  OptionType: "ရွေးချယ်မှု အမျိုးအစား*",
  OperatorIcon: "လုပ်ငန်းရှင် အိုင်ကွန်း",
  Uptosixrowsareallowedtobeadded:
    "လေးစားသော အတန်း (၆) အထိ ထည့်သွင်းရန် ခွင့်ပြုသည်။",
  VIEWImage: "ပုံကို ကြည့်ပါ",

  // Source Parent Type Master

  SourceParentTypeMaster: "အရင်းအမြစ် မိဘ အမျိုးအစား မဟာဌာန",
  SourceName: "အရင်းအမြစ် အမည်",
  SourceType: "အရင်းအမြစ် အမျိုးအစား",
  EnterSourceType: "အရင်းအမြစ် အမျိုးအစားကို ရိုက်ထည့်ပါ",
  DisplayOrder: "ပြသမှု အစီအစဉ်",
  EnterDisplayOrder: "ပြသမှု အစီအစဉ်ကို ရိုက်ထည့်ပါ",
  SignUpAllow: "စာရင်းသွင်းခြင်း ခွင့်ပြုပါ",
  BeneficiaryAllow: "ထောက်ခံသူ ခွင့်ပြုပါ",

  // Insurance Master
  InsuranceMaster: "အာမခံ မဟာဌာန",
  Code: "ကုဒ်",
  EnterCode: "ကုဒ်ကို ရိုက်ထည့်ပါ",
  AccountSource: "အကောင့် အရင်းအမြစ်",
  EnterTransactionParticulars: "ငွေလွှဲ အသေးစိတ်ကို ရိုက်ထည့်ပါ",
  TransactionParticulars2: "ငွေလွှဲ အသေးစိတ်2",
  EnterTransactionParticulars2: "ငွေလွှဲ အသေးစိတ်2 ကို ရိုက်ထည့်ပါ",
  Remark: "မှတ်ချက်",
  EnterRemark: "မှတ်ချက်ကို ရိုက်ထည့်ပါ",
  PolicyLabelEnglish: "မူဝါဒ အမှတ်အသား(အင်္ဂလိပ်)",
  EnterPolicyLabelEnglish: "မူဝါဒ အမှတ်အသား(အင်္ဂလိပ်)ကို ရိုက်ထည့်ပါ",
  PolicyLabelLocal: "မူဝါဒ အမှတ်အသား(ဒေသခံ)",
  EnterPolicyLabelLocal: "မူဝါဒ အမှတ်အသား(ဒေသခံ)ကို ရိုက်ထည့်ပါ",

  // University Master
  UniversityMaster: "တက္ကသိုလ် မဟာဌာန",
  PaymentID: "ငွေပေးချေမှု ID*",
  EnterPaymentID: "ငွေပေးချေမှု ID ကို ရိုက်ထည့်ပါ",
  PaymentHeader: "ငွေပေးချေမှု ဦးစီးချက်*",
  EnterPaymentHeader: "ငွေပေးချေမှု ဦးစီးချက်ကို ရိုက်ထည့်ပါ",

  // Utility Master
  UtilityMaster: "အသုံးစရိတ် မဟာဌာန",

  // Club Master
  ClubMaster: "ကလပ် မဟာဌာန",
  MemberDetails: "အဖွဲ့ဝင် အသေးစိတ်",
  DownloadSample: "နမူနာကိုဒေါင်းလုဒ်ဆွဲပါ",
  Upload: "တင်ပါ",
  UploadFile: "ဖိုင်ကို တင်ပါ",
  ClubMemberDetail: "ကလပ် အဖွဲ့ဝင် အသေးစိတ်",
  ClubMemberDetails: "ကလပ် အဖွဲ့ဝင် အသေးစိတ်များ",
  MemberID: "အဖွဲ့ဝင် ID",
  EnterMemberID: "အဖွဲ့ဝင် ID ကို ရိုက်ထည့်ပါ",
  MemberName: "အဖွဲ့ဝင် အမည်",
  EnterMemberName: "အဖွဲ့ဝင် အမည်ကို ရိုက်ထည့်ပါ",
  MemberType: "အဖွဲ့ဝင် အမျိုးအစား",
  EnterMemberType: "အဖွဲ့ဝင် အမျိုးအစားကို ရိုက်ထည့်ပါ",
  MemberSince: "အဖွဲ့ဝင်ဖြစ်မှုကစသည်",
  MemberStatus: "အဖွဲ့ဝင် အခြေအနေ",
  EnterMemberStatus: "အဖွဲ့ဝင် အခြေအနေကို ရိုက်ထည့်ပါ",
  EntryDate: "ဝင်ရောက်နေ့",
  ClubMember: "ကလပ် အဖွဲ့ဝင်",
  Futuredatesarenotallowed: "အနာဂတ်ရက်များကို ခွင့်ပြုမထားပါ။",

  InvalidDateareNotAllowedinMemberSinceColumn:
    "မှားယွင်းသော ရက်များသည် အဖွဲ့ဝင်ဖြစ်မှုကစသည် ကော်လံတွင် ခွင့်ပြုမထားပါ။",
  FutureDateareNotAllowedinMemberSinceColumn:
    "အနာဂတ်ရက်များသည် အဖွဲ့ဝင်ဖြစ်မှုကစသည် ကော်လံတွင် ခွင့်ပြုမထားပါ။",
  Requiredfieldscannotbenull: "လိုအပ်သော ကွက်များသည် မလွတ်လပ်ရပါ။",
  DoyouwanttoUpdateClubMemberData:
    "ကလပ် အဖွဲ့ဝင် အချက်အလက်များကို ပြင်ဆင်လိုပါသလား?",
  Whichformatdoyouwanttodownload: "မည်သည့်ပုံစံကို ဒေါင်းလုဒ်ဆွဲလိုပါသလဲ?",
  Excel: "Excel",
  CSV: "CSV",

  // Branch Master
  BranchMaster: "ဌာန မဟာဌာန",
  BranchCode: "ဌာန ကုဒ်",
  Address: "လိပ်စာ",
  ContactNumber: "ဆက်သွယ်ရန် နံပါတ်",
  EmailID: "အီးမေးလ် ID",
  EnterEmailID: "အီးမေးလ် ID ကို ရိုက်ထည့်ပါ",
  FileDownload: "ဖိုင် ဒေါင်းလုဒ်",

  ContactPerson: "ဆက်သွယ်ရန် ပုဂ္ဂိုလ်",
  EnterContactPerson: "ဆက်သွယ်ရန် ပုဂ္ဂိုလ်ကို ရိုက်ထည့်ပါ",
  ContactPersonBranchManagerDetails:
    "ဆက်သွယ်ရန် ပုဂ္ဂိုလ်/ဌာန မန်နေဂျာ အသေးစိတ်",
  PayOrderAllow: "ငွေပေးချေမှု ခွင့်ပြုပါ",
  ChequeBookAllow: "ချေးစာအုပ် ခွင့်ပြုပါ",
  DPSAllow: "DPS ခွင့်ပြုပါ",
  FDAllow: "FD ခွင့်ပြုပါ",
  District: "ခရိုင်",
  EnterAddress: "လိပ်စာကို ရိုက်ထည့်ပါ",
  Longitude: "လှိုဏ်ဂျစ်",
  EnterLongitude: "လှိုဏ်ဂျစ်ကို ရိုက်ထည့်ပါ",
  Latitude: "အလှိုင်း",
  EnterLatitude: "အလှိုင်းကို ရိုက်ထည့်ပါ",
  Phone1: "ဖုန်း(၁)",
  EnterPhone1: "ဖုန်း(၁)ကို ရိုက်ထည့်ပါ",
  Phone2: "ဖုန်း(၂)",
  EnterPhone2: "ဖုန်း(၂)ကို ရိုက်ထည့်ပါ",
  EMailisinvalid: "အီးမေးလ် မမှန်ကန်ပါ။",
  OpenDate: "ဖွင့်ရက်",
  BranchName: "ဌာန အမည်",
  EnterBranchName: "ဌာန အမည်ကို ရိုက်ထည့်ပါ",
  EnterBranchCode: "ဌာန ကုဒ်ကို ရိုက်ထည့်ပါ",
  Norowsfoundforupdate: "ပြုပြင်ရန် အတန်း မရှိပါ",
  DoyouwanttoUpdateBranchMasterData:
    "ဌာန မဟာဌာန အချက်အလက်များကို ပြင်ဆင်လိုပါသလား?",
  MobileNumber: "မိုဘိုင်း နံပါတ်",
  EnterMobileNumber: "မိုဘိုင်း နံပါတ်ကို ရိုက်ထည့်ပါ",

  // OTP SMS Configuration
  OTPSMSConfiguration: "မိုဘိုင်း OTP SMS စီမံခန့်ခွဲမှု",
  ActionCode: "လုပ်ဆောင်မှု ကုဒ်",
  EnterActionCode: "လုပ်ဆောင်မှု ကုဒ်ကို ရိုက်ထည့်ပါ",
  ActionDescription: "လုပ်ဆောင်မှု ဖော်ပြချက်",
  EnterActionDescription: "လုပ်ဆောင်မှု ဖော်ပြချက်ကို ရိုက်ထည့်ပါ",
  SMSText: "SMS အကြောင်းအရာ",
  EnterSMSText: "SMS အကြောင်းအရာကို ရိုက်ထည့်ပါ",

  // Tenure Type Configuration
  TenureTypeConfiguration: "အချိန်ကာလ အမျိုးအစား စီမံခန့်ခွဲမှု",
  AccountType: "အကောင့် အမျိုးအစား",
  TransactionTypeDisplay: "ငွေလွှဲ အမျိုးအစား ပြသမှု",
  AccountTypesDisplay: "အကောင့် အမျိုးအစား ပြသမှု",
  TenureTypeReq: "အချိန်ကာလ အမျိုးအစား*",
  TenureReq: "အချိန်ကာလ*",
  Tenures: "အချိန်ကာလများ",
  EnterTenure: "အချိန်ကာလကို ရိုက်ထည့်ပါ",
  EffectiveFromReq: "အကျိုးသက်ရောက်မှု မှာ*",

  // Email/SMS Template Configuration
  EmailSMSTemplateConfiguration:
    "အီးမေးလ်/SMS များ ရုပ်ပြ မူပိုင်ခွင့် စီမံခန့်ခွဲမှု",
  TranType: "ငွေလွှဲ အမျိုးအစား",
  EnterTranType: "ငွေလွှဲ အမျိုးအစားကို ရိုက်ထည့်ပါ",
  MailSubject: "အီးမေးလ် ခေါင်းစဉ်",
  EnterMailSubject: "အီးမေးလ် ခေါင်းစဉ်ကို ရိုက်ထည့်ပါ",
  SenderMailID: "ပို့သူ အီးမေးလ် ID",
  EnterSenderMailID: "ပို့သူ အီးမေးလ် ID ကို ရိုက်ထည့်ပါ",
  CCMailID: "CC အီးမေးလ် ID",
  EnterCCMailID: "CC အီးမေးလ် ID ကို ရိုက်ထည့်ပါ",
  DisplaySenderName: "ပို့သူ အမည်ကို ပြသပါ",
  EnterDisplaySenderName: "ပို့သူ အမည်ကို ရိုက်ထည့်ပါ",
  MailServer: "အီးမေးလ် ဆာဗာ",
  SMS: "SMS",
  Email: "အီးမေးလ်",
  SorrythecontentyouaretryingtouploadmustbeinHTMLformat:
    "သင်တင်သွင်းရန် ကြိုးစားနေသော အကြောင်းအရာသည် HTML ဖောင်မတ်တွင် ရှိရန် လိုအပ်ပါသည်။",
  EmailConfiguration: "အီးမေးလ် စီမံခန့်ခွဲမှု",
  Import: "သွင်းပါ",
  EmailText: "အီးမေးလ် အကြောင်းအရာ",
  EnterEmailText: "အီးမေးလ် အကြောင်းအရာကို ရိုက်ထည့်ပါ",
  Keys: "ခွင့်ပြုချက်များ",
  NoteImportHTMLFile:
    "မှတ်ချက်: HTML ဖိုင်ကို သွင်းရန်၊ အီးမေးလ် အကြောင်းအရာ ပေါ်တွင် လှိုက်လှိုက်လှဲလှဲ သွားပါ သို့မဟုတ် 'သွင်းပါ' ခလုတ်ကို နှိပ်ပါ။",
  InvalidMailSenderMailID: "မမှန်ကန်သော ပို့သူ အီးမေးလ် ID။",
  SMSConfiguration: "SMS စီမံခန့်ခွဲမှု",

  //Beneficiary Restriction Master
  BeneficiaryRestrictionMaster: "အကျိုးခံစားခွင့် ကန့်သတ်ချက် ဖွဲ့စည်းမှု",
  RestrictionType: "ကန့်သတ်ချက်အမျိုးအစား",
  Value: "တန်ဖိုး",
  BeneficiaryLabel: " အကျိုးခံစားခွင့်ရှိသူ အမှတ်အသား",
  AccountName: "အကောင့်အမည်",
  EnterAccountName: "အကောင့်အမည်ကိုထည့်ပါ",
  ProductCode: "ကုန်ပစ္စည်းကုဒ်",
  EnterProductCode: "ကုန်ပစ္စည်းကုဒ်ထည့်ပါ",
  RoutingNumber: "လမ်းကြောင်းနံပါတ်",
  EnterRoutingNumber: "လမ်းကြောင်းနံပါတ်ထည့်ပါ",
  RecordAlreadyExists: " မှတ်တမ်း ရှိပြီးသား ဖြစ်သည်။",

  // ATM Locator Master
  ATMLocatorMaster: "ATM တည်နေရာ ဖွင့်မဟာဌာန",
  ATMLocation: "ATM တည်နေရာ",
  EnterATMLocation: "ATM တည်နေရာကို ရိုက်ထည့်ပါ",
  Address1: "လိပ်စာ ၁",
  EnterAddress1: "လိပ်စာ ၁ ကို ရိုက်ထည့်ပါ",
  Address2: "လိပ်စာ ၂",
  EnterAddress2: "လိပ်စာ ၂ ကို ရိုက်ထည့်ပါ",
  Address3: "လိပ်စာ ၃",
  EnterAddress3: "လိပ်စာ ၃ ကို ရိုက်ထည့်ပါ",
  PostalCode: "စာတိုက် နံပါတ်",
  EnterPostalCode: "စာတိုက် နံပါတ်ကို ရိုက်ထည့်ပါ",
  ActiveStatus: "ပုံမှန် အခြေအနေ",
  DoyouwanttoupdateATMLocatormasterdata:
    "ATM တည်နေရာ မဟာဌာန အချက်အလက်များကို ပြင်ဆင်လိုပါသလား?",

  // Screen Note Configuration
  ScreenNoteConfiguration: "အမျက်နှာပြင်မှတ်စု စီမံခန့်ခွဲမှု",
  ScreenID: "အမျက်နှာပြင် ID",
  EnglishNote: "အင်္ဂလိပ် မှတ်စု",
  BanglaNote: "ဘင်္ဂလီ မှတ်စု",
  English: "အင်္ဂလိပ်*",
  EnterEnglishMessage: "အင်္ဂလိပ် မက်ဆေ့ချ်ကို ရိုက်ထည့်ပါ",
  Bangla: "ဘင်္ဂလီ",
  EnterBanglaMessage: "ဘင်္ဂလီ မက်ဆေ့ချ်ကို ရိုက်ထည့်ပါ",
  Translate: "ဘာသာပြန်ပါ",

  // Guessable Password Entry
  GuessablePasswordEntry: "ခန့်မှန်းနိုင်သော စကားဝှက် ထည့်သွင်းမှု",
  GuessablePassword: "ခန့်မှန်းနိုင်သော စကားဝှက်",
  EnterGuessablePassword: "ခန့်မှန်းနိုင်သော စကားဝှက်ကို ရိုက်ထည့်ပါ",

  // Banner Configuration
  BannerConfiguration: "ဘန်နာ စီမံခန့်ခွဲမှု",
  BannerType: "ဘန်နာ အမျိုးအစား",
  BannerDescription: "ဘန်နာ ဖော်ပြချက်",
  LoginID: "လော့ဂ်အင် ID",
  EnterLoginID: "လော့ဂ်အင် ID ကို ရိုက်ထည့်ပါ",
  ChannelReq: "ချန်နယ်*",
  Invaliddate: "မမှန်ကန်သော ရက်စွဲ",
  ViewUploadHTML: "HTML ကို ကြည့်ရန်/တင်ပါ",
  Htmltext: "HTML အကြောင်းအရာ",
  EnterHtmltext: "HTML အကြောင်းအရာကို ရိုက်ထည့်ပါ",
  BannerNote:
    "မှတ်ချက်: HTML ဖိုင်ကို တင်ရန်၊ အီးမေးလ် အကြောင်းအရာ ပေါ်တွင် လှိုက်လှိုက်လှဲလှဲ သွားပါ သို့မဟုတ် 'သွင်းပါ' ခလုတ်ကို နှိပ်ပါ။",
  DropHere: "ဤနေရာတွင် လွှင့်ပါ",
  DropHTMLFileHere: "HTML ဖိုင်ကို ဤနေရာတွင် လွှင့်ပါ",
  DisplayType: "ပြသမှု အမျိုးအစား",
  InvalidLoginID: "မမှန်ကန်သော လော့ဂ်အင် ID။",

  // Guideline File Configuration
  GuidelineFileConfiguration: "အညွှန်းဖိုင် စီမံခန့်ခွဲမှု",
  UseCase: "သုံးစွဲမှု အကြောင်း",
  UploadDate: "တင်သွင်းချိန်",
  FileName: "ဖိုင်အမည်",
  EnterFileName: "ဖိုင်အမည်ကို ရိုက်ထည့်ပါ",
  FileType: "ဖိုင်အမျိုးအစား",
  Filesizeshouldbelessthan5MB: "ဖိုင်အရွယ်အစားသည် 5 MB ထက်လျော့ပါမည်။",
  PleaseSelectPDFFileonly: "ကျေးဇူးပြု၍ PDF ဖိုင်သာ ရွေးချယ်ပါ။",
  Nofilefoundtopreview: "ကြည့်ရန် ဖိုင်မရှိပါ။",

  // FD Scheme Configuration
  FDSchemeConfiguration: "FD စီမံကိန်း စီမံခန့်ခွဲမှု",
  FDAccounttype: "FD အကောင့် အမျိုးအစား",
  TenureTypeFinacle: "အချိန်ကာလ အမျိုးအစား Finacle",
  Tenure: "အချိန်ကာလ",
  Renewal: "ပြန်လည်အသက်သွင်းခြင်း",
  EnterRenewal: "ပြန်လည်အသက်သွင်းခြင်းကို ရိုက်ထည့်ပါ",
  MaturityInst: "သက်တမ်းအဆုံး သက်ဆိုင်ရာ",
  EnterMaturityInst: "သက်တမ်းအဆုံးကို ရိုက်ထည့်ပါ",
  NatureofAccount: "အကောင့်၏ အခေတ်အကျင့်",
  EnterNatureofAccount: "အကောင့်၏ အခေတ်အကျင့်ကို ရိုက်ထည့်ပါ",
  TenureTypeRate: "အချိန်ကာလ အမျိုးအစား နှုန်း",
  EnterTenureTypeRate: "အချိန်ကာလ အမျိုးအစား နှုန်းကို ရိုက်ထည့်ပါ",
  CCY: "ငွေကြေး",
  EnterCCY: "ငွေကြေးကို ရိုက်ထည့်ပါ",
  SchemeDescription: "စီမံကိန်း ဖော်ပြချက်",
  EnterSchemeDescription: "စီမံကိန်း ဖော်ပြချက်ကို ရိုက်ထည့်ပါ",
  TDModAmount: "TD မော်ဒစ်အတွက် ငွေပမာဏ",
  EnterTDModAmount: "TD မော်ဒစ်အတွက် ငွေပမာဏကို ရိုက်ထည့်ပါ",
  SampleFileDownload: "နမူနာ ဖိုင် ဒေါင်းလုတ်",
  FdAccountType: "FD အကောင့် အမျိုးအစား",
  EnterFdAccountType: "FD အကောင့် အမျိုးအစားကို ရိုက်ထည့်ပါ",
  DoyouwanttoUpdateFDSchemeMasterData:
    "FD စီမံကိန်း မဟာဌာန အချက်အလက်များကို ပြင်ဆင်လိုပါသလား?",
  FDSchemeMaster: "FD စီမံကိန်း မဟာဌာန",

  //Parameter Master
  ParameterMaster: "ပאַרာမီတာ မဟာဌာန",
  DataType: "ဒေတာအမျိုးအစား",
  GlobalLevel: "ကမ္ဘာ့ အဆင့်",
  HOLevel: "HO အဆင့်",
  EnterValue: "တန်ဖိုးကို ရိုက်ထည့်ပါ",
  ParameterConfirmation: "ပאַרာမီတာ အတည်ပြုချက်",
  NewParameterValue: "အသစ် ပאַרာမီတာ တန်ဖိုး",
  OldParameterValue: "ဟောင်း ပאַרာမီတာ တန်ဖိုး",
  NewDatatype: "အသစ် ဒေတာအမျိုးအစား",
  OldDatatype: "ဟောင်း ဒေတာအမျိုးအစား",

  // User Block Configuration
  UserBlockConfiguration: "အသုံးပြုသူ ကာကွယ်မှု စီမံခန့်ခွဲမှု",
  ConfigType: "စီမံခန့်ခွဲမှု အမျိုးအစား",
  FailAttempt: "အောင်မြင်မှု မရနိုင်သော ကြိုးစားမှု",
  MinutesOfBlock: "ကာကွယ်ခြင်း မိနစ်",
  EnterMinutesOfBlock: "ကာကွယ်ခြင်း မိနစ်ကို ရိုက်ထည့်ပါ",
  AutoRelease: "အလိုအလျောက် ဖြုတ်ပေးရန်",
  EnterNoOfFailAttempt:
    "အောင်မြင်မှု မရနိုင်သော ကြိုးစားမှု အရေအတွက်ကို ရိုက်ထည့်ပါ",
  OldFailAttempt: "ဟောင်း အောင်မြင်မှု မရနိုင်သော ကြိုးစားမှု",
  OldMinutesOfBlock: "ဟောင်း ကာကွယ်ခြင်း မိနစ်",
  UserBlockConfigurationConfirmation:
    "အသုံးပြုသူ ကာကွယ်မှု စီမံခန့်ခွဲမှု အတည်ပြုချက်",

  // Application Review User Master
  ApplicationReviewUserMaster: "အပလီကေးရှင်း ပြန်လည်ဆန်းစစ်သူ မဟာဌာန",
  LoginName: "လော့ဂ်အင် အမည်",
  TestLoginID: "စမ်းသပ် လော့ဂ်အင် ID",
  ReviewLoginName: "ပြန်လည်ဆန်းစစ်မည့် လော့ဂ်အင် အမည်",
  LatestVersion: "နောက်ဆုံးဗားရှင်း",
  EnterLatestAppVersion: "နောက်ဆုံး အပလီကေးရှင်း ဗားရှင်းကို ရိုက်ထည့်ပါ",
  ExpiryDate: "သက်တမ်းကုန်ဆုံး ရက်",
  TestUserLastLoginDate: "စမ်းသပ် အသုံးပြုသူ နောက်ဆုံး လော့ဂ်အင် ရက်",
  EnterTestLoginID: "စမ်းသပ် လော့ဂ်အင် ID ကို ရိုက်ထည့်ပါ",
  EnterReviewLoginName: "ပြန်လည်ဆန်းစစ်မည့် လော့ဂ်အင် အမည်ကို ရိုက်ထည့်ပါ",
  EnterLatestVersion: "နောက်ဆုံးဗားရှင်းကို ရိုက်ထည့်ပါ",
  Spaceatthebeginningisnotallowed: "အစမှာ အာကာသလက္ခဏာများ မခွင့်ပြုပါ။",
  EnteraproperMobileAppVersion:
    "သင့်လျော်သော မိုဘိုင်း အပလီကေးရှင်း ဗားရှင်းကို ရိုက်ထည့်ပါ။",
  Pastdateisnotallowed: "အတိတ်ရက်ကို ခွင့်မပြုပါ။",
  EnterTestUserLastLoginDate:
    "စမ်းသပ် အသုံးပြုသူ နောက်ဆုံး လော့ဂ်အင် ရက်ကို ရိုက်ထည့်ပါ",
  // Validation Message Master
  ValidationMessageMaster: "အတည်ပြုမှု စာပိုင်း မဟာဌာန",
  MessageCode: "စာပိုင်း ကုဒ်",
  EnglishMessage: "အင်္ဂလိပ် စာပိုင်း",
  BanglaMessage: "ဘင်္ဂလီ စာပိုင်း",
  EnglishLan: "အင်္ဂလိပ်",

  // Card BIN Image Configuration
  CardBINImageConfiguration: "ကဒ် BIN ဓာတ်ပုံ စီမံခန့်ခွဲမှု",
  CardBin: "ကဒ် BIN",
  AllowBanglaQR: "ဘင်္ဂလီ QR ကို ခွင့်ပြုပါ",
  CardImage: "ကဒ် ဓာတ်ပုံ",
  UserStatus: "အသုံးပြုသူ အခြေအနေ",
  CardBinImageUpload: "ကဒ် BIN ဓာတ်ပုံ တင်ပါ",
  CardBinNumber: "ကဒ် BIN နံပါတ်",
  EnterCardBinNumber: "ကဒ် BIN နံပါတ်ကို ရိုက်ထည့်ပါ",
  Imagesizeshouldbelessthan5MB: "ဓာတ်ပုံအရွယ်အစားသည် 5 MB ထက်လျော့ရမည်။",
  PleaseSelectValidFormat: "မှန်ကန်သော အမျိုးအစားကို ရွေးချယ်ပါ။",
  ClicktouploadtheCardImage: "ကဒ် ဓာတ်ပုံကို တင်ရန် နှိပ်ပါ",
  UploadCardImage: "ကဒ် ဓာတ်ပုံကို တင်ပါ",
  ClickontheCardImageboxtouploadImage:
    "ဓာတ်ပုံတင်ရန် ကဒ် ဓာတ်ပုံဘောက်စ်ကို နှိပ်ပါ။",
  MaximumImageSizeshouldbe5MB: "အမြင့်ဆုံး ဓာတ်ပုံအရွယ်အစားသည် 5 MB ဖြစ်ရမည်။",
  ImageformatshouldbeJPEGorPNG:
    "ဓာတ်ပုံအမျိုးအစားသည် JPEG သို့မဟုတ် PNG ဖြစ်ရမည်။",

  // MS Monitoring Master
  MSMonitoringMaster: "MS ကြည့်ရှုမှု မဟာဌာन",
  ServiceID: "ဝန်ဆောင်မှု ID",
  ActiveInstance: "တက်ကြွသော အကောင့်",
  MSInstanceInformations: "MS အကောင့် အချက်အလက်များ",
  InstanceID: "အကောင့် ID",
  PropertiesList: "အထွေထွေရေးဇာတ်",
  Properties: "အထွေထွေရေး",
  MicroServiceList: "မိုက်ခရိုဝန်ဆောင်မှု အကြောင်းအရာများ",
  InstanceStatus: "အကောင့် အခြေအနေ",
  UpdateStatus: "အခြေအနေ ပြင်ဆင်မှု",
  APIResponse: "API တုံ့ပြန်မှု",

  //Service wise Mobile Number Validation Template Mapping
  ServiceWiseMobileNumberValidationMaster:
    "ဝန်ဆောင်မှုပညာရှိ မိုဘိုင်းနံပါတ် မှန်ကန်ကြောင်း ဆရာကြီး",
  TemplateName: "ပုံစံခွက်အမည်",
  ServiceWiseMobileNumberValidationConfirmation:
    "ဝန်ဆောင်မှုအလိုက် မိုဘိုင်းနံပါတ် အတည်ပြုမှု အတည်ပြုချက်",

  // IDTP Charge Configuration
  IDTPChargeConfiguration: "IDTP အခွန် စီမံခန့်ခွဲမှု",
  ReceiverFI: "လက်ခံသူ FI*",
  IDTPChargeConfigurationConfirmation: "IDTP အခွန် စီမံခန့်ခွဲမှု အတည်ပြုချက်",
  NewServiceChargeTemplate: "အသစ် ဝန်ဆောင်မှု အခွန် တမ်းပလိတ်",
  OldServiceChargeTemplate: "ဟောင်း ဝန်ဆောင်မှု အခွန် တမ်းပလိတ်",
  NewVATPercentage: "အသစ် VAT ရာခိုင်နှုန်း",
  OldVATPercentage: "ဟောင်း VAT ရာခိုင်နှုန်း",

  // Service Monitoring Master
  ServiceMonitoringMaster: "ဝန်ဆောင်မှု ကြည့်ရှုမှု မဟာဌာန",
  LastExecutionDate: "နောက်ဆုံး အကောင့် အကောင့်ဝင်ရက်",

  // MS Service Message Configuration
  MSServiceMessageConfiguration: "MS ဝန်ဆောင်မှု စာပိုင်း စီမံခန့်ခွဲမှု",
  KeyName: "ခွင့်အမည်",
  EnterKeyName: "ခွင့်အမည်ကို ရိုက်ထည့်ပါ",
  DefaultMessage: "မူလစာပိုင်း",
  EnterDefaultMessage: "မူလစာပိုင်းကို ရိုက်ထည့်ပါ",
  LocalLanguageMessage: "တိုင်းရင်းဘာသာ စာပိုင်း",
  EnterLocalLanguageMessage: "တိုင်းရင်းဘာသာ စာပိုင်းကို ရိုက်ထည့်ပါ",
  Orderby: "စဉ်ကိုအလိုက်",
  Comments: "မှတ်ချက်များ",
  //MS Properties Configuration
  MSPropertiesConfiguration: "MS ပစ္စည်းဥစ္စာ ဖွဲ့စည်းမှု",
  ApplicationName: "လျှောက်လွှာအမည်",
  ProfileName: "ပရိုဖိုင်အမည်",
  Label: "ကပ်တံဆိပ်",
  AreyousuretodeleteselectedMobileNumberValidationTemplate:
    "ရွေးထားသော မိုဘိုင်းနံပါတ် အတည်ပြုမှု တမ်းပလိတ်ကို ဖျက်ရန် သေချာပါသလား?",
  Key: "ခွင့်",
  EnterKey: "ခွင့်ကို ရိုက်ထည့်ပါ",
  NoteOne:
    "1. *-ခွင့်တန်ဖိုးကို * သို့မဟုတ် ရှည်လျားမှုအထိ အစားထိုးပါ။ EX.ACCOUNT=*{' '} ",
  NoteTwo:
    "2. ဖ kosong  ဖြစ်ရင်ခွင့်တန်ဖိုးကို ခွင့်လွှတ်ပါ။ EX.accountNumber={' '} ",
  NoteThree:
    "3. ဖျော်ဖြေရန် သတ်မှတ်ထားပြီးပါက စနစ်သည် ဖျော်ဖြေရန် အဖြစ်နှင့် တန်ဖိုးကို မူလသတ်မှတ်ချက်နှင့် တစ်ပြိုင်နက်တွင် အစားထိုးပါမည်၊ ဒါပေမယ့် သတ်မှတ်ချက်ကိုလျှောက်ထားသည့်အရွယ်အစားသည် ခွင့်တန်ဖိုး၏အရှည်နှင့် ညီရမည်။ သတ်မှတ်ချက်နှင့် တန်ဖိုး၏အရှည်မညီပါက ဂရုစိုက်ခြင်းမပြုမည်။ EX.$[1234******123,1234******123578]{' '} ",
  NoteFour:
    "4. ခွင့်အမည်သည် JSON ပစ္စည်း/JSON အမျိုးအစားအနေဖြင့် တန်ဖိုးများပါဝင်သည်ဆိုလျှင် တန်ဖိုးသည် ''''.'{' '}' နှင့်အစားထိုးပါ။",

  // Virtual Card Image Configuration
  CardImageConfiguration: "ကဒ် ဓာတ်ပုံ စီမံခန့်ခွဲမှု",
  CardImageConfirmation: "ကဒ် ဓာတ်ပုံ စီမံခန့်ခွဲမှု အတည်ပြုချက်",
  ImageID: "ဓာတ်ပုံ ID",
  EnterImageID: "ဓာတ်ပုံ ID ကို ရိုက်ထည့်ပါ",
  CardImageUpload: "ကဒ် ဓာတ်ပုံ တင်ပါ",

  // Web Rerouting Configuration
  WebReroutingConfiguration: "ဝက်ဘ် ပြန်လည်ဆွဲခြင်း စီမံခန့်ခွဲမှု",
  ActionMenu: "အရေးယူမှု မီနူး",
  PopupStatus: "ပေါင်းဆုံခြင်း အခြေအနေ",
  LoginStatus: "လော့ဂ်အင် အခြေအနေ",
  LabelEnglish: "တံဆိပ် (အင်္ဂလိပ်)",
  EnterEnglishLanguageLabel: "အင်္ဂလိပ်ဘာသာတံဆိပ်ကို ရိုက်ထည့်ပါ",
  LabelLocalLanguage: "တံဆိပ် (တိုင်းရင်းဘာသာ)",
  EnterLocalLanguageLabel: "တိုင်းရင်းဘာသာတံဆိပ်ကို ရိုက်ထည့်ပါ",
  PleaseentervalidURL: "မှန်ကန်သော URL ကို ရိုက်ထည့်ပါ။",
  PopupMessageEnglish: "ပေါင်းဆုံစာပိုင်း (အင်္ဂလိပ်)",
  EnterEnglishLanguagePopupMessage:
    "အင်္ဂလိပ်ဘာသာပေါင်းဆုံစာပိုင်းကို ရိုက်ထည့်ပါ",
  PopupMessageLocalLanguage: "ပေါင်းဆုံစာပိုင်း (တိုင်းရင်းဘာသာ)",
  EnterLocalLanguagePopupMessage:
    "တိုင်းရင်းဘာသာပေါင်းဆုံစာပိုင်းကို ရိုက်ထည့်ပါ",
  ServiceCode: "ဝန်ဆောင်မှု ကုဒ်",
  EnterServiceCode: "ဝန်ဆောင်မှု ကုဒ်ကို ရိုက်ထည့်ပါ",
  APIPassword: "API စကားဝှက်",
  EnterAPIPassword: "API စကားဝှက်ကို ရိုက်ထည့်ပါ",
  APIUserID: "API အသုံးပြုသူ ID",
  EnterAPIUserID: "API အသုံးပြုသူ ID ကို ရိုက်ထည့်ပါ",
  URL: "URL",
  EnterURL: "URL ကို ရိုက်ထည့်ပါ",
  WebReroutingConfirmation: "ဝက်ဘ် ပြန်လည်ဆွဲခြင်း အတည်ပြုချက်",
  MenuIcon: "မီနူး အမှတ်",
  ClicktouploadtheMenuIcon: "မီနူး အမှတ်ကို တင်ရန် နှိပ်ပါ",
  UploadMenuIcon: "မီနူး အမှတ်ကို တင်ပါ",
  ClickontheMenuIconboxtouploadIcon:
    "မီနူး အမှတ်ဘောက်စ်ကို နှိပ်၍ အမှတ်ကို တင်ပါ။",
  MaximumIconSizeshouldbe5MB: "အမြင့်ဆုံး အမှတ်အရွယ်အစားသည် 5 MB ဖြစ်ရမည်။",
  IconformatshouldbeJPEGorPNG:
    "အမှတ်အမျိုးအစားသည် JPEG သို့မဟုတ် PNG ဖြစ်ရမည်။",

  // Payment Gateway Merchant Master
  PaymentGatewayMerchantMaster: "ငွေပေးချေမှု ရွေးချယ်မှု မဟာဌာန",
  PaymentGatewayMerchantNameReq: "ငွေပေးချေမှု ရွေးချယ်မှု အမည်*",
  EnterPaymentGatewayMerchantName:
    "ငွေပေးချေမှု ရွေးချယ်မှု အမည်ကို ရိုက်ထည့်ပါ",

  // Merchant Onboarding Confirmation
  MerchantOnboardingConfirmation: "ကုန်သည် ဝင်ကြောင်း အတည်ပြုချက်",
  MerchantOnboardingConfiguration: "ကုန်သည် ဝင်ကြောင်း စီမံခန့်ခွဲမှု",
  GateWayPasswordValidation:
    "ဂိတ်ဝေးအ စကားဝှက်သည် အက္ခရာနဲ့နံပါတ်နှစ်ခုရှိပြီး အထက်ဆုံး စာလုံး၊ နိမ့်ဆုံး စာလုံးနှင့် အထူးအမှတ်တစ်ခုပါရှိရမည်၊ အကြားတွင် အာကာသမရှိဘူး။",
  PerTransactionLimit: "လိပ်စာတိုင်း ကန့်သတ်",
  EnterPerTransactionLimit: "လိပ်စာတိုင်း ကန့်သတ်ကို ရိုက်ထည့်ပါ",
  GatewayEmail: "ဂိတ်ဝေးအ အီးမေးလ်",
  EnterGatewayEmail: "ဂိတ်ဝေးအ အီးမေးလ်ကို ရိုက်ထည့်ပါ",
  InvalidMailGatewayEmail: "မမှန်ကန်သော ဂိတ်ဝေးအ အီးမေးလ်။",
  PercentageofVAT: "VAT ရာခိုင်နှုန်း",
  EnterPercentageofVAT: "VAT ရာခိုင်နှုန်းကို ရိုက်ထည့်ပါ",
  ToAccountNumber: "သို့ သင့်အကောင့်နံပါတ်",
  EnterToAccountNumber: "သင့်အကောင့်နံပါတ်ကို ရိုက်ထည့်ပါ",
  GatewayUsername: "ဂိတ်ဝေးအသုံးပြုသူအမည်",

  GatewayPassword: "ဂိတ်ဝေးအ စကားဝှက်",
  EnterGatewayPassword: "ဂိတ်ဝေးအ စကားဝှက်ကို ရိုက်ထည့်ပါ",
  PleaseEnterURL: "URL ကို ရိုက်ထည့်ပါ။",

  // PGW Merchant Users
  PGWMerchantUsers: "PGW ကုန်သည် အသုံးပြုသူများ",
  UserRole: "အသုံးပြုသူ အခန်းကဏ္ဍ",
  PGWMerchantUsersConfirmation: "PGW ကုန်သည် အသုံးပြုသူများ အတည်ပြုချက်",
  PGWMerchantUserCreation: "PGW ကုန်သည် အသုံးပြုသူ ဖန်တီးခြင်း",
  GatewayNamePID: "ဂိတ်ဝေးအ အမည် (PID)",
  PleaseentervalidIPAddress: "မှန်ကန်သော IP နံပါတ်ကို ရိုက်ထည့်ပါ။",
  IPAddress: "IP နံပါတ်",
  EnterIPAddress: "IP နံပါတ်ကို ရိုက်ထည့်ပါ။",
  EmailIDisinvalid: "အီးမေးလ် ID မမှန်ကန်ပါ",
  GatewayName: "ဂိတ်ဝေးအ အမည်",
  ConfirmationStatus: "အတည်ပြုချက် အခြေအနေ",

  // Mobile Number Validation Template
  MobileNumberValidationTemplate: "မိုဘိုင်းနံပါတ် အတည်ပြုမှု တမ်းပလိတ်",
  MobileNoLengthReq: "မိုဘိုင်း နံပါတ်အရှည်*",
  EnterMobileNoLength: "မိုဘိုင်း နံပါတ်အရှည်ကို ရိုက်ထည့်ပါ",
  MobileNoStartFrom: "မိုဘိုင်း နံပါတ် စတင်မည်",
  EnterMobileNoStartFrom: "မိုဘိုင်း နံပါတ် စတင်မည်ကို ရိုက်ထည့်ပါ",
  DescriptionReq: "ဖျော်ဖြေရန်*",

  // Dynamic Biller Deletion Request Confirmation
  DynamicBillerDeletionRequestConfirmation:
    "ဒိုင်နမစ် ဘီလာ ဖျက်သိမ်းမှု တောင်းဆိုမှု အတည်ပြုချက်",
  DynamicBillerConfirmation: "ဒိုင်နမစ် ဘီလာ အတည်ပြုချက်",
  DynamicBillerConfiguration: "ဒိုင်နမစ် ဘီလာ စီမံခန့်ခွဲမှု",
  CategoryID: "အမျိုးအစား ID",
  EnterCategoryID: "အမျိုးအစား ID ကို ရိုက်ထည့်ပါ",
  SubCategoryID: "အမျိုးအစား အတွင်း ID",
  EnterSubCategoryID: "အမျိုးအစား အတွင်း ID ကို ရိုက်ထည့်ပါ",
  BillerID: "ဘီလာ ID",
  EnterBillerID: "ဘီလာ ID ကို ရိုက်ထည့်ပါ",
  BilleName: "ဘီလာ အမည်",
  EnterBilleName: "ဘီလာ အမည်ကို ရိုက်ထည့်ပါ",
  SubCategoryName: "အမျိုးအစား အတွင်း အမည်",
  CategoryName: "အမျိုးအစား အမည်",
  BillerDescription: "ဘီလာ အကြောင်းအရာ",
  SubCategoryDescription: "အမျိုးအစား အတွင်း အကြောင်းအရာ",
  CategoryDescription: "အမျိုးအစား အကြောင်းအရာ",
  BillerInfoURL: "ဘီလာ အချက်အလက် URL",
  BillerPaymentURL: "ဘီလာ ငွေပေးချေမှု URL",
  Refresh: "ပြန်လည်ရ-refresh",
  ScreenNotes: "စာမျက်နှာ မှတ်ချက်များ",
  FieldOptions: "ကွက် ရွေးချယ်မှုများ",
  Options: "ရွေးချယ်မှုများ",
  BillerDetails: "ဘီလာ အသေးစိတ်",
  Doyouwanttoupdateselectedbillerdata:
    "ရွေးချယ်ထားသော ဘီလာဒေတာကို ပြင်ဆင်မည်လား?",
  RefreshDynamicBillerConfiguration:
    "ဒိုင်နမစ် ဘီလာ စီမံခန့်ခွဲမှုကို ပြန်လည်ရ-refresh",
  DynamicBillerScreenNotes: "ဒိုင်နမစ် ဘီလာ စာမျက်နှာ မှတ်ချက်များ",
  Language: "ဘာသာစကား",
  ScreenMessage: "စာမျက်နှာ ဆက်ဆံရေး",
  EnterScreenMessage: "စာမျက်နှာ ဆက်ဆံရေးကို ရိုက်ထည့်ပါ",
  FieldName: "ကွက်အမည်",
  FieldType: "ကွက်အမျိုးအစား",
  Required: "လိုအပ်သည်",
  Datatype: "ဒေတာအမျိုးအစား",
  MinimumValue: "အနည်းဆုံး တန်ဖိုး",
  MaximumValue: "အများဆုံး တန်ဖိုး",
  LabelEnglish1: "တံဆိပ် အင်္ဂလိပ်",
  LabelBangla: "တံဆိပ် ဘင်္ဂါလီ",
  DefaultValue: "စံနှုန်း တန်ဖိုး",
  TextAlign: "စာသား ဆက်စပ်",
  Placeholder: "အစားထိုးစာ",
  ValidationRegex: "အတည်ပြုမှု Regex",
  IsBeneficiaryField: "အကျိုးခံစားခွင့် ကွက်ဖြစ်ပါသလား",
  RequireForBillInfo: "ဘီလာ အချက်အလက်များအတွက် လိုအပ်ပါသလား",
  DisplaySequence: "ပြသမှု အစဉ်",
  IspayableAmount: "ငွေပေးချေရန် ရှိပါသလား",
  IsBillNumber: "ဘီလာနံပါတ်ဖြစ်ပါသလား",
  IsFromAccountField: "အကောင့်ကွက်မှ ရှိပါသလား",
  IsReadonlyField: "ဖတ်သာ ကွက်ဖြစ်ပါသလား",
  OptionsName: "ရွေးချယ်မှု အမည်",
  OptionsValue: "ရွေးချယ်မှု တန်ဖိုး",
  ParameterKeys: "အချက်အလက် ချိတ်ဆွဲ",
  DynamicBillerURLs: "ဒိုင်နမစ် ဘီလာ URL များ",
  BillerFields: "ဘီလာ ကွက်များ",
  BillInfoParameters: "ဘီလာ အချက်အလက်များ",
  BillPaymentParameters: "ဘီလာ ငွေပေးချေမှု အချက်အလက်များ",
  BillerName: "ဘီလာ အမည်",
  DynamicBillerAccountsChargeConfirmation:
    "ဒိုင်နမစ် ဘီလာ အကောင့်/ကြေး အတည်ပြုချက်",
  FinaclePoolAccount: "Finacle Pool အကောင့်",
  EnterFinaclePoolAccount: "Finacle Pool အကောင့်ကို ရိုက်ထည့်ပါ",
  AbabilPoolAccount: "Ababil Pool အကောင့်",
  EnterAbabilPoolAccount: "Ababil Pool အကောင့်ကို ရိုက်ထည့်ပါ",
  DynamicBillerChargeConfiguration: "ဒိုင်နမစ် ဘီလာ ကြေး စီမံခန့်ခွဲမှု",
  SubCategoryImage: "အမျိုးအစား အတွင်း ပုံ",
  BillerImage: "ဘီလာ ပုံ",
  NoteDoubleclickontheImageboxtouploadanewImage:
    "မှတ်ချက်: ပုံကို ဂဏန်းနှိပ်၍ အသစ်တင်ပါ။",

  // Bank Master
  BankMaster: "ဘဏ် မဟာဌာန",
  BankCode: "ဘဏ် ကုဒ်",
  EnterBankCode: "ဘဏ် ကုဒ်ကို ရိုက်ထည့်ပါ",
  NewDistrictCode: "အသစ် အထွေထွေ ကုဒ်",
  NPSBBankCode: "NPSB ဘဏ် ကုဒ်",
  EnterNPSBBankCode: "NPSB ဘဏ် ကုဒ်ကို ရိုက်ထည့်ပါ",
  BankName: "ဘဏ် အမည်",
  EnterBankName: "ဘဏ် အမည်ကို ရိုက်ထည့်ပါ",
  NPSB: "NPSB",
  BEFTN: "BEFTN",
  RTGS: "RTGS",
  ROWTYPE: "အတန်းအမျိုးအစား",
  NPSBENABLED: "NPSB အသုံးပြုမှု",
  BEFTNENABLED: "BEFTN အသုံးပြုမှု",
  RTGSENABLED: "RTGS အသုံးပြုမှု",
  Pleaseselectrecords: "မှတ်တမ်းများကို ရွေးချယ်ပါ။",
  Doyouwanttodeletetheselectedrecords:
    "ရွေးချယ်ထားသော မှတ်တမ်းများကို ဖျက်မည်လား?",
  Pleaseselectoneusertogetthedetails:
    "အချက်အလက်များရယူရန် အသုံးပြုသူတစ်ဦးကို ရွေးချယ်ပါ",
  UpdateServiceStatus: "ဝန်ဆောင်မှု အခြေအနေ ပြင်ဆင်ပါ",
  BankServiceStatusTitle: "ဘဏ် ဝန်ဆောင်မှု အခြေအနေ အဆင့်",
  BankServiceStatusCountNote: "ရွေးချယ်ထားသော ဘဏ်များ: ",
  BankServiceStatusNote:
    "မှတ်ချက်: ရွေးချယ်ထားသော ဘဏ်များအတွက် ဝန်ဆောင်မှုနှင့် အခြေအနေကို ရွေးချယ်ပါ။",
  BankServiceStatusUpdateMsg:
    "သင်သည် အရွေး {0} ကို {1} ဝန်ဆောင်မှုကို ရွေးချယ်ထားသော ဘဏ်များအားလုံးတွင် လုပ်မည်လား?",
  DoyouwanttoUpdateBankMasterData: "ဘဏ် မဟာဌာန ဒေတာကို ပြင်ဆင်မည်လား?",
  OperationFailed: "လုပ်ဆောင်မှု မအောင်မြင်ပါ။",

  // MFS Configuration
  MFSConfiguration: "MFS စီမံခန့်ခွဲမှု",
  MFSService: "MFS ဝန်ဆောင်မှု",
  MFSID: "MFS ID",
  EnterMFSID: "MFS ID ကို ရိုက်ထည့်ပါ",
  MFSName: "MFS အမည်",
  EnterMFSName: "MFS အမည်ကို ရိုက်ထည့်ပါ",
  MaximunDailyLimit: "အထူးနေ့စွဲ ကန့်သတ်",
  MFSLabelEnglish: "MFS တံဆိပ် (အင်္ဂလိပ်)",
  EnterMFSEnglishLanguageLabel: "MFS အင်္ဂလိပ် တံဆိပ်ကို ရိုက်ထည့်ပါ",
  MFSLabelLocal: "MFS တံဆိပ် (ရိုးရာ)",
  EnterMFSLocalLanguageLabel: "MFS ရိုးရာ တံဆိပ်ကို ရိုက်ထည့်ပါ",
  TranCode: "လွှဲပြောင်း ကုဒ်",
  Perdaymaxaddmoneyinbeneficiary: "နေ့စဉ် အမြင့်ဆုံး ပံ့ပိုးငွေ",
  EnterPerdaymaxaddmoneyinbeneficiary:
    "နေ့စဉ် အမြင့်ဆုံး ပံ့ပိုးငွေကို ရိုက်ထည့်ပါ",
  MFSConfigurationConfirmation: "MFS စီမံခန့်ခွဲမှု အတည်ပြုချက်",
  MFSIcon: "MFS အိုင်ကွန်း",

  // From Source Key Value Configuration
  FromSourceKeyValueConfiguration: "ရင်းမြစ် ကီး တန်ဖိုး စီမံခန့်ခွဲမှု",
  Services: "ဝန်ဆောင်မှု",
  DescriptionisAlreadyenteredatLine:
    "ဖော်ပြချက်သည် သင်္ကွင်း {0} တွင် ရှိပြီးဖြစ်သည်",
  AllowDisallowReq: "ခွင့်ပြု/မခွင့်ပြု*",
  ResponseKeyValue: "တုံ့ပြန်မှု ကီး တန်ဖိုး",
  ResponseKey: "တုံ့ပြန်မှု ကီး",
  ResponseKeyValueReq: "တုံ့ပြန်မှု ကီး တန်ဖိုး*",
  EnterResponseKeyValue: "တုံ့ပြန်မှု ကီး တန်ဖိုးကို ရိုက်ထည့်ပါ",

  // Card Activate/Deactivate Status Configuration
  CardActivateDeactivateStatusConfiguration:
    "ကတ် ဖွင့်/ပိတ် သည် အခြေအနေ စီမံခန့်ခွဲမှု",
  CardStatus: "ကတ် အခြေအနေ",
  OperationType: "လုပ်ဆောင်မှု အမျိုးအစား",
  StatusValue: "အခြေအနေ တန်ဖိုး",
  EnterStatusValue: "အခြေအနေ တန်ဖိုးကို ရိုက်ထည့်ပါ",
  EnableStatusReq: "ဖွင့်ရန် အခြေအနေ*",
  EnablestatusisAlreadyenteredatLine:
    "ဖွင့်ရန် အခြေအနေ သင်္ကွင်း {0} တွင် ရှိပြီးဖြစ်သည်",
  StatusValueReq: "အခြေအနေ တန်ဖိုး*",
  StatusValueisAlreadyenteredatLine:
    "အခြေအနေ တန်ဖိုး သင်္ကွင်း {0} တွင် ရှိပြီးဖြစ်သည်",

  // Product Display Name Configuration
  ProductDisplayNameConfiguration: "ထုတ်ကုန် ပြသမှု အမည် စီမံခန့်ခွဲမှု",
  DisplayName: "ပြသမှု အမည်",
  Enterdisplayname: "ပြသမှု အမည်ကို ရိုက်ထည့်ပါ",
  CompanyCode: "ကုမ္ပဏီ ကုဒ်",
  SchemeCodeCardBINReq: "စီမံကိန်း ကုဒ်/ကတ် BIN*",
  EnterschemecodeCarBINno: "စီမံကိန်း ကုဒ်/ကတ် BIN နံပါတ်ကို ရိုက်ထည့်ပါ",
  SchemeCodeCardBINNoisAlreadyenteredatLine:
    "စီမံကိန်း ကုဒ်/ကတ် BIN နံပါတ် သင်္ကွင်း {0} တွင် ရှိပြီးဖြစ်သည်",
  SchemeNameReq: "စီမံကိန်း အမည်*",
  Enterschemename: "စီမံကိန်း အမည်ကို ရိုက်ထည့်ပါ",

  // Application Version Master
  ApplicationVersionMaster: "အက်ပလီကေးရှင်း ဗားရှင်း မဟာဌာန",
  DeviceOS: "ကိရိယာ O.S.",
  Version: "ဗားရှင်း",
  PopupMessage: "ပြ Popup ဆက်ဆံရေး",
  ForceUpdate: "အက်လက်အပ်နှံ ပြောင်းလဲမှု",
  EnterVersion: "ဗားရှင်းကို ရိုက်ထည့်ပါ",

  // Page Content Configuration
  PageContentConfiguration: "စာမျက်နှာ အကြောင်းအရာ စီမံခန့်ခွဲမှု",
  DetailsID: "အသေးစိတ် ID",
  EnterDetailsID: "အသေးစိတ် ID ကို ရိုက်ထည့်ပါ",
  LanguageCode: "ဘာသာစကား ကုဒ်",
  LanguageID: "ဘာသာစကား ID",
  EnterLanguageID: "ဘာသာစကား ID ကို ရိုက်ထည့်ပါ",
  DetailData: "အသေးစိတ် အချက်အလက်",
  EnterDetailData: "အသေးစိတ် အချက်အလက်ကို ရိုက်ထည့်ပါ",

  // Virtual Card Product Type Configuration
  VirtualCardProductTypeConfiguration:
    "ဗျူဟာကတ် ထုတ်ကုန် အမျိုးအစား စီမံခန့်ခွဲမှု",
  ProductType: "ထုတ်ကုန် အမျိုးအစား",
  CardProductBIN: "ကတ် ထုတ်ကုန် BIN",
  EnterCardProductBIN: "ကတ် ထုတ်ကုန် BIN ကို ရိုက်ထည့်ပါ",
  ProductID: "ထုတ်ကုန် ID",
  EnterProductID: "ထုတ်ကုန် ID ကို ရိုက်ထည့်ပါ",
  ProductName: "ထုတ်ကုန် အမည်",
  EnterProductName: "ထုတ်ကုန် အမည်ကို ရိုက်ထည့်ပါ",
  VerifiedBy: "အတည်ပြုသူ",
  VerifiedDate: "အတည်ပြုချိန်",
  VirtualCardProductTypeConfigurationConfirmation:
    "ဗျူဟာကတ် ထုတ်ကုန် အမျိုးအစား စီမံခန့်ခွဲမှု အတည်ပြုချက်",
  CardLimit: "ကတ် ကန့်သတ်",
  EnterCardLimit: "ကတ် ကန့်သတ်ကို ရိုက်ထည့်ပါ",
  FinancialProfile: "ဘဏ္ဍာရေး ပရိုဖိုင်း",
  EnterFinancialProfile: "ဘဏ္ဍာရေး ပရိုဖိုင်းကို ရိုက်ထည့်ပါ",
  LimitCurrency: "ကန့်သတ် ငွေကြေး",
  LimitGroup: "ကန့်သတ် အဖွဲ့",
  EnterLimitGroup: "ကန့်သတ် အဖွဲ့ကို ရိုက်ထည့်ပါ",
  RMCode: "RM ကုဒ်",
  EnterRMCode: "RM ကုဒ်ကို ရိုက်ထည့်ပါ",
  AllowInIntroductionPage: "မိတ်ဆက် စာမျက်နှာတွင် ခွင့်ပြုပါ",
  VirtualCardProductTypeDetails: "ဗျူဟာကတ် ထုတ်ကုန် အမျိုးအစား အသေးစိတ်",
  SchemeCodeReq: "စီမံကိန်း ကုဒ်*",
  SchemecodeandConstitutionalreadyexistsatline:
    "စီမံကိန်း ကုဒ်နှင့် ဖွဲ့စည်းပုံ သင်္ကွင်း {0} တွင် ရှိပြီးဖြစ်သည်",
  ConstitutionReq: "ဖွဲ့စည်းပုံ*",
  EnterConstitution: "ဖွဲ့စည်းပုံကို ရိုက်ထည့်ပါ",

  // Customer Wise Limit Modification Confirmation
  CustomerWiseLimitModificationConfirmation:
    "ဖောက်သည်အရ ကန့်သတ် ပြင်ဆင်မှု အတည်ပြုချက်",
  CustomerName: "ဖောက်သည် အမည်",
  UserWiseLimitConfirmation: "အသုံးပြုသူအရ ကန့်သတ် အတည်ပြုချက်",
  UserWiseLimitConfiguration: "အသုံးပြုသူအရ ကန့်သတ် စီမံခန့်ခွဲမှု",
  Retry: "ပြန်လည် ကြိုးစားပါ",
  CustomerDetails: "ဖောက်သည် အသေးစိတ်",
  CardMinimumAmt: "ကတ် အနည်းဆုံး ငွေတောင်း",
  MaximumAmountReq: "အများဆုံး ငွေတောင်း*",
  MinimumAmountReq: "အနည်းဆုံး ငွေတောင်း*",
  DailyLimitReq: "နေ့စဉ် ကန့်သတ်*",
  Thistypealreadyexists: "ဒီအမျိုးအစားသည် ရှိပြီးဖြစ်သည်။",

  // Customer Activation
  CustomerActivation: "ဖောက်သည် ဖွင့်ခြင်း",
  ActivationUsing: "ဖွင့်ခြင်း အသုံးပြုသည်",
  SelectOption: "ရွေးချယ်မှုကို ရွေးပါ",
  ClientID: "Client ID",
  EnterClientID: "Client ID ကို ရိုက်ထည့်ပါ",
  CardNumber: "ကတ် နံပါတ်",
  EnterCardNumber: "ကတ် နံပါတ်ကို ရိုက်ထည့်ပါ",
  RegWith: "မှတ်ပုံတင်ခြင်း",
  RegAccount: "မှတ်ပုံတင်ထားသော အကောင့်",
  Name: "အမည်",
  BirthDate: "မွေးနေ့",
  EMailAddress: "အီးမေးလ် လိပ်စာ",
  NoteAfterconfirmationtemporarypasswordwillbesenttotheregisteredmobilenumber:
    "မှတ်ချက်: အတည်ပြုခြင်းပြီးနောက် အချိန်လိုအပ်သောစကားဝှက်သည် မှတ်ပုံတင်ထားသော မိုဘိုင်းနံပါတ်သို့ပို့မည်။",
  FetchDetails: "အသေးစိတ် ရယူပါ",
  AccountCardNumber: "အကောင့်/ကတ် နံပါတ်",
  CustomerID: "ဖောက်သည် ID",
  EnterCustomerID: "ဖောက်သည် ID ကိုထည့်ပါ။",
  Constitution: "ဖွဲ့စည်းပုံ",
  AccountTypeName: "အကောင့် အမျိုးအစား အမည်",
  Gender: "လိင်",
  FatherName: "ဖခင် အမည်",
  MotherName: "မေ အမည်",
  LinkedAccount: "ချိတ်ဆက်ထားသော အကောင့်",
  FullName: "အပြည့်အစုံ အမည်",
  TINNumber: "TIN နံပါတ်",
  NationalID13Digit: "နိုင်ငံသား ID ၁၃ ဒစ်ဂျစ်",
  ModeOfOperation: "လုပ်ငန်းဆောင်ရွက်မှု နည်းလမ်း",
  Nationality: "နိုင်ငံသား",
  NationalID: "နိုင်ငံသား ID",
  IdentificationNumber: "အတည်ပြုနံပါတ်",
  CustomerCardDetails: "ဖောက်သည် ကတ် အသေးစိတ်",
  CardDetails: "ကတ် အသေးစိတ်",
  CustomerActivationConfirmation: "ဖောက်သည် ဖွင့်ခြင်း အတည်ပြုချက်",
  RequestDate: "တောင်းဆိုချိန်",
  RequestNumber: "တောင်းဆိုနံပါတ်",
  RequestBy: "တောင်းဆိုသူ",
  accountCardType: "အကောင့် ကတ်/အမျိုးအစား",

  // Customer Searching
  CustomerSearching: "ဖောက်သည် ရှာဖွေမှု",
  GetDetails: "အသေးစိတ် ရယူပါ",
  ClientIDCBNumber: "ဖောက်သည် ID/CB",
  TIN: "TIN",
  NoteAllFieldscontainawildsearchfacility:
    "မှတ်ချက်: အစိတ်အပိုင်းများသည် ရှာဖွေရန် လွတ်လပ်မှုရှိသည်။",
  Pleaseenteravalidemailaddress:
    "ကျေးဇူးပြု၍ မှန်ကန်သော အီးမေးလ် လိပ်စာကို ရိုက်ထည့်ပါ",
  PrimaryAccountCardNumber: "မူလ အကောင့်/ကတ် နံပါတ်",
  PrimaryCBNumber: "မူလ CB နံပါတ်",
  PrimarySource: "မူလ အရင်းအမြစ်",
  AdminRemarks: "အုပ်ချုပ်ရေးမှတ်ချက်",
  AuthFlag: "အာဏာ Flag",
  LimitModification: "ကန့်သတ် ပြင်ဆင်မှု",
  CurrentRelationshipData: "လက်ရှိ ဆက်နွယ်မှု အချက်အလက်",
  Restrict: "ကန့်သတ်",
  Unlock: "ဖွင့်ပါ",
  Remarks: "မှတ်ချက်",
  EnterRemarks: "မှတ်ချက်ကို ရိုက်ထည့်ပါ",
  TransactionTypeReq: "ငွေလှိုက်လှိုင် အမျိုးအစား*",
  Dailylimitshouldbelessthanweeklylimit:
    "နေ့စဉ် ကန့်သတ်သည် အပတ်စဉ် ကန့်သတ်ထက် သန့်ရှင်းရမည်။",
  DailylimitshouldbelessthanMonthlylimit:
    "နေ့စဉ် ကန့်သတ်သည် လစဉ် ကန့်သတ်ထက် သန့်ရှင်းရမည်။",
  WeeklyLimitshouldbemorethenDailyLimit:
    "အပတ်စဉ် ကန့်သတ်သည် နေ့စဉ် ကန့်သတ်ထက် ပိုရမည်။",
  PasswordReset: "စကားဝှက် ပြန်လည် ပြင်ဆင်မှု",
  CBNumber: "CB နံပါတ်",
  IdentificationNo: "အတည်ပြုနံပါတ်",
  DoyouwanttoPasswordReset: "သင် စကားဝှက် ပြန်လည် ပြင်ဆင်ရန် ဆန္ဒရှိပါသလား?",
  RefreshCustomerRelationshipData:
    "ဖောက်သည် ဆက်နွယ်မှု အချက်အလက်ကို သစ်လွင်စေပါ",
  FetchData: "အချက်အလက် ရယူပါ",
  PrimaryAccountCard: "မူလ အကောင့်/ကတ်",
  LastLoginDate: "နောက်ဆုံး လော့ဂ်အင် ချိန်",
  PasswordChangeDate: "စကားဝှက် ပြောင်းလဲချိန်",

  RestrictionRemarks: "ကန့်သတ် မှတ်ချက်",
  UnlockingRemarks: "ဖွင့်ခြင်းမှတ်ချက်",
  UpdateData: "အချက်အလက် ကို အသစ်ပြုလုပ်ပါ",

  // Password Reset Confirmation
  PasswordResetConfirmation: "စကားဝှက် ပြန်လည် ပြင်ဆင်မှု အတည်ပြုချက်",
  AcceptRemarks: "လက်ခံမှတ်ချက်",
  RejectionRemarks: "မလက်ခံမှတ်ချက်",

  // Primary Identifier Change
  PrimaryIdentifierChange: "မူလ အိုင်ဒင်တီဖိုင်ယား ပြောင်းလဲမှု",
  Search: "ရှာဖွေပါ",
  SignUpWith: "မှတ်ပုံတင်ရန်",
  PrimaryIdentifierChangeConfirmation:
    "မူလ အိုင်ဒင်တီဖိုင်ယား ပြောင်းလဲမှု အတည်ပြုချက်",
  OldPrimarySource: "ဟောင်းသော မူလ အရင်းအမြစ်",
  NewPrimarySource: "သစ်သော မူလ အရင်းအမြစ်",
  OldCBNumber: "ဟောင်းသော CB နံပါတ်",
  NewCBNumber: "သစ်သော CB နံပါတ်",
  OldCardAccountNumber: "ဟောင်းသော ကတ်/အကောင့် နံပါတ်",
  NewCardAccountNumber: "သစ်သော ကတ်/အကောင့် နံပါတ်",

  SetAsPrimary: "မူလ အမျိုးအစား အဖြစ် သတ်မှတ်ပါ",
  DoyouwanttosetthisaccountcardasaPrimaryIdentifier:
    "သင်ဤအကောင့်/ကတ်ကို မူလ အိုင်ဒင်တီဖိုင်ယား အဖြစ် သတ်မှတ်လိုပါသလား?",

  // CIB Loan Request Check
  CIBLoanRequestCheck: "CIB ချေးငွေ တောင်းဆိုမှု စစ်ဆေးမှု",
  LoanRequestCheck: "ချေးငွေ တောင်းဆိုမှု စစ်ဆေးမှု",
  FileNumber: "ဖိုင် နံပါတ်",
  ApplicantName: "တင်ပြသူ အမည်",
  TDAccount: "TD အကောင့်",
  LoanAmount: "ချေးငွေ အရောင်း",
  EMIAmount: "EMI အရောင်း",
  LockBy: "ချိတ်ဆက်သူ",
  CIBCalculationView: "CIB တွက်ချက်မှု | ကြည့်ရန်",
  AppliedLoanamount: "တင်ပြထားသော ချေးငွေ",
  ProposedEMIamount: "အကြံပြု EMI အရောင်း",
  AppliedTenor: "တင်ပြထားသော သက်တမ်း",
  DOB: "မွေးနေ့",
  DistrictofBirth: "မွေးရာ နယ်မြေ",
  NID: "NID",
  ETINNumber: "E-TIN နံပါတ်",
  SmartCardNumber: "စမတ် ကတ် နံပါတ်",
  SpouseName: "ဇနီး/ချစ်သူ အမည်",
  PermanentAddress: "အမြဲတမ်း လိပ်စာ",
  PresentAddress: "လက်ရှိ လိပ်စာ",
  CIBUserInformation: "CIB အသုံးပြုသူ အချက်အလက်",
  CIBStatus: "CIB အခြေအနေ",
  Pleaseselectstatus: "ကျေးဇူးပြု၍ အခြေအနေ ရွေးချယ်ပါ",
  DateRange: "ရက်စွဲ အပိုင်း",
  YouCantviewthisRequest: "သင်ဤတောင်းဆိုမှုကို မျှဝေပေး၍ မရပါ။",
  FileUploadRequired: "ဖိုင် ကို တင်ရန် လိုအပ်ပါသည်။",
  DoYouwanttoacceptLoanRequest: "သင် ချေးငွေ တောင်းဆိုမှုကို လက်ခံလိုပါသလား?",
  Decline: "ပယ်ချ",

  // Loan Closure Request
  LoanClosureRequest: "ချေးငွေ ပိတ်သိမ်းမှု တောင်းဆိုမှု",
  LoanAccount: "ချေးငွေ အကောင့်",
  FromAccount: "အကောင့်မှ",
  ClosureDate: "ပိတ်သိမ်းမှု ရက်စွဲ",
  Amount: "ပမာဏ",
  CreditAccount: "ငွေလွှဲ အကောင့်",
  Outstanding: "ကျန်ရှိသောငွေ",
  ClosingFee: "ပိတ်သိမ်းခြင်းကြေး",
  VAT: "VAT",
  TOTALAMOUNT: "စုစုပေါင်း ပမာဏ",

  // Tag Account Request
  TagAccountRequest: "အကောင့်ကို တာဝင်ဆိုင်မှု တောင်းဆိုမှု",
  RequestType: "တောင်းဆိုမှု အမျိုးအစား",
  TagCreditCardRequest: "တင်ဒါအကောင့် တောင်းဆိုမှု",
  SearchingParameters: "ရှာဖွေရန် အချက်အလက်များ",
  AppliedFilters: "သုံးစွဲထားသော စိစစ်မှုများ",

  // Loan Release Lock Request
  LoanReleaseLockRequest: "ချေးငွေ ဖွင့်ခြင်း အကာအကြယ် တောင်းဆိုမှု",
  FDAccount: "FD အကောင့်",
  RequestReleasedSuccessfully: "တောင်းဆိုမှု အောင်မြင်စွာ ဖြုတ်ပြီးပါပြီ။",
  AreYouSuretoReleaseLockedRequest:
    "သင် အတားအကွေးထားသော တောင်းဆိုမှုကို ဖြုတ်လိုပါသလား?",

  // From Source Key Template
  FromSourceKeyTemplate: "အရင်းအမြစ် သုတေသန အချက်အလက်",
  SettoFromSource: "အရင်းအမြစ်ကို သတ်မှတ်ပါ",
  ResponseValue: "ပြန်လည် တုံ့ပြန်မှု အကြောင်းအရာ*",
  EnterResponseValue: "ပြန်လည် တုံ့ပြန်မှု အကြောင်းအရာကို ရိုက်ထည့်ပါ",
  TemplateSetAs: "နမူနာ သတ်မှတ်ခြင်း",
  CurrentConfig: "လက်ရှိ စီစဉ်မှု",
  SetFromSourceKeyTemplateOf: "အရင်းအမြစ် သုတေသန အချက်အလက် သတ်မှတ်ပါ",

  // Account Deletion Request For Checker
  AccountDeletionRequestForChecker:
    "အကောင့် ပယ်ဖျက်ရန် တောင်းဆိုမှု (စစ်ဆေးသူ)",
  PrimaryAccount: "မူလ အကောင့်",
  PrimaryCBNo: "မူလ CB နံပါတ်",
  DeletionReason: "ပယ်ဖျက်မှု အကြောင်းပြချက်",
  RejectRemarks: "မလက်ခံသော မှတ်ချက်",

  // Account Deletion Request For Approval
  AccountDeletionRequestForApproval:
    "အကောင့် ပယ်ဖျက်ရန် တောင်းဆိုမှု (အတည်ပြုရန်)",
  AcceptedBy: "လက်ခံသူ",
  CheckerAcceptDate: "ပါဝင်လာပါတယ်။ လက်ခံ ရက်စွဲ",
  CheckerRemarks: "ပါဝင်လာပါတယ်။ မှတ်ချက်",

  // Rooted Device Repository Allow/Disallow
  RootedDeviceRepositoryAllowDisallow:
    "အမြစ်တွယ် စက်ပစ္စည်း သိုလှောင်မှု ခွင့်ပြု/မခွင့်ပြု",
  RootedDeviceRepository: "အမြစ်တွယ် စက်ပစ္စည်း သိုလှောင်မှု",
  DeviceID: "စက်ပစ္စည်း ID",
  DevicesOS: "စက်ပစ္စည်း O.S.",
  DeviceName: "စက်ပစ္စည်း အမည်",
  DeviceUserName: "စက်ပစ္စည်း အသုံးပြုသူ အမည်",
  DeviceIP: "စက်ပစ္စည်း IP",
  AppVersion: "အက်ပ်ဗားရှင်း",
  DeviceIMEI: "စက်ပစ္စည်း IMEI",
  Maker: "ပြုလုပ်သူ",
  MakerRemark: "ပြုလုပ်သူ မှတ်ချက်",
  Checker: "ပါဝင်လာပါတယ်။",
  CheckerRemark: "ပါဝင်လာပါတယ်။ မှတ်ချက်",
  Disallow: "မခွင့်ပြု",
  Allow: "ခွင့်ပြု",
  AllowRemarks: "ခွင့်ပြုမှတ်ချက်",
  DisallowRemarks: "မခွင့်ပြုမှတ်ချက်",
  RootedDeviceAllowDisallowConfirmation:
    "Rooted Device ခွင့်ပြု/မခွင့်ပြု အတည်ပြုချက်",
  ConfirmationRemarks: "အတည်ပြု မှတ်ချက်",

  // Corporate User Registration Entry
  CorporateUserRegistrationEntry: "ကုမ္ပဏီ အသုံးပြုသူ မှတ်ပုံတင်မှု",
  DomainName: "ဒိုမိန်း အမည်",
  RegDate: "မှတ်ပုံတင် ရက်စွဲ",
  ACNo: "အကောင့် နံပါတ်",
  Sign: "လက်မှတ်",
  OwnAC: "ပိုင်ဆိုင်သော အကောင့်",
  SanctionAmount: "ခွင့်ပြုသော ပမာဏ",
  WithinBank: "ဘဏ်အတွင်း",
  EFT: "EFT",
  IMPS: "IMPS",
  UtilityBillPayment: "ဝန်ဆောင်မှု ဘယ်ခွန်များ ပေးဆောင်မှု",
  PaymentGetway: "ငွေပေးချေမှု လမ်းကြောင်း",
  FromAmounts: "မှ ပမာဏ",
  ToAmounts: "သို့ ပမာဏ",
  ByNumberofUser: "အသုံးပြုသူ အရေအတွက်",
  CustomerType: "ဖောက်သည် အမျိုးအစား",
  PersonName: "ပုဂ္ဂိုလ် အမည်",
  Document: "စာရွက်စာတမ်း",
  DocumentNo: "စာရွက်စာတမ်း နံပါတ်",
  UploadDocument: "စာရွက်စာတမ်း တင်ပါ",
  ViewDocument: "စာရွက်စာတမ်း ကြည့်ပါ",
  AuthLetter: "အာမခံစာ",
  ViewAuthLetter: "အာမခံစာ ကြည့်ပါ",
  Deactive: "ပိတ်ပါ",
  DeactiveReason: "ပိတ်သိမ်းမှု အကြောင်းပြချက်",
  UserRights: "အသုံးပြုသူ အခွင့်အရေး",
  PanNo: "PAN နံပါတ်",
  UserLimit: "အသုံးပြုသူ ကန့်သတ်",
  ViewOnly: "ကြည့်ရှုရန်သာ",
  PerDayLimit: "နေ့စဉ် ကန့်သတ်",
  SpecialAuthorized: "သီးသန့် ခွင့်ပြု",
  CorporateUserRegistration: "ကုမ္ပဏီ အသုံးပြုသူ မှတ်ပုံတင်မှု",
  PerDayMaxLimit: "နေ့စဉ် အမြင့်ဆုံး ကန့်သတ်",
  Limit: "ကန့်သတ်",
  ControllingPerson: "ထိန်းချုပ်သူ",
  CorporateFinanceDepartment: "ကုမ္ပဏီ ငွေကြေးဌာန",
  AccountMapping: "အကောင့် သွယ်ဝိုင်းခြင်း",
  AuthenticationWorkflow: "အတည်ပြုခြင်း လမ်းကြောင်း",
  EffectiveDailyLimit: "ထိရောက်သော နေ့စဉ် ကန့်သတ်",
  LimitAmount: "ကန့်သတ် ပမာဏ",

  // Admin Panel User Maintenance
  AdminPanelUserMaintenance: "အက်မင် ပွဲခင်း အသုံးပြုသူ စီမံခန့်ခွဲမှု",
  UserGroupName: "အသုံးပြုသူ အဖွဲ့ အမည်",
  GroupName: "အဖွဲ့ အမည်",
  AllowRelease: "ထုတ်လွှတ်ခွင့်ပြု",
  UserSubtype: "အသုံးပြုသူ အမျိုးအစား",
  NotificationTemplate: "အသိပေးမှု နမူနာ",
  ConfirmedStatus: "အတည်ပြုထားသော အခြေအနေ",
  AdminPanelUserConfirmation: "အက်မင် ပွဲခင်း အသုံးပြုသူ အတည်ပြုမှု",
  UserLevel: "အသုံးပြုသူ အဆင့်",
  EnterUserID: "အသုံးပြုသူ ID ကို ရိုက်ထည့်ပါ",
  EnterUserfullnamehere: "အသုံးပြုသူ အမည်အပြည့်ကို ရိုက်ထည့်ပါ",
  ConfirmPasswordValidation: "သစ်စကားဝှက်နှင့် အတည်ပြုစကားဝှက် မညီညွတ်ပါ",
  ChangePasswordValidation:
    "စကားဝှက်သည် အက္ခရာနှင့် နံပါတ်များရောနှောထားပြီး အထက်ဆုံး ၁ လုံး၊ အောက်ဆုံး ၁ လုံးနှင့် အထူးအက္ခရာ ၁ လုံးပါရှိရမည်။",
  NewPassword: "သစ်စကားဝှက်",
  ConfirmPassword: "အတည်ပြုစကားဝှက်",
  InactiveDate: "မသုံးသော ရက်စွဲ",
  UpdateDetails: "အသေးစိတ် အပ်ဒိတ်လုပ်ပါ",
  AdminUserConfirmation: "အက်မင် အသုံးပြုသူ အတည်ပြုမှု",
  ConfirmationColumnDetails: "အတည်ပြုခြင်း အထူးစာရင်း အသေးစိတ်",
  OldValue: "ဟောင်းသော တန်ဖိုး",
  LabelName: "အတံဆိပ် အမည်",
  NewValue: "သစ်သော တန်ဖိုး",
  MakerDate: "ပြုလုပ်သူ ရက်စွဲ",
  MobileNoisrequired: "ဖုန်းနံပါတ် လိုအပ်သည်",

  // Admin Panel User Release
  AdminPanelUserRelease: "အက်မင် ပွဲခင်း အသုံးပြုသူ ထုတ်လွှတ်မှု",
  LoginTime: "ဝင်ရောက်ချိန်",
  Operation: "လုပ်ဆောင်မှု",
  LoginDateTime: "ဝင်ရောက်ရက်နှင့် အချိန်",
  BlockedReason: "တားဆီးရသော အကြောင်းပြချက်",
  LogoutDateTime: "ထွက်ရက်နှင့် အချိန်",
  ViewAll: "အားလုံး ကြည့်ပါ",
  ReleaseBlockedUser: "တားဆီးထားသော အသုံးပြုသူကို ထုတ်လွှတ်ပါ",
  ReleaseUsers: "အသုံးပြုသူများကို ထုတ်လွှတ်ပါ",
  Userissuccessfullyreleased: "အသုံးပြုသူကို အောင်မြင်စွာ ထုတ်လွှတ်ပါပြီ",
  Loggedin: "ဝင်ရောက်ပြီး",
  WouldyouliketoreleasetheselectedBlockedUsers:
    "ရွေးချယ်ထားသော တားဆီးထားသော အသုံးပြုသူများကို ထုတ်လွှတ်လိုပါသလား?",
  WouldyouliketoreleasetheselectedLoggedinUsers:
    "ရွေးချယ်ထားသော ဝင်ရောက်ပြီးသော အသုံးပြုသူများကို ထုတ်လွှတ်လိုပါသလား?",
  ReleaseBlockedUsers: "တားဆီးထားသော အသုံးပြုသူများကို ထုတ်လွှတ်ပါ",
  AdminPanelBlockedUserRelease:
    "အက်မင် ပွဲခင်း တားဆီးထားသော အသုံးပြုသူ ထုတ်လွှတ်မှု",
  BlockedUserName: "တားဆီးထားသော အသုံးပြုသူ အမည်",
  FailureAttemptCount: "မအောင်မြင်သော ကြိုးစားမှု အရေအတွက်",
  ListofFailedLoginAttempts: "မအောင်မြင်သော ဝင်ရောက်ကြိုးစားမှုများ စာရင်း",
  UserFailedAttemptDetails: "အသုံးပြုသူ မအောင်မြင်သော ကြိုးစားမှု အသေးစိတ်",
  ReleaseReason: "ထုတ်လွှတ်မှု အကြောင်းပြချက်",
  ApplicationSessionID: "အက်ပလီကေးရှင်း ဆက်သွယ်မှု ID",

  // Screen Access Rights
  ScreenAccessRights: "စာမျက်နှာ ဝင်ခွင့် အခွင့်အရေး",
  GroupNames: "အဖွဲ့အမည်များ",
  AccessDetail: "ဝင်ခွင့် အသေးစိတ်",
  Groups: "အဖွဲ့များ",
  Users: "အသုံးပြုသူများ",
  Youcannotmodifyyourownrights:
    "သင့်ကိုယ်ပိုင် အခွင့်အရေးကို မပြောင်းလဲနိုင်ပါ။",
  AreyouwanttopopulateitsGroupRight:
    "သင်သည် ၎င်း၏ အဖွဲ့ အခွင့်အရေးကို ဖျော်ဖြေရန် မျှော်လင့်ပါသလား?",
  MenuList: "မီနူး စာရင်း",
  PendingScreenAccess: "စောင့်ဆိုင်း中的 ဝင်ခွင့်",
  CurrentScreenAccess: "ယခု ဝင်ခွင့်",
  AssignUserGroupRights: "အသုံးပြုသူ/အဖွဲ့ အခွင့်အရေး သတ်မှတ်ပါ",
  CarryForwardScreenRightsFrom: "စာမျက်နှာ အခွင့်အရေးများကို ယာယီ ပြောင်းပါ",
  YoucannotCarryForwardRightsforsameuser:
    "သင်သည် တစ်ဦးတည်းသော အသုံးပြုသူအတွက် အခွင့်အရေးများကို ယာယီ မပြောင်းနိုင်ပါ။",
  AssignUserGroupRightsTo: "အသုံးပြုသူ/အဖွဲ့ အခွင့်အရေးကို သတ်မှတ်ပါ ",
  FastForward: "မြန်မြန်နှင့် မြန်မြန်",
  FastRewind: "မြန်မြန် အရှေ့ပြန်",
  ScreenAccessRightsOf: "{0} အသုံးပြုသူ၏ စာမျက်နှာ ဝင်ခွင့် အခွင့်အရေးများ",
  User: "အသုံးပြုသူ",

  // Admin Panel User Group
  AdminPanelUserGroupCreation:
    "စီမံခန့်ခွဲသူအုပ်စု အသုံးပြုသူအုပ်စု ဖန်တီးခြင်း။",
  NoofScreenstodisplayunderRecentOption:
    "Recent Option အောက်တွင် ပြသမည့် စာမျက်နှာအရေအတွက်",
  LoginPasswordForceExpiryDays: "ဝင်ရောက်စကားဝှက် မတုန်းက အဆုံးသတ်ရက်များ",
  EnterLoginPasswordForceExpiryDays:
    "ဝင်ရောက်စကားဝှက် မတုန်းက အဆုံးသတ်ရက်များကို ရိုက်ထည့်ပါ",
  AdminUserGroupMaintenance: "အက်မင် အသုံးပြုသူ အဖွဲ့ စီမံခန့်ခွဲမှု",
  EnterUserGroupName: "အသုံးပြုသူ အဖွဲ့ အမည်ကို ရိုက်ထည့်ပါ",
  NoofScreensunderRecentOption: "Recent Option အောက်တွင် စာမျက်နှာအရေအတွက်",
  EnterNoofScreensunderRecentOption:
    "Recent Option အောက်တွင် စာမျက်နှာအရေအတွက်ကို ရိုက်ထည့်ပါ",
  UserGroup: "အသုံးပြုသူ အဖွဲ့",

  // Admin User Notification Template
  AdminUserNotificationTemplate: "အက်မင် အသုံးပြုသူ အသိပေးမှု နမူနာ",
  NotificationTemplateName: "အသိပေးမှု နမူနာ အမည်",
  AdminUserNotificationTemplateName: "အက်မင် အသုံးပြုသူ အသိပေးမှု နမူနာ အမည်",
  EnterAdminUserNotificationTemplateName:
    "အက်မင် အသုံးပြုသူ အသိပေးမှု နမူနာ အမည်ကို ရိုက်ထည့်ပါ",
  UserLoginIDReq: "အသုံးပြုသူ ဝင်ရောက် ID*",
  USERLoginIDisAlreadyenteredatLine:
    "USER ဝင်ရောက် ID သည် သင်္ကွင်းတွင် ရှိပြီးဖြစ်သည်",

  // Release Block Users
  ReleaseBlockUsers: "တားဆီးထားသော အသုံးပြုသူများကို ထုတ်လွှတ်ပါ",
  ReleaseTypeReq: "ထုတ်လွှတ်မှု အမျိုးအစား*",
  BlockTypeReq: "တားဆီးမှု အမျိုးအစား*",
  BlockDate: "တားဆီးရက်စွဲ",
  BlockReason: "တားဆီးရသော အကြောင်းပြချက်",
  ReleaseCardPINBlockUsers:
    "ကတ် PIN တားဆီးထားသော အသုံးပြုသူများကို ထုတ်လွှတ်ပါ",
  ActivityType: "လုပ်ဆောင်မှု အမျိုးအစား",
  Details: "အသေးစိတ်",
  Areyousureyouwanttorelease: "သင်ထုတ်လွှတ်လိုသည်မှာ အတည်ပြုပါသလား",
  ReleasePGWBlockUsers: "PGW တားဆီးထားသော အသုံးပြုသူများကို ထုတ်လွှတ်ပါ",
  Fetch: "ယူပါ",

  // DBR Loan Request Check
  DBRLoanRequestCheck: "DBR ချေးငွေ မျှော်မှန်းခြေ စစ်ဆေးမှု",
  CustomerLoanRequestInformation: "အသုံးပြုသူ ချေးငွေ မျှော်မှန်းခြေ အချက်အလက်",
  Profession: "ပညာ၊ အလုပ်",
  NetMonthlyIncomeA: "စစ်မှန်သော လစဉ် ဝင်ငွေ (A)",
  TDAccountNumber: "TD အကောင့် နံပါတ်",
  TenorMonth: "ချေးချိန် (လ)",
  TDAmountC: "TD ပမာဏ (C)",
  RateofInterest: "စိုးရိမ်မှု အခြေအနေ",
  EMIB: "EMI (B)",
  AccountforEncashEMI: "EMI ဖြင့် ငွေချေးသည့် အကောင့်",
  DBRBA: "DBR (B/A)%",
  LoanRequestRecommendedInformation:
    "ချေးငွေ မျှော်မှန်းခြေ အကြံပြုထားသော အချက်အလက်",
  LoanAmountD: "ချေးငွေ ပမာဏ (D)",
  OtherLoanInstF: "အခြား ချေးငွေ လစဉ် (F)",
  CreditCardlimitG: "เครดิตကတ် အကန့်အသတ် (G)",
  DBRF5ofGA100: "DBR% ((F + 5% of G)/A)*100",
  EMIE: "EMI (E)",
  LTVDC: "LTV% (D/C)",
  FinalLoanAmountLTVC: "နောက်ဆုံး ချေးငွေ ပမာဏ (LTV * C)",
  CIBRemarks: "CIB မှ မှတ်ချက်များ",
  MessagefromDBR: "DBR မှ သတင်းစာ",
  DBRRemarks: "DBR မှ မှတ်ချက်များ",
  Requesthasalreadybeenprocessed: "တောင်းဆိုချက်သည် ရှိပြီးဖြစ်သည်။",
  ViewDocuments: "စာရွက်စာတမ်းများကို ကြည့်ပါ",

  // Loan Approval Detail
  LoanApprovalDetail: "ချေးငွေ အတည်ပြုချက် အသေးစိတ်",
  LoanApprovalRequestDetails: "ချေးငွေ အတည်ပြုချက် တောင်းဆိုချက် အသေးစိတ်",
  FileReferenceNo: "ဖိုင် အညွှန်း နံပါတ်",
  SecurityValueTDAmount: "လုံခြုံရေး တန်ဖိုး/TD ပမာဏ",
  AssessedbyDBRID: "သုံးသပ်ချက်ဖြင့်/DBR ID",
  AssessedbyDBRName: "သုံးသပ်ချက်ဖြင့်/DBR အမည်",
  AssessedDate: "သုံးသပ်ခဲ့သော ရက်စွဲ",
  LTV: "LTV%",
  NetMonthlyIncome: "စစ်မှန်သော လစဉ် ဝင်ငွေ",
  Tenor: "ချေးချိန်",
  OtherLoanInstallment: "အခြား ချေးငွေ လစဉ်",
  CreditCardlimit: "เครดิตကတ် အကန့်အသတ်",
  EMI: "EMI",
  DBR: "DBR",
  SOLID: "SOL ID",
  FinalLoanAmount: "နောက်ဆုံး ချေးငွေ ပမာဏ",
  MessageFromApproval: "အတည်ပြုမှုမှ သတင်းစာ",

  // Enter Retrieval Parameters
  EnterRetrievalParameters: "ထုတ်ယူမှု အချက်အလက်များကို ရိုက်ထည့်ပါ",
  ToDateshouldbegreaterthanorequaltoFromDate:
    "သို့ရက်သည် သက်မှတ်သော ရက်ထက် ကြီးရမည် သို့မဟုတ် ညီရမည်။",
  FromDateshouldbelessthanorequaltoToDate:
    "မှစရက်သည် သက်မှတ်သော ရက်ထက် သေးရမည် သို့မဟုတ် ညီရမည်။",
  today: "ယနေ့",
  accept: "လက်ခံ",
  cancel: "မဆက်လုပ်ပါ",

  // REPORT
  RetrievalParameters: "ထုတ်ယူမှု အချက်အလက်များ",
  Searched: "ရှာဖွေခြင်း",
  records: "မှတ်တမ်းများ",
  showFilters: "စစ်ထုတ်ခြင်းများကို ပြပါ",
  ClearFilter: "စစ်ထုတ်ခြင်းကို သန့်စင်ပါ",
  ExpandRows: "စာကြောင်းများကို ဖွင့်ပါ",
  Export: "တင်ပို့ရန်",
  Showexportoptions: "တင်ပို့ရန် ရွေးချယ်မှုများကို ပြပါ",
  RetrieveData: "ဒေတာကို ထုတ်ယူပါ",
  RequiredValueMissingForLoginID: "Login ID အတွက် လိုအပ်သော တန်ဖိုး လွတ်လပ်သည်",
  rowswillbeexported: "စာကြောင်း(များ)သည် တင်ပို့မည်။",
  Nodatafoundtoexport: "တင်ပို့ရန် မရှိသော ဒေတာ",
  ReportExportStatus: "အစီရင်ခံစာ တင်ပို့ခြင်း အခြေအနေ",

  // Customer Registration Report
  CustomerRegistrationReport: "အသုံးပြုသူ စာရင်းသွင်းမှု အစီရင်ခံစာ",
  RegAccountCardNumber: "မှတ်ပုံတင် အကောင့်/ကတ် နံပါတ်",
  Source: "ရင်းမြစ်",
  AuthWith: "အတည်ပြုခြင်းဖြင့်",
  LastPassChange: "နောက်ဆုံး စကားဝှက်ပြောင်းလဲခြင်း",

  // User Login History
  UserLoginHistory: "အသုံးပြုသူ ဝင်ရောက်မှု သမိုင်း",
  LoginDate: "ဝင်ရောက်မှု ရက်စွဲ",
  LoginBy: "ဝင်ရောက်ခဲ့သူ",

  // Password Change History
  PasswordChangeHistory: "စကားဝှက် ပြောင်းလဲမှု သမိုင်း",
  PasswordModifyDate: "စကားဝှက် ပြောင်းလဲသည့် ရက်စွဲ",

  // User Activity
  UserActivity: "အသုံးပြုသူ လုပ်ဆောင်မှု",
  ActivityCode: "လုပ်ဆောင်မှု ကုဒ်",
  ActivityTime: "လုပ်ဆောင်မှု အချိန်",
  ActivityDescription: "လုပ်ဆောင်မှု ဖျော်ဖြေရန်",

  // Fund Transfer Transaction Details
  FundTransferTransactionDetails: "ငွေပေးချေမှု လုပ်ငန်းစဉ် အသေးစိတ်",
  TransactionStatus: "လုပ်ငန်းစဉ် အခြေအနေ",
  TransactionDate: "လုပ်ငန်းစဉ် ရက်စွဲ",
  VATAmount: "VAT ပမာဏ",
  FromSource: "မူလ အရင်းအမြစ်",
  FromACNo: "မှ A/C နံပါတ်",
  FromACName: "မှ A/C အမည်",
  ToACNo: "သို့ A/C နံပါတ်",
  ToACName: "သို့ A/C အမည်",
  ToIFSCCode: "သို့ IFSC ကုဒ်",
  ProcessDate: "လုပ်ငန်းစဉ် ရက်စွဲ",
  RefNo: "အညွှန်း နံပါတ်",
  OTPType: "OTP အမျိုးအစား",
  FromContactNo: "မှ ဆက်သွယ်ရန် နံပါတ်",
  FromEmailID: "မှ အီးမေးလ် ID",
  ToContactNo: "သို့ ဆက်သွယ်ရန် နံပါတ်",
  ToEmailID: "သို့ အီးမေးလ် ID",
  TransFlow: "လုပ်ငန်းစဉ် အဆင်း",
  NickName: "နာမည်သက်ရိုး",

  APIResponseDetailsReport: "API တုံ့ပြန်မှု အသေးစိတ် အစီရင်ခံစာ",
  ApiName: "API အမည်",
  RespCode: "တုံ့ပြန်မှု ကုဒ်",
  RefTranID: "အညွှန်း.လုပ်ငန်း ID",
  ResponseMessage: "တုံ့ပြန်မှု သတင်းစာ",
  ResponseDate: "တုံ့ပြန်မှု ရက်စွဲ",
  ExportReportform: "တင်ပို့ရန် အစီရင်ခံစာ ဖောင်",

  Selectfiletype: "ဖိုင် အမျိုးအစား ရွေးချယ်ပါ",
  Selectpagesize: "စာမျက်နှာ အရွယ်အစား ရွေးချယ်ပါ",
  Selectorientation: "လမ်းကြောင်း ရွေးချယ်ပါ",
  ShowHeader: "ခေါင်းစဉ် ပြပါ",
  ColumnstoExport: "တင်ပို့ရန် ကော်လံများ",
  TransactionParticularsDetail: "လုပ်ငန်းစဉ် အသေးစိတ်",
  Print: "ထုတ်ပုံ",
  ResponseDetail: "တုံ့ပြန်မှု အသေးစိတ်",

  TransactionRefNumber: "လုပ်ငန်းစဉ် အညွှန်း နံပါတ်",
  FromAccountNumber: "မှ အကောင့် နံပါတ်",
  AbabilTrnParticulars: "Ababil လုပ်ငန်းစဉ် အသေးစိတ်",
  AbabilTrnParticulars2: "Ababil လုပ်ငန်းစဉ် အသေးစိတ် 2",
  TranzwareTrnParticulars: "Tranzware လုပ်ငန်းစဉ် အသေးစိတ်",
  TranzwareTrnParticulars2: "Tranzware လုပ်ငန်းစဉ် အသေးစိတ် 2",

  // Service Active/Deactive Register
  ServiceActiveDeactiveRegister: "ဝန်ဆောင်မှု လည်ပတ်မှု/သေချာမှု မှတ်ပုံတင်",
  SubTranType: "အဆင့်လုပ်ငန်းအမျိုးအစား",
  FromDates: "မှ ရက်စွဲ",
  ToDates: "သို့ ရက်စွဲ",
  DisplayMessage: "ပြသရန် သတင်းစာ",
  DisplayMessageDetail: "ပြသရန် သတင်းစာ အသေးစိတ်",

  // Mobile/Email Updation From Core Report
  MobileEmailUpdationFromCoreReport: "မိုဘိုင်း/အီးမေးလ် ပြင်ဆင်မှု အစီရင်ခံစာ",
  UpdatedField: "ပြင်ဆင်ထားသော လယ်ယာ",

  // OTP Notification Report
  OTPNotificationReport: "OTP သတင်းစာ အစီရင်ခံစာ",
  TRNCode: "TRN ကုဒ်",
  MobileNoEmailID: "မိုဘိုင်း နံပါတ်/အီးမေးလ် ID",
  SentTime: "ပေးပို့ချိန်",
  MessageDescription: "သတင်းစာ ဖျော်ဖြေရန်",
  ApiResp: "API တုံ့ပြန်မှု",
  PageNumber: "စာမျက်နှာ နံပါတ်",
  EnterPageNumber: "စာမျက်နှာ နံပါတ် ရိုက်ထည့်ပါ",
  PageSize: "စာမျက်နှာ အရွယ်အစား",
  EnterPageSize: "စာမျက်နှာ အရွယ်အစား ရိုက်ထည့်ပါ",

  // List Of Club Member Report
  ListOfClubMemberReport: "ကလပ်အဖွဲ့ဝင်များ စာရင်း အစီရင်ခံစာ",
  Pleaseselectatleastonerow: "တစ်ဆင့်မှ သင့်လျော်သော ရွေးချယ်ပါ။",

  // Mobile/Email Notification Report
  MobileEmailNotificationReport: "မိုဘိုင်း/အီးမေးလ် သတင်းစာ အစီရင်ခံစာ",
  MessageType: "သတင်းစာ အမျိုးအစား",

  // Beneficiary Detail Report
  BeneficiaryDetailReport: "အကျိုးခံစားသူ အသေးစိတ် အစီရင်ခံစာ",
  BeneficiaryType: "အကျိုးခံစားသူ အမျိုးအစား",

  // Mobile/Email Updation From Citytouch Report
  MobileEmailUpdationFromCitytouchReport:
    "မိုဘိုင်း/အီးမေးလ် ပြင်ဆင်မှု Citytouch အစီရင်ခံစာ",
  ReqestDate: "တောင်းဆိုမှု ရက်စွဲ",
  ResponseCode: "တုံ့ပြန်မှု ကုဒ်",

  // Email Transfer Transaction Details
  EmailTransferTransactionDetails: "အီးမေးလ် ပေးပို့မှု လုပ်ငန်းစဉ် အသေးစိတ်",
  AcceptStatus: "လက်ခံမှု အခြေအနေ",
  ResentCount: "ထပ်မံပေးပို့မှု အရေအတွက်",
  CancelReason: "ဖျက်သိမ်းရန် အကြောင်းပြချက်",

  // Cash By Code Transaction Details
  CashByCodeTransactionDetails: "ကုဒ်ဖြင့် ငွေပေးချေမှု အသေးစိတ်",
  FromCardNumber: "မှ ကဒ် နံပါတ်",
  LinkedACNo: "ဆက်စပ် A/C နံပါတ်",
  CodeViewBy: "ကုဒ် ကြည့်ရှုသူ",
  CashByCode: "ကုဒ်ဖြင့် ငွေပေးချေမှု",
  BenConatctNo: "အကျိုးခံစားသူ ဆက်သွယ်ရန် နံပါတ်",

  // Favourite Transaction Details
  FavouriteTransactionDetails: "အကြိုက်ဆုံး လုပ်ငန်းစဉ် အသေးစိတ်",
  FavType: "အကြိုက်ဆုံး အမျိုးအစား",
  FavTranname: "အကြိုက်ဆုံး လုပ်ငန်းစဉ် အမည်",

  // Payment Details
  PaymentDetails: "ငွေပေးချေမှု အသေးစိတ်",
  PaymentDate: "ငွေပေးချေမှု ရက်စွဲ",
  ToSource: "သို့ အရင်းအမြစ်",
  ServiceCharge: "ဝန်ဆောင်မှု လိုက်လျောမှု",
  Mobile: "မိုဘိုင်း",
  ResponseDesc: "တုံ့ပြန်မှု ဖျော်ဖြေရန်",
  RefTransactionID: "အညွှန်း.လုပ်ငန်း ID",
  MerchantName: "စျေးကွက် အမည်",
  Frequency: "အကြိမ်ရေ",
  AsonDate: "ရက်စွဲအရ",
  DeselectAll: "အားလုံး ပယ်ဖျက်ပါ",
  SelectAll: "အားလုံး ရွေးချယ်ပါ",

  // Schedule Payment Details
  SchedulePaymentDetails: "စီစဉ်ထားသော ငွေပေးချေမှု အသေးစိတ်",
  LastProcessDate: "နောက်ဆုံး လုပ်ငန်းစဉ် ရက်စွဲ",
  DeactiveChannel: "လည်ပတ်မှု မရှိသော အာရုံစူးစိုက်မှု",
  PaymentType: "ငွေပေးချေမှု အမျိုးအစား",
  NoofPayments: "ငွေပေးချေမှု အရေအတွက်",
  PolicyNumber: "မူဝါဒ နံပါတ်",
  PolicyHolderName: "မူဝါဒ ကိုင်ဆောင်သူ အမည်",
  PolicyPaidType: "မူဝါဒ ပေးထားသော အမျိုးအစား",
  ScheduleResponse: "စီစဉ်ထားသော တုံ့ပြန်မှု",

  ScheduleDetailsReport: "စီစဉ်ထားသော အသေးစိတ် အစီရင်ခံစာ",
  ScheduleDate: "စီစဉ်ထားသော ရက်စွဲ",
  FromAccountNo: "မှ အကောင့် နံပါတ်",
  FromAccountName: "မှ အကောင့် အမည်",
  ToAccountNo: "သို့ အကောင့် နံပါတ်",
  ToAccountName: "သို့ အကောင့် အမည်",
  BenContactNo: "အကျိုးခံစားသူ ဆက်သွယ်ရန် နံပါတ်",
  BenEmailID: "အကျိုးခံစားသူ အီးမေးလ် ID",
  RefDate: "အညွှန်း.ရက်စွဲ",

  // Card Activate/Reset Pin Report
  CardActivateResetPinReport: "ကတ် ဖွင့်ခြင်း/ပြန်လည်ပြင်ဆင်မှု PIN အစီရင်ခံစာ",
  TypeOfTran: "လုပ်ငန်းအမျိုးအစား",
  CardNo: "ကတ် နံပါတ်",
  OldStatusOfCard: "ကတ်၏ ဟောင်းသော အခြေအနေ",
  NewStatusOfCard: "ကတ်၏ အသစ်သော အခြေအနေ",
  ChangeReason: "ပြောင်းလဲမှု အကြောင်းပြချက်",
  ResponseMesssage: "တုံ့ပြန်မှု မက်ဆေ့ခ်ျ",

  // Tag Credit Card And Account Number Details
  TagCreditCardAndAccountNumberDetails: "ကတ်နှင့် အကောင့် နံပါတ် အသေးစိတ်",
  AcOrCardNo: "A/C သို့မဟုတ် ကတ် နံပါတ်",
  AcceptBy: "လက်ခံသူ",
  AcceptDate: "လက်ခံမှု ရက်စွဲ",
  AcceptanceRemarks: "လက်ခံမှု မှတ်ချက်များ",

  // Untag Credit Card And Account Number Details
  UntagCreditCardAndAccountNumberDetails: "ကတ်နှင့် အကောင့် နံပါတ် ဖျက်ခြင်း",

  // Positive Pay Request Report
  PositivePayRequestReport: "အပေါ်ဖွင့် ငွေပေးချေမှု တောင်းဆိုမှု အစီရင်ခံစာ",
  BeneficiaryName: "အကျိုးခံစားသူ အမည်",
  ChequeDate: "ချေးချုပ် ရက်စွဲ",
  ChequeNumber: "ချေးချုပ် နံပါတ်",
  ChequeBookNumber: "ချေးချုပ် စာအုပ် နံပါတ်",

  // QR Generated Report
  QRGeneratedReport: "QR ဖန်တီးခဲ့သော အစီရင်ခံစာ",
  QRID: "QR ID",
  Currency: "ငွေကြေး",
  ProcessStatus: "လုပ်ငန်းစဉ် အခြေအနေ",

  // QR Merchant Payment Report
  QRMerchantPaymentReport: "QR စျေးဆိုင် ငွေပေးချေမှု အစီရင်ခံစာ",

  // Cheque Book Request Report
  ChequeBookRequestReport: "ချေးချုပ် စာအုပ် တောင်းဆိုမှု အစီရင်ခံစာ",
  NoOfLeaf: "ရွက် အရေအတွက်",
  DeliveryBranch: "ပေးပို့ရေး ဌာန",

  // Cheque Stop Request Report
  ChequeStopRequestReport: "ချေးချုပ် အပြီးသတ် တောင်းဆိုမှု အစီရင်ခံစာ",
  BeginChequeNo: "စတင်ချေးချုပ် နံပါတ်",
  ChequeNo: "ချေးချုပ် နံပါတ်",
  ContactNo: "ဆက်သွယ်ရန် နံပါတ်",
  EnterContactNo: "ဝင်ပါ။ ဆက်သွယ်ရန် နံပါတ်",

  // User Block Unblock Report
  UserBlockUnblockReport: "အသုံးပြုသူ ပိတ်သိမ်း/ဖျက်ခြင်း အစီရင်ခံစာ",
  BlockType: "ပိတ်သိမ်းမှု အမျိုးအစား",

  // Apply for Fixed Deposite Request Report
  ApplyforFixedDepositeRequestReport: "Fixed Deposit တောင်းဆိုမှု အစီရင်ခံစာ",
  TypeOfAccount: "အကောင့် အမျိုးအစား",
  AccountTitle: "အကောင့် ခေါင်းစဉ်",
  AvilBalance: "အသုံးပြုနိုင်သော လက်ကျန်",
  TenureType: "ချိန်ကာလ အမျိုးအစား",
  AutoRenewal: "အလိုအလျောက် ပြန်လည်အသစ်ပြုခြင်း",
  IntRepayAccount: "အတိုး/ပြန်လည်ပေးချေမှု အကောင့်",
  CollectionBranch: "စုဆောင်းရေး ဌာန",
  InterestRate: "အတိုးနှုန်း",
  MaturityDate: "မဖွဲ့စည်းမှု ရက်စွဲ",
  ApplyForDepositPensionSchemeReport: "ထုတ်လုပ်မှု ပင်ရှင် အစီရင်ခံစာ",
  InstallStartDate: "အစတင်ရက်စွဲ",
  GeneratedAccount: "ဖန်တီးထားသော အကောင့်",

  // Credit Card Payment Report
  CreditCardPaymentReport: "ကတ်ငွေပေးချေမှု အစီရင်ခံစာ",
  ReferenceNo: "အညွှန်း နံပါတ်",
  FromACNumber: "မှ A/C နံပါတ်",
  ToCardNo: "သို့ ကတ် နံပါတ်",
  Recipientname: "လက်ခံသူ အမည်",
  RecipientEmail: "လက်ခံသူ အီးမေးလ်",
  CurrCode: "ငွေကြေး ကုဒ်",
  ToCurrCode: "သို့ ငွေကြေး ကုဒ်",
  CurrInt: "ငွေကြေး အစိတ်အပိုင်း",
  CardType: "ကတ် အမျိုးအစား",
  TotalAmount: "စုစုပေါင်း ငွေပမာဏ",

  // Admin Panel User Application Usage History
  AdminPanelUserApplicationUsageHistory:
    "အေဒြာပညာ panel အသုံးပြုသူ အပလီကေးရှင်း အသုံးပြုမှု သမိုင်း",
  OpenDateAndTime: "ဖွင့်သည့် ရက်စွဲနှင့် အချိန်",
  CloseDateAndTime: "ပိတ်သည့် ရက်စွဲနှင့် အချိန်",

  // Apply for Quick Loan Summary Report
  ApplyforQuickLoanSummaryReport:
    "အထက်မြန်စွာ အလွတ်ငွေချေးမှု အကျဉ်းချုပ် အစီရင်ခံစာ",
  RequestDateandTime: "တောင်းဆိုသည့် ရက်စွဲနှင့် အချိန်",
  EMIAccount: "EMI အကောင့်",
  IntRate: "အတိုးနှုန်း",

  ApplyforQuickLoanDetailReport:
    "အထက်မြန်စွာ အလွတ်ငွေချေးမှု အသေးစိတ် အစီရင်ခံစာ",
  LoanTenure: "ငွေချေးမှု ကြာချိန်",
  MonthlyIncome: "လစဉ် ဝင်ငွေ",
  ProcessingFee: "လုပ်ငန်းစဉ် ကုန်ကျစရိတ်",
  FileREFNo: "ဖိုင် အညွှန်း နံပါတ်",
  ETINNo: "E TIN နံပါတ်",
  NIDNo: "NID နံပါတ်",
  SmartCardNo: "စမတ် ကတ် နံပါတ်",
  BirthPlace: "မွေးရာနေရာ",
  SoalID: "ဆိုးလ် ID",
  SanIntRate: "San. အတိုးနှုန်း",
  OtherLoanEMI: "အခြား ငွေချေးမှု EMI",
  SanLoanAmount: "San ငွေချေးမှု ပမာဏ",
  EMIDate: "EMI ရက်စွဲ",
  CCLimitAmount: "CC. လုပ်ငန်း အမြတ် ပမာဏ",
  SanInstAmount: "San အစိတ်အပိုင်း ပမာဏ",
  DBRAmount: "DBR ပမာဏ",
  CIBUser: "CIB အသုံးပြုသူ",
  CIBEnteredDate: "CIB ထည့်သွင်းသည့် ရက်စွဲ",
  CIBMachineName: "CIB စက်အမည်",
  DBRUsers: "DBR အသုံးပြုသူများ",
  DBREnteredDate: "DBR ထည့်သွင်းသည့် ရက်စွဲ",
  DBRMachineName: "DBR စက်အမည်",
  AuthUser: "အတည်ပြုသူ",
  AuthRemarks: "အတည်ပြုမှတ်ချက်များ",
  AuthEnteredDate: "အတည်ပြု ထည့်သွင်းသည့် ရက်စွဲ",
  AuthMachineName: "အတည်ပြု စက်အမည်",
  RejectedBy: "ပယ်ဖျက်သူ",
  RejectedDate: "ပယ်ဖျက်သည့် ရက်စွဲ",
  RejectedMachineName: "ပယ်ဖျက်သည့် စက်အမည်",
  FDBalance: "FD လက်ကျန်",

  // Merchant Transaction Report
  MerchantTransactionReport: "ကုန်သွယ်မှု အစီရင်ခံစာ",
  RequestDateTime: "တောင်းဆိုသည့် ရက်စွဲနှင့် အချိန်",
  UniqueID: "ထူးခြားသော ID",
  BankRefID: "ဘဏ် အညွှန်း ID",
  MerchantReferenceID: "ကုန်သွယ်မှု အညွှန်း ID",
  TokenNo: "Token နံပါတ်",
  ServiceType: "ဝန်ဆောင်မှု အမျိုးအစား",
  ReverseStatus: "ပြန်လည်အခြေအနေ",

  // Supporting Documents Upload Report
  SupportingDocumentsUploadReport: "ထောက်ခံစာရွက်များ တင် Upload အစီရင်ခံစာ",
  RegistrationDate: "မှတ်ပုံတင် ရက်စွဲ",
  ChangeRequestType: "ပြောင်းလဲမှု တောင်းဆိုမှု အမျိုးအစား",
  APIResponceID: "API တုံ့ပြန်မှု ID",
  DocumentName: "စာရွက် အမည်",
  DocumentFileName: "စာရွက် ဖိုင်အမည်",

  // Pay Order Details Report
  PayOrderDetailsReport: "ငွေပေးအပ်မှု အချက်အလက် အစီရင်ခံစာ",
  TransactionTime: "ငွေကြေးလှိုင်း အချိန်",
  TypeOfFundTransfer: "ငွေလွှဲလုပ်ငန်း အမျိုးအစား",
  DeliveryBranchName: "ပေးပို့ရေး ဌာန အမည်",
  TransferRefNumber: "လွှဲပြောင်း အညွှန်း နံပါတ်",

  // FDR Issuance Report
  FDRIssuanceReport: "FDR ထုတ်လုပ်မှု အစီရင်ခံစာ",
  RequestCompletedDateTime: "တောင်းဆိုမှု ပြီးစီးသည့် ရက်စွဲနှင့် အချိန်",
  SOLDescription: "SOL အကြောင်းအရာ",
  CIFID: "CIF ID",
  FDRType: "FDR အမျိုးအစား",
  AcName: "A/C အမည်",
  AcOpeningDate: "A/C ဖွင့်ရက်",
  IntCreditAcID: "အတိုးကွဲ အကောင့် ID",
  IntCreditAcName: "အတိုးကွဲ အကောင့် အမည်",
  ValueDate: "တန်ဖိုးရက်",
  DepositAmount: "ဒေါ်လာ တင်သွင်းမှု ပမာဏ",
  DepositPeriod: "ဒေါ်လာ တင်သွင်းမှု အချိန်ကာလ",
  TenorType: "ချိန်ကာလ အမျိုးအစား",
  MaturityValue: "မဖွဲ့စည်းမှု တန်ဖိုး",
  RepaymentAcID: "ပြန်လည်ပေးချေမှု အကောင့် ID",
  RepaymentAcName: "ပြန်လည်ပေးချေမှု အကောင့် အမည်",
  MaturityInstructions: "မဖွဲ့စည်းမှု ညွှန်ကြားချက်များ",
  AutoClosure: "အလိုအလျောက် ပိတ်ခြင်း",
  SectorCode: "လယ်ဝေး ကုဒ်",
  SubSectorCode: "အင်္ကျီဝယ် ကုဒ်",
  OccupationCode: "အလုပ်အကိုင် ကုဒ်",
  FreeCode3: "အခမဲ့ ကုဒ် 3",
  FreeCode6: "အခမဲ့ ကုဒ် 6",
  FreeCode7: "အခမဲ့ ကုဒ် 7",
  DebitAcID: "ချေးငွေ အကောင့် ID",
  DebitAcName: "ချေးငွေ အကောင့် အမည်",
  NomineesName: "ရွေးချယ်သူ အမည်",
  Relationship: "ဆက်နွယ်မှု",
  AddressLine1: "လိပ်စာ အကြောင်းအရာ 1",
  AddressLine2: "လိပ်စာ အကြောင်းအရာ 2",
  NomineePhotoID: "ရွေးချယ်သူ ပုံ ID",
  City: "မြို့",
  State: "ပြည်နယ်",
  Country: "နိုင်ငံ",
  NomineeMinor: "ရွေးချယ်သူ အငယ်သား",
  DateOfBirth: "မွေးရက်",
  NomineePent: "ရွေးချယ်သူ Pent.",
  RequestID: "တောင်းဆိုမှု ID",

  // DPS Issuance Report
  DPSIssuanceReport: "DPS ထုတ်လုပ်မှု အစီရင်ခံစာ",
  SISrlNo: "SI အမှတ်",
  StandInstFreqType: "Stand. Inst. အကြိမ်ရေ အမျိုးအစား",
  DayofStandInstFreq: "Stand. Inst. အကြိမ်ရေ၏ ရက်",
  StandInstFreq: "Stand. Inst. အကြိမ်ရေ",
  NextExecutionDate: "အနောက်ဆုံး အကောင့်လှုံ့ဆော်ရက်",

  // API Response Report
  APIResponseReport: "API တုံ့ပြန်မှု အစီရင်ခံစာ",
  APICallCount: "API ခေါ်ယူမှု အရေအတွက်",

  // Admin Panel User Information Report
  AdminPanelUserInformationReport:
    "အုပ်ချုပ်မှု စာရင်းဇယား အသုံးပြုသူ အချက်အလက် အစီရင်ခံစာ",
  CreationDate: "ဖန်တီးသည့် ရက်စွဲ",

  // Admin Panel User Activity Report
  AdminPanelUserActivityReport:
    "အုပ်ချုပ်မှု စာရင်းဇယား အသုံးပြုသူ လှုပ်ရှားမှု အစီရင်ခံစာ",
  LogDescription: "မှတ်တမ်း အကြောင်းအရာ",
  LoginIpAddress: "ဝင်ထွက် IP လိပ်စာ",
  Terminal: "တာမီနယ်",
  ReleasedBy: "ထုတ်ပြန်သည့်သူ",
  ReleasedDate: "ထုတ်ပြန်သည့် ရက်စွဲ",
  ReleasedIpAddress: "ထုတ်ပြန်သည့် IP လိပ်စာ",

  // Perameters Audit Trail
  PerametersAuditTrail: "ပאַרာမီတာ များ လေ့လာစစ်ဆေးမှု",
  PeraNo: "Pera အမှတ်",
  ModifiedDateTime: "ပြင်ဆင်သည့် ရက်စွဲ - အချိန်",

  // Admin Panel User Audit Trail Detail
  AdminPanelUserAuditTrailDetail:
    "အုပ်ချုပ်မှု စာရင်းဇယား အသုံးပြုသူ လေ့လာစစ်ဆေးမှု အသေးစိတ်",
  ActionDateTime: "လှုပ်ရှားမှု ရက်စွဲနှင့် အချိန်",
  AdminPanelUserWiseScreenAccessReport:
    "အုပ်ချုပ်မှု စာရင်းဇယား အသုံးပြုသူ အခြေခံ စခန်း ဝင်ရောက်မှု အစီရင်ခံစာ",
  ScreenCode: "စခန်း ကုဒ်",

  // Monthly Service And Channel Wise MAU Report
  MonthlyServiceAndChannelWiseMAUReport:
    "လစဉ် ဝန်ဆောင်မှု နှင့် ချန်နယ် အခြေခံ MAU အစီရင်ခံစာ",
  Month: "လ",
  Transaction: "ငွေကြေး လှိုင်း",
  Volume: "အရေအတွက်",
  UniqueCustomer: "ထူးခြားသော ဖောက်သည်",
  DailyServiceAndChannelWiseMAUReport:
    "နေ့စဉ် ဝန်ဆောင်မှု နှင့် ချန်နယ် အခြေခံ MAU အစီရင်ခံစာ",
  PleaseSelectAtLeastOneChannel: "ကျေးဇူးပြု၍ အနည်းဆုံး ချန်နယ် ၁ ခု ရွေးပါ။",
  PleaseSelectAtLeastOneTrnType:
    "ကျေးဇူးပြု၍ အနည်းဆုံး ငွေကြေး လှိုင်း အမျိုးအစား ၁ ခု ရွေးပါ။",

  // Monthly User And Channel Wise MAU Report
  MonthlyUserAndChannelWiseMAUReport:
    "လစဉ် အသုံးပြုသူ နှင့် ချန်နယ် အခြေခံ MAU အစီရင်ခံစာ",
  NumberOfService: "ဝန်ဆောင်မှု အရေအတွက်",
  DailyUserAndChannelWiseMAUReport:
    "နေ့စဉ် အသုံးပြုသူ နှင့် ချန်နယ် အခြေခံ MAU အစီရင်ခံစာ",

  // Primary Identifier Change Report
  PrimaryIdentifierChangeReport: "မူလ အမှတ်ပြုသူ ပြောင်းလဲမှု အစီရင်ခံစာ",
  OldSource: "ဟောင်းသော အရင်းအမြစ်",
  NewSource: "အသစ်သော အရင်းအမြစ်",
  OldCardaccountNo: "ဟောင်းသော ကတ်/အကောင့် နံပါတ်",
  NewCardaccountNo: "အသစ်သော ကတ်/အကောင့် နံပါတ်",
  ChangedBy: "ပြောင်းလဲသည့်သူ",
  ChangedDate: "ပြောင်းလဲသည့် ရက်စွဲ",

  // Device Change Report
  DeviceChangeReport: "စက်ပစ္စည်းပြောင်းလဲမှု အစီရင်ခံစာ",

  // Currently Login Customer Details Report
  CurrentlyLoginCustomerDetailsReport:
    "လက်ရှိဝင်ရောက်နေသော ဖောက်သည် အချက်အလက် အစီရင်ခံစာ",
  LastLoginDateTime: "နောက်ဆုံး ဝင်ရောက်သည့် ရက်စွဲနှင့် အချိန်",
  LastActivityDateTime: "နောက်ဆုံး လှုပ်ရှားမှု ရက်စွဲနှင့် အချိန်",
  InactiveTime: "အလုပ်မလုပ်သော အချိန်",
  TTL: "TTL",
  LastActivityType: "နောက်ဆုံး လှုပ်ရှားမှု အမျိုးအစား",
  LastActivityDescription: "နောက်ဆုံး လှုပ်ရှားမှု အကြောင်းအရာ",

  // Mobile Recharge Details Report
  MobileRechargeDetailsReport:
    "မိုဘိုင်း ပြန်လည်လျှော့ချမှု အချက်အလက် အစီရင်ခံစာ",
  ConnectionType: "ချိတ်ဆက်မှု အမျိုးအစား",
  OTPMobileNumber: "OTP မိုဘိုင်း နံပါတ်",
  OTPEmailID: "OTP အီးမေးလ် ID",

  // Account Deletion Request Report
  AccountDeletionRequestReport: "အကောင့် ဖျက်ရန် တောင်းဆိုမှု အစီရင်ခံစာ",
  PrimaryCBCID: "မူလ CB/CID",
  CheckerDate: "စစ်ဆေးသူ ရက်စွဲ",

  // Topup Reversal Report
  TopupReversalReport: "Topup ပြန်လည်လှုပ်ရှားမှု အစီရင်ခံစာ",
  TopupTranCode: "Topup လှိုင်း ကုဒ်",
  MerechantRefID: "ကုန်သွယ်မှု အညွှန်း ID",
  AmountStatus: "ပမာဏ အခြေအနေ",
  RequestIP: "တောင်းဆို IP",
  Rechargedate: "ပြန်လည်လျှော့ချမှု ရက်စွဲ",

  // Merchant Transaction Reversal Report
  MerchantTransactionReversalReport:
    "ကုန်သည်ငွေချိုးမှုပြန်လည်အတည်ပြုအစီရင်ခံစာ",
  ReversedBy: "ပြန်လည်အတည်ပြုသူ",
  ReversedDateTime: "ပြန်လည်အတည်ပြုချိန်",
  AcceptedDateTime: "လက်ခံချိန်",
  ReversedMachineName: "ပြန်လည်အတည်ပြုစက်အမည်",
  AcceptedMachineName: "လက်ခံစက်အမည်",

  // User Status Change Audit Report
  UserStatusChangeAuditReport: "အသုံးပြုသူအခြေအနေပြောင်းလဲမှုစာရင်း",
  NewStatus: "အခြေအနေအသစ်",

  // Utility Bill Payment Report
  UtilityBillPaymentReport: "အသုံးပြုမှုဘီလ်ငွေပေးချေမှုအစီရင်ခံစာ",
  Category: "အမျိုးအစား",
  TrnStatus: "ငွေလွှဲအခြေအနေ",
  Retrieve: "ပြန်လည်ရယူရန်",
  BillNumber: "ဘီလ်နံပါတ်",
  GrandTotal: "စုစုပေါင်း",
  OTPMobileNo: "OTP မိုဘိုင်းနံပါတ်",
  TransactionRefID: "ငွေလွှဲရုံငြင်းအမှတ်",
  OtherDetails: "အခြားအသေးစိတ်",

  // Daily Service And Channel Wise Charges report
  DailyServiceAndChannelWiseChargesreport:
    "နေ့စဉ်ဝန်ဆောင်မှုနှင့်ချန်နယ်အလိုက်ကြေးငွေအစီရင်ခံစာ",
  MonthlyServiceAndChannelWiseChargesReport:
    "လစဉ်ဝန်ဆောင်မှုနှင့်ချန်နယ်အလိုက်ကြေးငွေအစီရင်ခံစာ",

  // Insurance Premium Payment Report
  InsurancePremiumPaymentReport: "အာမခံပရိုမိုးရှင်းငွေပေးချေမှုအစီရင်ခံစာ",
  CompanyName: "ကုမ္ပဏီအမည်",
  TransferType: "လွှဲပြောင်းခြင်းအမျိုးအစား",
  ToAccount: "အကောင့်သို့",

  // MFS Transfer Transaction Details
  MFSTransferTransationDetails: "MFS လွှဲပြောင်းငွေလွှဲအသေးစိတ်",
  TransationDate: "ငွေလွှဲနေ့",
  TransationType: "ငွေလွှဲအမျိုးအစား",

  // Customer Wise Global Limit Usage Report
  CustomerWiseGlobalLimitUsageReport:
    "ဖောက်သည်အလိုက်ကမ္ဘာလုံးဆိုင်ရာကန့်သတ်အသုံးပြုမှုအစီရင်ခံစာ",
  GlobalLimit: "ကမ္ဘာလုံးဆိုင်ရာကန့်သတ်",
  TransactionCount: "ငွေလွှဲအရေအတွက်",
  MFSvolume: "MFS အဖွဲ့ဝင်ပမာဏ",
  WithinBankVolume: "ဘဏ်အတွင်းပမာဏ",
  OtherBankVolume: "အခြားဘဏ်ပမာဏ",
  PaymentVolume: "ငွေပေးချေမှုပမာဏ",

  // IDTP Registration Report
  IDTPRegistrationReport: "IDTP စာရင်းသွင်းမှုအစီရင်ခံစာ",
  VID: "VID",
  DefualtDebitAccount: "ကန့်သတ် ဒက်ဘစ်အကောင့်",
  DefualtCreditAccount: "ကန့်သတ် เครดิตအကောင့်",
  DefualtRTPAccount: "ကန့်သတ် RTP အကောင့်",
  RegistrationType: "စာရင်းသွင်းမှုအမျိုးအစား",

  // IDTP Transfer Report
  IDTPTransferReport: "IDTP လွှဲပြောင်းမှုအစီရင်ခံစာ",
  SenderVID: "ပေးပို့သူ VID",
  ReceiverVID: "လက်ခံသူ VID",
  ReceiverName: "လက်ခံသူအမည်",
  InterOperableFee: "အပြောင်းအလဲကြေး",
  PlatformFee: "ပလက်ဖောင်းကြေး",
  RTPID: "RTP ID",
  SwiftCode: "Swift ကုဒ်",
  SDKResponseCode: "SDK တုံ့ပြန်ကုဒ်",
  ReqestID: "တောင်းဆိုမှု ID",
  ReferanceNumber: "ကိုးကားနံပါတ်",
  RefNoSendingPSP: "Ref.No. ပေးပို့သော PSP",
  RefNoReceivingPSP: "Ref.No. လက်ခံသော PSP",
  RefNoReceivingBank: "Ref.No. လက်ခံသောဘဏ်",
  RefNoIDTP: "Ref.No. IDTP",

  // IDTP Create RTP Report
  IDTPCreateRTPReport: "IDTP RTP ဖန်တီးမှုအစီရင်ခံစာ",
  UserVID: "အသုံးပြုသူ VID",

  // IDTP Beneficiary Detail Report
  IDTPBeneficiaryDetailReport: "IDTP အထူးအကျိုးခံစားသူအသေးစိတ်အစီရင်ခံစာ",
  BeneficiaryVID: "အထူးအကျိုးခံစားသူ VID",

  // IDTP Transaction PIN Change Report
  IDTTransactionPINChangeReport: "IDTP ငွေလွှဲ PIN ပြောင်းလဲမှုအစီရင်ခံစာ",

  // Password Reset Through Admin Panel Report
  PasswordResetThroughAdminPanelReport:
    "အုပ်ချုပ်မှုပန်းချီမှ ကိစ္စကို ပြန်လည်သတ်မှတ်ခြင်းအစီရင်ခံစာ",
  MakerMachine: "ဖန်တီးသူစက်",
  CheckerMachine: "စစ်ဆေးသူစက်",

  // IDTP Forgot PIN Report
  IDTPForgotPINReport: "IDTP PIN မေ့သည့်အစီရင်ခံစာ",
  VirtualID: "ဗာချွယ် ID",
  AcOrCardNumber: "အကောင့် သို့မဟုတ် ကတ်နံပါတ်",

  // IDTP RTP Decline Report
  IDTPRTPDeclineReport: "IDTP RTP ပယ်ချမှုအစီရင်ခံစာ",
  SenderName: "ပေးပို့သူအမည်",
  SenderVirtualID: "ပေးပို့သူဗာချွယ် ID",

  // Virtual Card Request Report
  VirtualCardRequestReport: "ဗာချွယ်ကတ်တင်သွင်းခြင်းအစီရင်ခံစာ",
  CardProductName: "ကတ်ထုတ်ကုန်အမည်",
  NameOnCard: "ကတ်ပေါ်အမည်",
  CurrencyCode: "ငွေကြေးကုဒ်",
  PassportNumber: "ခရီးသွားလက်မှတ်နံပါတ်",
  CorrespondenceAddress: "အCorrespondence လိပ်စာ",

  // Dynamic Report Configure
  DynamicReportConfigure: "ဒိုင်းနမစ်အစီရင်ခံစာပြုပြင်ခြင်း",
  SQLANSIQuerySyntax: "SQL ANSI မေးခွန်းပုံစံ",
  PleaseEnterSQLSyntax: "SQL ပုံစံထည့်ပါ။",
  PleaseVerifySQLSyntax: "SQL ပုံစံကိုစစ်ဆေးပါ။",
  Parameters: "ပြောင်းလဲမှုများ",
  Title: "ခေါင်းစဉ်",
  EnterTitle: "ခေါင်းစဉ်ထည့်ပါ",
  RetrievalType: "ရယူမှုအမျိုးအစား",
  DisableGroupBy: "Group By ကိုပိတ်ထားပါ",
  HideAmountIn: "ပမာဏကိုဖျက်Hide",
  HideFooter: "Footer ကိုဖျက်Hide",
  ColumnAccessor: "ကော်လံဝင်ရိုး",
  EnterColumnAccessor: "ကော်လံဝင်ရိုးထည့်ပါ",
  ColumnName: "ကော်လံအမည်",
  EnterColumnName: "ကော်လံအမည်ထည့်ပါ",
  ColumnWidth: "ကော်လံအကျယ်",
  EnterColumnWidth: "ကော်လံအကျယ်ထည့်ပါ",
  ColumnType: "ကော်လံအမျိုးအစား",
  EnterColumnType: "ကော်လံအမျိုးအစားထည့်ပါ",
  ColumnFilterType: "ကော်လံစစ်ထုတ်မှုအမျိုးအစား",
  IsVisible: "မြင်သာပါသလား",
  CreatedBy: "ဖန်တီးသူ",
  CreatedDate: "ဖန်တီးသည့်နေ့",
  QuerySuccessfullyVerified: "မေးခွန်းအောင်မြင်စွာစစ်ဆေးပြီးပါပြီ။",
  ColumnFormat: "ကော်လံပုံစံ",
  EnterColumnFormat: "ကော်လံပုံစံထည့်ပါ",
  WhereSequence: "ဘယ်နေရာတွင် အစီအစဉ်",
  EnterWhereSequence: "ဘယ်နေရာတွင်အစီအစဉ်ထည့်ပါ",
  AccessRights: "သင့်လွှာအခွင့်အရေး",
  DynamicReportAccessRights: "ဒိုင်းနမစ်အစီရင်ခံစာသင့်လွှာအခွင့်အရေး",
  Userrightsupdatedsuccessfully:
    "အသုံးပြုသူအခွင့်အရေးအောင်မြင်စွာအပ်ဒိတ်ပြုပြင်သည်။",
  Verify: "စစ်ဆေးပါ",
  Done: "ပြီးပြီ",

  UserList: "အသုံးပြုသူစာရင်း",
  Club: "ကလပ်",

  startswith: "စတင်သည်",
  endswith: "အဆုံးသတ်သည်",
  equal: "ညီသည်",
  contains: "ပါဝင်သည်",

  PleaseSelectValidStartTime: "ကျေးဇူးပြု၍ မှန်ကန်သော စတင်ချိန်ကို ရွေးချယ်ပါ",
  PleaseSelectValidEndTime: "ကျေးဇူးပြု၍ မှန်ကန်သော အဆုံးချိန်ကို ရွေးချယ်ပါ",
  MonthlyLimitshouldgreaterthanorequaltoDailyLimit:
    "လစဉ် ကန့်သတ်သည် နေ့စဉ် ကန့်သတ်ထက် ကြီးမားသည် သို့မဟုတ်ညီညွတ်သည်",
  MonthlyLimitshouldgreaterthanorequaltoWeeklyLimit:
    "လစဉ် ကန့်သတ်သည် ပတ်စဉ် ကန့်သတ်ထက် ကြီးမားသည် သို့မဟုတ်ညီညွတ်သည်",
  MaximumAmountshouldgreaterthanorequaltoMinimumAmount:
    "အများဆုံးပမာဏသည် အနည်းဆုံးပမာဏထက် ကြီးမားသည် သို့မဟုတ်ညီညွတ်သည်",
  WeeklyLimitshouldgreaterthanorequaltoDailyLimit:
    "ပတ်စဉ် ကန့်သတ်သည် နေ့စဉ် ကန့်သတ်ထက် ကြီးမားသည် သို့မဟုတ်ညီညွတ်သည်",

  viewmode: "မြင်ကွင်းမုဒ်",
  newmode: "အထူးသစ်မုဒ်",
  editmode: "ပြင်ဆင်မုဒ်",
  confirmmode: "အတည်ပြုမုဒ်",
  addmode: "ထည့်သွင်းမုဒ်",

  SelectCompute: "တွက်ချက်ရန်ရွေးချယ်ပါ",

  BusinessDayhasbeennotgeneratedPleasegenerateaBusinessDaythroughtheViewDetailsScreen:
    "စီးပွားရေးနေ့ကို ဖန်တီးထားသည်မဟုတ်ပါ။ ကျေးဇူးပြု၍ View Details Screen မှတဆင့် စီးပွားရေးနေ့ကို ဖန်တီးပါ။",
  SelectBranchName: "ခွဲခြမ်းအမည်ကို ရွေးချယ်ပါ",
  StartdatemustbegreaterthanpreviousEnddate:
    "စတင်နေ့သည် ယခင်အဆုံးနေ့ထက် ကြီးမားရမည်။",
  SelectParentType: "မိဘအမျိုးအစားကို ရွေးချယ်ပါ",
  SelectLeavesTemplate: "လက်ပတ်အတွဲကို ရွေးချယ်ပါ",
  SelectCharges: "ကြေးငွေကို ရွေးချယ်ပါ",
  SelectOperatorType: "အသုံးပြုသူအမျိုးအစားကို ရွေးချယ်ပါ",
  SelectOptionType: "ရွေးချယ်မှုအမျိုးအစားကို ရွေးချယ်ပါ",
  SelectChargeTemplate: "ကြေးငွေအတွဲကို ရွေးချယ်ပါ",
  SelectAccountSource: "အကောင့်ရင်းမြစ်ကို ရွေးချယ်ပါ",
  DragandDropor: "ဆွဲနှိပ်ပြီးရောက်ခြင်း သို့မဟုတ်",
  Browse: "ရှာဖွေရန်",
  DropFileshere: "ဖိုင်များကို ဒီနေရာတွင် ထိန်းသိမ်းပါ",
  SelectSourceName: "ရင်းမြစ်အမည်ကို ရွေးချယ်ပါ",
  SelectSourceType: "ရင်းမြစ်အမျိုးအစားကို ရွေးချယ်ပါ",
  SelectDistrict: "ခရိုင်ကို ရွေးချယ်ပါ",
  SelectTransactionType: "ငွေလွှဲအမျိုးအစားကို ရွေးချယ်ပါ",
  SelectAccountType: "အကောင့်အမျိုးအစားကို ရွေးချယ်ပါ",
  SelectTenureType: "အချိန်ကာလအမျိုးအစားကို ရွေးချယ်ပါ",
  SelectRestrictionType: "ကန့်သတ်မှုအမျိုးအစားကို ရွေးချယ်ပါ",
  SelectUsecase: "အသုံးပြုမှုကိစ္စကို ရွေးချယ်ပါ",
  SelectChannel: "ချန်နယ်ကို ရွေးချယ်ပါ",
  SelectDisplayType: "ပြသမှုအမျိုးအစားကို ရွေးချယ်ပါ",
  SelectBannerType: "ဘန်နာအမျိုးအစားကို ရွေးချယ်ပါ",
  SelectTenureTypeFinacle: "Finacle အချိန်ကာလအမျိုးအစားကို ရွေးချယ်ပါ",
  SelectRenewal: "ပြန်လည်ပြင်ဆင်မှုကို ရွေးချယ်ပါ",
  SelectDataType: "ဒေတာအမျိုးအစားကို ရွေးချယ်ပါ",
  SelectMFSService: "MFS ဝန်ဆောင်မှုကို ရွေးချယ်ပါ",
  SelectDescription: "ဖေါ်ပြချက်ကို ရွေးချယ်ပါ",
  SelectAllowDisallow: "ခွင့်ပြု/မခွင့်ပြုကို ရွေးချယ်ပါ",
  SelectTemplate: "အတွဲကို ရွေးချယ်ပါ",
  SelectCardStatus: "ကတ်အခြေအနေကို ရွေးချယ်ပါ",
  SelectOperationType: "လုပ်ဆောင်မှုအမျိုးအစားကို ရွေးချယ်ပါ",
  SelectEnableStatus: "ဖွင့်ခြင်းအခြေအနေကို ရွေးချယ်ပါ",
  SelectDeviceOS: "ထုတ်ကုန် O.S. ကို ရွေးချယ်ပါ",
  SelectServiceName: "ဝန်ဆောင်မှုအမည်ကို ရွေးချယ်ပါ",
  SelectTemplateName: "အတွဲအမည်ကို ရွေးချယ်ပါ",
  SelectProductType: "ထုတ်ကုန်အမျိုးအစားကို ရွေးချယ်ပါ",
  SelectLimitCurrency: "ကန့်သတ်ငွေကြေးကို ရွေးချယ်ပါ",
  SelectLanguageID: "ဘာသာစကား ID ကို ရွေးချယ်ပါ",
  SelectMerchantID: "ကုန်သည် ID ကို ရွေးချယ်ပါ",
  SelectTerminalID: "Terminal ID ကို ရွေးချယ်ပါ",
  SelectCharge: "ကြေးငွေကို ရွေးချယ်ပါ",
  SelectGatewayNamePID: "Gateway အမည် (PID) ကို ရွေးချယ်ပါ",
  SelectUserRole: "အသုံးပြုသူအခန်းကဏ္ဍကို ရွေးချယ်ပါ",
  SelectUserStatus: "အသုံးပြုသူအခြေအနေကို ရွေးချယ်ပါ",
  SelectActionMenu: "ဆောင်ရွက်မှုမီနူးကို ရွေးချယ်ပါ",
  SelectResponseKey: "တုံ့ပြန်မှုအချက်ကို ရွေးချယ်ပါ",
  SelectUserLevel: "အသုံးပြုသူအဆင့်ကို ရွေးချယ်ပါ",
  SelectGroupName: "အဖွဲ့အမည်ကို ရွေးချယ်ပါ",
  SelectUserSubType: "အသုံးပြုသူအထွေထွေ အမျိုးအစားကို ရွေးချယ်ပါ",
  SelectNotificationTemplate: "သတိပေးမှုအတွဲကို ရွေးချယ်ပါ",
  SelectUserLoginID: "အသုံးပြုသူ လော့ဂ်အင် ID ကို ရွေးချယ်ပါ",
  ErrorDetails: "အမှားအသေးစိတ်",
  ShowLess: "ပိုမိုနည်းပါစေ",
  ShowMore: "ပိုမိုပြပါ",
  Atleastonerowmustbeindetail: "အသေးစိတ်တွင် အနည်းဆုံး တစ်ရိုးရှိရမည်။",
  All: "အားလုံး",

  UploadProfilePhoto: "ပရိုဖိုင်းဓါတ်ပုံ ကို အပ်လွှတ်ပါ",
  Filenotfound: "ဖိုင်မတွေ့ပါ",
  Profilepictureupdatedsuccessfully:
    "ပရိုဖိုင်းဓါတ်ပုံ ကို အောင်မြင်စွာပြင်ဆင်သည်။",
  Zoom: "ဇုန်",
  Rotate: "ပြောင်း",
  UpdatePhoto: "ဓါတ်ပုံကို အပ်ဒိတ်လုပ်ပါ",
  ServiceChargeDetails: "ဝန်ဆောင်မှုကြေးအကြောင်းအရာ",
  Addedsuccessfully: "အောင်မြင်စွာ ထည့်သည်",
  Updatedsuccessfully: "အောင်မြင်စွာ ပြင်ဆင်သည်",
  EditChargeTemplate: "ကြေးအတွဲကို ပြင်ဆင်ပါ",
  AreyousureyouwanttodeletetheselectedRecord:
    "သင်သည် ရွေးချယ်ထားသော မှတ်တမ်းကို ဖျက်မည်ဟု အတည်ပြုပါသလား။",
  Disagree: "အဘယျသဘောမရှိပါ",
  Agree: "သဘောတူသည်",
  EditChecklistDetails: "စစ်ဆင်ရေးအကြောင်းအရာကို ပြင်ဆင်ပါ",
  EnterFromAmount: "သင့်ထံမှ ပမာဏကို ထည့်ပါ",
  EnterToAmount: "သင့်သို့ ပမာဏကို ထည့်ပါ",
  EnterChargeAmount: "ကြေးပမာဏကို ထည့်ပါ",
  EnterChargePercent: "ကြေးရာခိုင်နှုန်းကို ထည့်ပါ",
  AddChargeTemplateDetail: "ကြေးအတွဲအသေးစိတ် ထည့်ပါ",
  AccessDenied: "ဝင်ရောက်မှု ပိတ်ပင်သည်!",
  Usernameisnotvalid: "အသုံးပြုသူအမည် မမှန်ပါ",
  OopsPageNotFound: "ဝပ်စ်! စာမျက်နှာမတွေ့ပါ",
  Pleaseselectatleastonecolumn: "ကျေးဇူးပြု၍ အနည်းဆုံး ကော်လံတစ်ခု ရွေးချယ်ပါ!",
  Nodatafoundtoexports: "တင်ပို့ရန် အချက်အလက်မတွေ့ပါ!",
  ResendOTP: "OTP ကို ပြန်ပို့ပါ",

  OTPVerification: "OTP သက်သေခံချက်",
  PleaseEnterOTP: "ကျေးဇူးပြု၍ OTP ထည့်ပါ",
  ForgotTOTP: "TOTP မေ့နေပါသည်",

  SelectCategory: "အမျိုးအစားကို ရွေးချယ်ပါ",
  SelectBillerName: "ဘီလာအမည်ကို ရွေးချယ်ပါ",
  SelectTrnStatus: "ငွေလွှဲအခြေအနေကို ရွေးချယ်ပါ",
  SelectStatus: "အခြေအနေကို ရွေးချယ်ပါ",
  SelectOTPType: "OTP အမျိုးအစားကို ရွေးချယ်ပါ",
  SelectMerchantName: "ကုန်သည်အမည်ကို ရွေးချယ်ပါ",
  SelectTransactionStatus: "ငွေလွှဲအခြေအနေကို ရွေးချယ်ပါ",
  SelectFrequency: "အကြိမ်နှုန်းကို ရွေးချယ်ပါ",
  SelectAccessChannel: "ဝင်ရောက်မှုချန်နယ်ကို ရွေးချယ်ပါ",
  AreyousureyouwanttodeletetheselectedRecords:
    "သင်သည် ရွေးချယ်ထားသော မှတ်တမ်းများကို ဖျက်မည်ဟု အတည်ပြုပါသလား",
  AllRecordssuccessfullydeleted:
    "အားလုံးသော မှတ်တမ်းများ အောင်မြင်စွာ ဖျက်ခဲ့သည်",
  LoginPasswordForceExpiryDaysmustbeavalidnumberbetween1to30:
    "လော့ဂ်အင်စကားဝှက် ပိတ်ပင်ချိန် အချိန်သည် ၁ မှ ၃၀ အတွင်း တရားဝင်နံပါတ် ဖြစ်ရမည်။",

  IDTPAliasUpdateReport: "IDTP အမည်ပြောင်းလဲမှုအစီရင်ခံစာ",
  ExistingAlias: "ရှိနေသော အမည်",
  NewAlias: "အမည်အသစ်",
  SelectLanguage: "ဘာသာစကားကို ရွေးချယ်ပါ",
  AreyouSureyouwanttodeletethisrecord:
    "သင်သည် ဤမှတ်တမ်းကို ဖျက်မည်ဟု အတည်ပြုပါသလား?",
  Recordsuccessfullydeleted: "မှတ်တမ်းကို အောင်မြင်စွာ ဖျက်ခဲ့သည်",
  Pleasewaitdeletingrecord: "မှတ်တမ်းကို ဖျက်နေစဉ် ခန့်မှန်းပါ",
  NoRecordsFoundclicktheaddbuttontoaddone:
    "မှတ်တမ်း မတွေ့ပါ, တစ်ခု ထည့်ရန် ဖွင့်ပါခလုတ်ကို နှိပ်ပါ",
  Maximize: "အမြှုပ်တင်ပါ",
  EnterDefaultValue: "မူလတန်ဖိုးကို ထည့်ပါ",
  IsTotalWithoutCurrency: "စုစုပမာဏသည် ငွေကြေးမပါဘူးလား",
  IsTotalWithCurrency: "စုစုပမာဏသည် ငွေကြေးပါသလား",
  IsVisibleCurrencySymbol: "ငွေကြေးလက္ခဏာသည် မြင်သာပါသလား",
  IsCurrencyCode: "ငွေကြေးကုဒ် ဖြစ်ပါသလား",
  CurrencyReferenceColumn: "ငွေကြေး ရည်ညွှန်းကော်လံ",

  // Password Rotation
  PasswordRotation: "စကားဝှက်လှည်ပြောင်းခြင်း",
  CurrentPassword: "လက်ရှိစကားဝှက်",
  EnterCurrentPassword: "လက်ရှိစကားဝှက်ထည့်ပါ",
  EnterNewPassword: "အဆက်အသွယ်စကားဝှက်ထည့်ပါ",
  ConfirmNewPassword: "အသစ်စကားဝှက်ကို အတည်ပြုပါ",
  Enterconfirmnewpassword: "အသစ်စကားဝှက်ကို အတည်ပြုရန် ထည့်ပါ",
  CurrentPasswordisrequired: "လက်ရှိစကားဝှက်လိုအပ်သည်။",
  Thenewpasswordcannotbethesameastheoldpassword:
    "အသစ်စကားဝှက်သည် ယခင်စကားဝှက်နှင့် တူမဖြစ်ရ။",
  Confirmnewpasswordisrequired: "အသစ်စကားဝှက်ကို အတည်ပြုရန် လိုအပ်သည်။",
  NewPasswordandConfirmPassworddidnotmatched:
    "အသစ်စကားဝှက်နှင့် အတည်ပြုစကားဝှက် မတူသည်",
  Passwordsuccessfullychanged: "စကားဝှက်ကို အောင်မြင်စွာ ပြောင်းလဲခဲ့သည်။",
  //
  CardProductBin: "ကတ်ထုတ်ကုန် Bin",
  ModeofOperation: "လုပ်ဆောင်မှုပုံစံ",
  AccountStatus: "အကောင့်အခြေအနေ",

  // Push Notification Master
  PushNotificationMaster: "ပွင့်လင်းသတင်းဆက်ရာစီမံခန့်ခွဲမှု",
  UserType: "အသုံးပြုသူအမျိုးအစား",
  SelectUserType: "အသုံးပြုသူအမျိုးအစားကို ရွေးချယ်ပါ",
  ExecuteDate: "အကောင်အထည်ဖော်နေ့",
  EnterExecuteDate: "အကောင်အထည်ဖော်နေ့ ထည့်ပါ",
  SelectLoginID: "လော့ဂ်အင် ID ကို ရွေးချယ်ပါ",
  EnterCustomerName: "ဖောက်သည်အမည် ထည့်ပါ",
  EnterLastLoginDate: "နောက်ဆုံးလော့ဂ်အင်နေ့ ထည့်ပါ",
  PushNotificationMasterConfirmation:
    "ပွင့်လင်းသတင်းဆက်ရာစီမံခန့်ခွဲမှု အတည်ပြုချက်",

  // Push Notification Template Configuration
  PushNotificationTemplateConfiguration:
    "ပွင့်လင်းသတင်းဆက်ရာ Template ကုန်ကျစရိတ်",
  Subject: "ခေါင်းစဥ်",
  EnterSubject: "ခေါင်းစဥ်ထည့်ပါ",
  EnterTemplateName: "Template အမည် ထည့်ပါ",
  PushNotificationTemplateConfigurationPreview:
    "ပွင့်လင်းသတင်းဆက်ရာ Template ကုန်ကျစရိတ် ကြည့်ရှုခြင်း",
  EnterDeviceID: "ကိရိယာ ID ထည့်ပါ",
  Preview: "ကြည့်ရှုမှု",
  Test: "စမ်းသပ်မှု",
  PushNotificationTemplateConfirmation:
    "ပွင့်လင်းသတင်းဆက်ရာ Template အတည်ပြုချက်",
  FromAmountshouldbelessToAmount: "ထုတ်ပုံမှန်ပမာဏသည် အခြားပမာဏထက် သက်သာရမည်",

  Mobilenumbermustbe11digitslong: "မိုဘိုင်းနံပါတ်သည် ၁၁ အချက်အလက်ရှိရမည်",
  UserRestrictProcessing: "အသုံးပြုသူ ကန့်သတ်မှုလုပ်ငန်းစဉ်",
  PrimaryStatus: "မူလအခြေအနေ",
  CardID: "ကတ် ID",
  TapPayDetails: "Tap & Pay အကြောင်းအရာ",
  TapPay: "Tap & Pay",

  // IBMB Product

  LanguageReq: "ဘာသာစကား*",
  MessageReq: "သတင်းစကား*",
  EnterMessage: "သတင်းစကားထည့်ပါ",
  MessageNoteReq: "သတင်းမှတ်ချက်*",
  EnterMessageNote: "သတင်းမှတ်ချက်ထည့်ပါ",
  EnterMessageCode: "သတင်းကုဒ်ထည့်ပါ",
  LanguageisAlreadyenteredatLine:
    "ဘာသာစကားသည် စာကြောင်း {0} တွင် ယခင်မှာရှိခဲ့သည်",
  SelectCurrencyCode: "ငွေကြေးကုဒ်ကို ရွေးချယ်ပါ",
  DefaultNote: "မူလမှတ်ချက်",
  EnterDefaultNote: "မူလမှတ်ချက်ထည့်ပါ",

  CommonMessageTemplate: "ယေဘုယျ သတင်းစကား Template",
  Message: "သတင်းစကား",
  SelectMessage: "သတင်းစကားကို ရွေးချယ်ပါ",

  // Password Policy Configuration
  PasswordPolicyConfiguration: "စကားဝှက် မူဝါဒ စီမံခန့်ခွဲမှု",
  PasswordType: "စကားဝှက်အမျိုးအစား",
  MinimumLength: "အနည်းဆုံးအရှည်",
  MaximumLength: "အများဆုံးအရှည်",
  UpperCaseRequire: "အကြီးလုံးလိုအပ်သည်",
  LowerCaseRequire: "အနည်းငယ်လုံးလိုအပ်သည်",
  SpecialCharacterRequire: "အထူးလက္ခဏာလိုအပ်သည်",
  DigitsRequire: "ဂဏန်းလိုအပ်သည်",
  NoSpaces: "အချင်းချင်းမပါ",
  EnterPasswordType: "စကားဝှက်အမျိုးအစားထည့်ပါ",
  EnterMinimumLength: "အနည်းဆုံးအရှည်ထည့်ပါ",
  EnterMaximumLength: "အများဆုံးအရှည်ထည့်ပါ",
  NoofPreviousPasswordNotAllowed: "ယခင်စကားဝှက်များ ရရှိရန်မလိုအပ်",
  EnterNoofPreviousPasswordNotAllowed: "ယခင်စကားဝှက်များ ရရှိရန်မလိုအပ်ထည့်ပါ",
  MinimumUpperCase: "အနည်းဆုံး အကြီးလုံး",
  EnterMinimumUpperCase: "အနည်းဆုံး အကြီးလုံးထည့်ပါ",
  MinimumLowerCase: "အနည်းဆုံး အနည်းငယ်လုံး",
  EnterMinimumLowerCase: "အနည်းဆုံး အနည်းငယ်လုံးထည့်ပါ",
  MinimumDigits: "အနည်းဆုံး ဂဏန်း",
  EnterMinimumDigits: "အနည်းဆုံး ဂဏန်းထည့်ပါ",
  MinimumSpecialCharater: "အနည်းဆုံး အထူးလက္ခဏာ",
  EnterMinimumSpecialCharater: "အနည်းဆုံး အထူးလက္ခဏာထည့်ပါ",
  AllowedSpecialCharacter: "ခွင့်ပြုထားသော အထူးလက္ခဏာ",
  EnterAllowedSpecialCharacter: "ခွင့်ပြုထားသော အထူးလက္ခဏာထည့်ပါ",
  MinimumEnglishCharacter: "အနည်းဆုံး အင်္ဂလိပ်လက္ခဏာ",
  EnterMinimumEnglishCharacter: "အနည်းဆုံး အင်္ဂလိပ်လက္ခဏာထည့်ပါ",
  ExpireDays: "ပိတ်မိသော နေ့",
  EnterExpireDays: "ပိတ်မိသောနေ့ထည့်ပါ",
  AlertBeforeExpireDays: "ပိတ်မိမီ သတိပေးပါ",
  EnterAlertBeforeExpireDays: "ပိတ်မိမီ သတိပေးရန်နေ့ထည့်ပါ",
  Pleaseenteronlyspecialcharacters: "ကျေးဇူးပြု၍ အထူးလက္ခဏာများကိုသာ ထည့်ပါ",

  EnterAccountSource: "အကောင့် ရင်းမြစ် ထည့်ပါ",
  EnterAccountType: "အကောင့်အမျိုးအစား ထည့်ပါ",
  EditAllowed: "ပြင်ဆင်ရန် ခွင့်ပြုသည်",
  EnteraproperVersion: "သင့်လျော်သော ဗားရှင်းထည့်ပါ",
  SelectDefaultMessage: "မူရင်း Message ကို ရွေးပါ။",

  PrimaryCustomerID: "အဓိက ဖောက်သည် ID",
  SecurityQuestionMasterConfiguration:
    "လုံခြုံရေးမေးခွန်း မာစတာကွန်ဖီဂရေးရှင်း",
  SecurityQuestion: "လုံခြုံရေးမေးခွန်း",
  SecurityQuestionGroupCD: "လုံခြုံရေးမေးခွန်းအဖွဲ့",
  EnterSecurityQuestions: "လုံခြုံရေးမေးခွန်းများထည့်ပါ",
  SecurityQuestionConfirmation: "လုံခြုံရေးမေးခွန်းအတည်ပြုချက်",
  SecurityQuestionConfiguration: "လုံခြုံရေးမေးခွန်း ကွန်ဖီဂရေးရှင်း",
  AccountCustomerID: "အကောင့်ဖောက်သည် ID",
  AccountCardNo: "အကောင့်/ကတ်နံပါတ်",
  MakerRemarks: "ထုတ်လုပ်သူ မှတ်ချက်",

  SecurityQuestionConfigurationConfirmation:
    "လုံခြုံရေးမေးခွန်းပြင်ဆင်မှု အတည်ပြုချက်",
  Unknownerroroccured: "အမည်မသိ အမှားတစ်ခု ဖြစ်ပွားခဲ့သည်။",

  OtherBankMaster: "အခြားဘဏ်မာစတာ",
  OtherBranchMaster: "အခြားဌာနခွဲဆရာကြီး",
  OtherRegionMaster: "တခြားတိုင်း ဒေသကြီး ဆရာကြီး",

  // State Township MAster Configuration Screen

  StateTownshipMasterConfiguration: "ပြည်နယ် မြို့နယ် မာစတာ ကွန်ဖီဂျူရေးရှင်း",
  StateCode: "ပြည်နယ်ကုဒ်",
  EnterStateCode: "ပြည်နယ်ကုဒ်ထည့်ပါ",
  StateName: "ပြည်နယ်အမည်",
  EnterStateName: "ပြည်နယ်အမည်ထည့်ပါ",
  TownshipCode: "မြို့နယ်ကုဒ်",
  EnterTownshipCode: "မြို့နယ်ကုဒ်ထည့်ပါ",
  TownshipName: "မြို့နယ်အမည်",
  EnterTownshipName: "မြို့နယ်အမည်ထည့်ပါ",
  // Suspense Account Template Configuration

  SuspenseAccountTemplateConfiguration:
    "ဆိုင်းထားသော အကောင့်ပုံစံပုံစံ ဖွဲ့စည်းမှု",
  SuspenseAccountTemplateConfirmation:
    "ဆိုင်းထားသော အကောင့်ပုံစံပုံစံ အတည်ပြုချက်",
  TransactionRemark1: "ငွေပေးငွေယူ မှတ်ချက် ၁",
  EnterTransactionRemark1: "ဝင်ပါ။ ငွေပေးငွေယူ မှတ်ချက် ၁",
  TransactionRemark2: "ငွေပေးငွေယူ မှတ်ချက် ၂",
  EnterTransactionRemark2: "ဝင်ပါ။ ငွေပေးငွေယူ မှတ်ချက် ၂",
  AccountTypereq: "အကောင့် အမျိုးအစား*",
  AccountTypeisAlreadyenteredatLine:
    "အကောင့်အမျိုးအစားကို Line {0} တွင် ထည့်သွင်းပြီးဖြစ်သည်။",
  // Currency Limit Template Configuration

  CurrencyLimitTemplateConfiguration: "ငွေကြေးကန့်သတ် Template ပုံစံဖွဲ့စည်း",
  CurrencyLimitTemplateConfirmation: "ငွေကြေးကန့်သတ် နမူနာပုံစံ အတည်ပြုခြင်း။",
  DailyAmount: "နေ့စဉ်ပမာဏ",
  WeeklyAmount: "အပတ်စဉ်ပမာဏ",
  MonthlyAmount: "လစဉ်ပမာဏ",
  MaximumDailyCount: "နေ့စဉ်အများဆုံး အရေအတွက်",
  MaximumWeeklyCount: "အပတ်စဉ်အများဆုံး အရေအတွက်",
  MaximumMonthlyCount: "လစဉ်အများဆုံး အရေအတွက်",
  CurrencyCodeReq: "ငွေကြေးကုဒ်*",
  EnterOrderBy: "မှာယူမှုအလိုက် ထည့်သွင်းပါ။",

  CurrencyReq: "ငွေကြေး*",
  SelectCurrency: "ငွေကြေးကိုရွေးချယ်ပါ",
  EitherChargeAmountOrChargePercentageIsRequired:
    "ငွေချေးပမာဏ သို့မဟုတ် ငွေချေးရာခွင့် ရာခိုင်နှုန်း တစ်ခုခုလိုအပ်သည်",

  //Account Wise ChargeAccountSpecificChargeTemplate Template setting
  AccountSpecificChargeTemplate: "အကောင့်အသီးသီးအတွက် ချိန်ညှိမှုပုံစံ",
  ServiceChargeTemplateReq: "ဝန်ဆောင်ခပုံစံ*",
  AccountClassificationReq: "အကောင့်အမျိုးအစား*",
  AcParameterMappingTemplateReq: "အကောင့် ပရာမီတာ မပ်ပင်ပုံစံ*",
  AccountSpecificChargeTemplateConfirmation:
    "အကောင့်အသီးသီးအတွက် ချိန်ညှိမှုပုံစံအတည်ပြုမှု",
  AccountSourceNumber: "အကောင့်/အရင်းအမြစ် နံပါတ်",
  ThisCurrencyAlreadyExists: "ဤငွေကြေးသည် ရှိပြီးသားဖြစ်သည်",
  AccountParametersMappingTemplate: "အကောင့်ပရာမီတာ မပ်ပင်ပုံစံ",
  FromSourceKeyValueConfigMapping:
    "အရင်းအမြစ်အတိုင်းကီးနှင့်တန်ဖိုးပုံစံချိန်ညှိမှု",
  AcParameterMappingTemplate: "အကောင့် ပရာမီတာ မပ်ပင်ပုံစံ",
  ConfigurationType: "ဖွဲ့စည်းမှုအမျိုးအစား",
  PresetAmountConfiguration: "ကြိုတင်သတ်မှတ်ထားသောငွေပမာဏ ဖွဲ့စည်းမှု",
  TemplateCode: "ပုံစံကုဒ်",

  LimitTemplateReq: "ကန့်သတ်မှုနမူနာ*",
  LimitTemplate: "ကန့်သတ်မှုနမူနာ",
  SelectLimitTemplate: "ကန့်သတ်မှုနမူနာကို ရွေးချယ်ပါ",
  AccountTemplate: "အကောင့်နမူနာ",
  SelectAccountTemplate: "အကောင့်နမူနာကို ရွေးချယ်ပါ",
  GloballimitTemplate: "ကမ္ဘာလုံးဆိုင်ရာ ကန့်သတ်မှုနမူနာ",
  SelectGloballimitTemplate: "ကမ္ဘာလုံးဆိုင်ရာ ကန့်သတ်မှုနမူနာကို ရွေးချယ်ပါ",

  ProfileTemplate: "ကိုယ်ရေးအကျဉ်း နမူနာပုံစံ",
  ProfileTemplateConfirmation: "ကိုယ်ရေးအကျဉ်း နမူနာပုံစံ အတည်ပြုချက်",
  // service master
  ServiceMaster: "ဝန်ဆောင်မှုမဟာမိတ်",
  ServiceMasterConfirmation: "ဝန်ဆောင်မှုမဟာမိတ်အတည်ပြုချက်",
  SuspenseAccountDetails: "အတိတ်မှတ်စာရင်းအချက်အလက်",
  ChargeAllow: "ချက်ချက်ခွင့်ပြုပါ",
  SuspenseAccountTemplate: "အတိတ်မှတ်စာရင်းနမူနာ",
  SelectSuspenseAccountTemplate: "အတိတ်မှတ်စာရင်းနမူနာကိုရွေးချယ်ပါ",
  AccountSourceReq: "အကောင့် အရင်းအမြစ်*",

  // Wallet Master
  WalletMaster: "ပိုက်ဆံအိတ် မာစတာ",
  WalletMasterConfirmation: "ပိုက်ဆံအိတ် မာစတာ အတည်ပြုမှု",
  WalletType: "ပိုက်ဆံအိတ် အမျိုးအစား",
  EnterWalletType: "ပိုက်ဆံအိတ် အမျိုးအစား ရိုက်ထည့်ပါ",
  WalletName: "ပိုက်ဆံအိတ် နာမည်",
  EnterWalletName: "ပိုက်ဆံအိတ် နာမည် ရိုက်ထည့်ပါ",
  WalletIDValidateRegex:
    "ပိုက်ဆံအိတ် အိုင်ဒီ သတ်မှတ်ချက် ချမှတ်ရန် ပုံမှန်အသုံးအနှုန်းများ",
  EnterWalletIDValidateRegex:
    "ပိုက်ဆံအိတ် အိုင်ဒီ သတ်မှတ်ချက် ပုံမှန်အသုံးအနှုန်းများ ရိုက်ထည့်ပါ",
  WalletIDRegExpNotaValid:
    "ပိုက်ဆံအိတ် မာစတာ ပုံမှန်အသုံးအနှုန်းများ သည် အကျုံးဝင်မည်မဟုတ်ပါ။",

  Areyousureyouwanttoupdatetheprofiletemplateforthisuser:
    "ဤအသုံးပြုသူအတွက် ပရိုဖိုင်ပုံစံကို အပ်ဒိတ်လုပ်ရန် သေချာပါသလား။",

  Theholidaydatemustbebetweenthestartdateandenddate:
    "အားလပ်ရက်ရက်စွဲသည် စတင်ရက်စွဲနှင့် ကုန်ဆုံးရက်ကြားတွင် ဖြစ်ရမည်။",
  SelectCardType: "ကတ်အမျိုးအစားကို ရွေးပါ။",
  CardStatusisAlreadyenteredatLine:
    "কার্ডের স্থিতি ইতিমধ্যে লাইন {0} এ প্রবেশ করানো হয়েছে",
  CardCategory: "ကတ် အမျိုးအစား",
  CardApplyConfirmation: "ကတ်လျှောက်လွှာအတည်ပြုချက်",
  ProofType: "အထောက်အထားအမျိုးအစား",
  ProofValue: "အထောက်အထားတန်ဖိုး",
  CardApplyDetails: "ကတ်လျှောက်လွှာအသေးစိတ်",
  ClicktoViewFullImage: "ပုံအပြည့်အစုံကြည့်ရန် နှိပ်ပါ။",
  DoubleClicktoCloseImage: "ပုံပိတ်ရန် နှစ်ချက်နှိပ်ပါ။",
  RequestDetail: "အသေးစိတ်ကို တောင်းဆိုပါ။",
  //check
  AppAnnualExpense: "နှစ်စဉ်ကျသင့်ငွေကို လျှောက်ထားပါ",
  EnterAppAnnualExpense: "နှစ်စဉ်ကျသင့်ငွေကို ရိုက်ထည့်ပါ",
  AppAnnualIncome: "နှစ်စဉ်ဝင်ငွေကို လျှောက်ထားပါ",
  EnterAppAnnualIncome: "နှစ်စဉ်ဝင်ငွေကို ရိုက်ထည့်ပါ",
  AppCompanyName: "ကုမ္ပဏီအမည်ကို လျှောက်ထားပါ",
  EnterAppCompanyName: "ကုမ္ပဏီအမည်ကို ရိုက်ထည့်ပါ",
  AppPosition: "ရာထူးကို လျှောက်ထားပါ",
  EnterAppPosition: "ရာထူးကို ရိုက်ထည့်ပါ",
  EnterCardCategory: "ကတ်အမျိုးအစားကို ရိုက်ထည့်ပါ",

  CredentialsResetRequestHistoryReport:
    "အထောက်အထားများ ပြန်လည်သတ်မှတ်ရန် တောင်းဆိုမှု မှတ်တမ်းအစီရင်ခံစာ",
  AuthenticationFlow: "အထောက်အထားစိစစ်ခြင်း စီးဆင်းမှု",
  BankRegion: "ဘဏ်တိုင်းဒေသကြီး",
  MobileAccountLinkReport: "မိုဘိုင်းအကောင့်လင့်ခ်အစီရင်ခံစာ",
  ActionFlag: "လုပ်ဆောင်ချက်အလံ",
  TRFType: "TRF အမျိုးအစား",
  WalletTopUpDetails: "ပိုက်ဆံအိတ်ငွေဖြည့်အသေးစိတ်",
  ToWalletId: "သို့ ပိုက်ဆံအိတ် ID",
  ToWalletNM: "သို့ ပိုက်ဆံအိတ် အမည်",
  OtherBankFundTransferDetails: "အခြားဘဏ်ရန်ပုံငွေလွှဲပြောင်းမှုအသေးစိတ်",
  NRCFundTransferDetails: "NRC ရန်ပုံငွေလွှဲပြောင်းမှုအသေးစိတ်",
  CreditCardPaymentDetails: "အကြွေးဝယ်ကတ် ငွေပေးချေမှုအသေးစိတ်",
  RecipientMobileNo: "လက်ခံသူ မိုဘိုင်းနံပါတ်",
  FormAccountNo: "အကောင့်နံပါတ်မှ",
  CardResetPinReport: "ကတ်ကို ပြန်လည်သတ်မှတ်ရန် ပင်နံပါတ် အစီရင်ခံစာ",
  PinChangeReason: "ပင်ထိုးပြောင်းခြင်း။ အကြောင်းပြချက်",
  CardApplicationDetails: "ကတ်လျှောက်လွှာအသေးစိတ်",
  PartyDetails: "ပါတီအသေးစိတ်",
  BlockUnblockCardPinDetails:
    "ကတ်ပင် ပင်အသေးစိတ်အချက်အလက်များကို ပိတ်ဆို့/ပိတ်ခြင်း",
  CardActivationDetails: "ကတ်အသက်သွင်းခြင်းအသေးစိတ်",

  InActiveDate: "အလုပ်မလုပ်သည့်ရက်",
  TransactionAllowed: "ငွေကြေးလုပ်ဆောင်ချက် ခွင့်ပြုသည်",
  selectTransactionAllowed: "ငွေကြေးလုပ်ဆောင်ချက် ခွင့်ပြုမှုကို ရွေးချယ်ပါ",
  Mobilenumbermustbe9digitslong: "မိုဘိုင်းနံပါတ်သည် ၉ လုံးရှည် လိုအပ်ပါသည်",
  Mobilenumbermustbe7digitslong: "မိုဘိုင်းနံပါတ်သည် ၇ လုံးရှည် လိုအပ်ပါသည်",
  SearchServiceName: "ဝန်ဆောင်မှုအမည်ကိုရှာဖွေပါ။",
  AppliedLimits: "အသုံးချကန့်သတ်ချက်များ",
  EnterAccountCardNumber: "အကောင့်/ကတ်နံပါတ် ထည့်ပါ။",
  EnterAccountCustomerID: "အကောင့်ဖောက်သည် ID ကိုထည့်ပါ။",

  CardProductMaster: "ကတ်ထုတ်ကုန်မန်နေဂျာ",
  CardProductMasterConfirmation: "ကတ်ထုတ်ကုန်မန်နေဂျာအတည်ပြု",
  StatementType: "ထုတ်ပြန်ချက်အမျိုးအစား",
  SentStatus: "ပေးပို့ထားသော အခြေအနေ",
  AccountStatementReport: "အကောင့်ထုတ်ပြန်ချက်အစီရင်ခံစာ",
  ChargeAmount: "ကောက်ခံသည့်ပမာဏ",
  ToSourceFlag: "အရင်းအမြစ်သို့အလံ",

  ServiceUnavailableAction: "ဝန်ဆောင်မှု မရရှိနိုင်သော လုပ်ဆောင်ချက်",
  SelectServiceUnavailableAction:
    "ဝန်ဆောင်မှု မရရှိနိုင်သော လုပ်ဆောင်ချက်ကို ရွေးချယ်ပါ",
  ServiceUnavailableActionReq: "ဝန်ဆောင်မှု မရရှိနိုင်သော လုပ်ဆောင်ချက်*",
  AllowAccess: "ဝင်ရောက်ခွင့်ပေးပါ",
  ProfileReq: "ပရိုဖိုင်*",
  SelectProfile: "ပရိုဖိုင်ကို ရွေးချယ်ပါ",
  ThisChannelalreadyexists: "ဤချန်နယ်သည်ရှိပြီးသားဖြစ်သည်",
  ThisProfilealreadyexists: "ဤပရိုဖိုင်သည်ရှိပြီးသားဖြစ်သည်",
  BranchMasterConfirmation: "ရှေ့ဆောင်မစ္စတာ အတည်ပြုမှု",
  FromSourceKeyValueConfigurationConfirmation:
    "အရင်းအမြစ် သော့တန်ဖိုး ဖွဲ့စည်းမှု အတည်ပြုမှု",
  FromSourceKeyValueConfirmation: "အရင်းအမြစ် သော့တန်ဖိုး အတည်ပြုမှု",

  IntraFundTransferDetails: "အတွင်းငွေငွေလွှဲငွေပေးချေမှုအသေးစိတ်",
  ErrorCode: "အမှားကုဒ်",
  ToAccountCardNo: "သို့ အကောင့်/ကတ်နံပါတ်",
  CardApplicationPartiesDetails: "ကတ်လျှောက်ထားမှုပါတီများ၏အသေးစိတ်အချက်အလက်",
  FromAccountBalance: "အကောင့်လက်ကျန်ငွေ",
  RetryCount: "ပြန်လည်ကြိုးစားမှုအကြိမ်ရေ",
  CallResponse: "ခေါ်ဆိုမှုတုံ့ပြန်မှု",
  ReferenceID: "ကိုးကားအိုင်ဒီ",
  RefereneceDate: "ကိုးကားရက်စွဲ",
  BatchID: "အစုအိုင်ဒီ",
  APIStatus: "API အခြေအနေ",
  APIExecutionTime: "API ဆောင်ရွက်ချိန်",
  ChannelLimit: "ချန်နယ်ကန့်သတ်",
  ChannelLimitConfiguration: "ချန်နယ်ကန့်သတ်ဖွဲ့စည်းမှု",
  ChannelLimitConfirmation: "ချန်နယ်ကန့်သတ်အတည်ပြုမှု",
  TransactionAllowedReq: "ငွေကြေးလုပ်ဆောင်ချက် ခွင့်ပြုသည်*",

  BranchServiceStatusTitle: "ဘဏ်ဝန်ဆောင်မှုအခြေအနေ ပြင်ဆင်မှု",
  BranchServiceStatusCountNote: "ရွေးချယ်ထားသောဘဏ်: ",
  BranchServiceStatusNote:
    "မှတ်ချက်: ရွေးချယ်ထားသောဘဏ်များတွင် ဝန်ဆောင်မှုနှင့်အခြေအနေကို အားလုံးအတွက် ပြင်ဆင်ရန် ရွေးချယ်ပါ။",
  BranchServiceStatusUpdateMsg:
    "သင် {0} ဝန်ဆောင်မှုကို {1} ရွေးချယ်ထားသောဘဏ်အားလုံးတွင် ပြင်ဆင်လိုကြောင်း သေချာပါသလား?",
  Specialcharactersandspacesarenotallowed:
    "Special characters and spaces are not allowed",

  ResetFlag: "ပြန်လည်သတ်မှတ်သည့်အလံ",
  DeviceUsername: "စက်၏အသုံးပြုသူအမည်",
  AccountCardType: "အကောင့်/ကတ်အမျိုးအစား",
  LastScheduledDate: "နောက်ဆုံးအစီအစဉ်ထားသည့်နေ့",
};
